/* Pokémon navigation projection, verified against the live Finder payload and
   da-finder-flow.js on 5 October 2026. Finder compatibility data remains untouched.
   Both Quick Match and menu grouping consume this one navigation structure. */
window.DisplayArmourPokemonTaxonomy = Object.freeze([
  {
    "key": "cards",
    "label": "Single Cards & Protection",
    "handles": [
      "pokemon-single-card-acrylic-case",
      "trading-card-protective-sleeve",
      "trading-card-toploader"
    ]
  },
  {
    "key": "graded",
    "label": "Graded Cards & Slab Protection",
    "handles": [
      "psa-graded-card-acrylic-case",
      "bgs-graded-card-acrylic-case",
      "psa-graded-card-bumper-guard",
      "psa-multi-colour-bumper-guard",
      "psa-bumper-guard-with-plate",
      "graded-card-bumper-guard-with-plate"
    ]
  },
  {
    "key": "packs",
    "label": "Booster Packs & Bundles",
    "handles": [
      "pokemon-single-booster-pack-acrylic-display-case",
      "pokemon-sleeved-booster-pack-acrylic-display-case",
      "pokemon-booster-pack-acrylic-display-case-3-slot",
      "pokemon-pre-2026-booster-bundle-case",
      "pokemon-booster-bundle-case",
      "pokemon-10-booster-bundle-display-case"
    ]
  },
  {
    "key": "boxes",
    "label": "Booster Boxes",
    "handles": [
      "pokemon-booster-box-acrylic-display-case",
      "pokemon-half-booster-box-acrylic-display-case",
      "pokemon-japanese-10-pack-booster-box-case",
      "pokemon-japanese-30-pack-booster-box-case",
      "pokemon-6-booster-box-display-case"
    ]
  },
  {
    "key": "etbs",
    "label": "Elite Trainer Boxes",
    "handles": [
      "pokemon-etb-acrylic-display-case",
      "pokemon-etb-plus-case",
      "pokemon-center-etb-acrylic-display-case"
    ]
  },
  {
    "key": "special",
    "label": "UPC, Special Boxes & Tins",
    "handles": [
      "pokemon-moltres-upc-case",
      "pokemon-charizard-upc-case",
      "pokemon-151-upc-case",
      "pokemon-mega-upc-case",
      "pokemon-prismatic-evolutions-spc-case",
      "pokemon-tohoku-box-case",
      "pokemon-mini-tin-acrylic-display-case",
      "pokemon-tin-acrylic-display-case"
    ]
  },
  {
    "key": "storage",
    "label": "Displays, Dispensers & Storage",
    "handles": [
      "pokemon-3-slot-booster-pack-dispenser",
      "pokemon-6-slot-booster-pack-dispenser",
      "9-pocket-trading-card-binder",
      "12-pocket-trading-card-binder",
      "large-9-pocket-trading-card-binder",
      "pokemon-acrylic-card-desktop-display-frame-3-grid",
      "pokemon-acrylic-card-desktop-display-frame-6-grid",
      "pokemon-acrylic-card-desktop-display-frame-9-grid",
      "psa-3-slab-acrylic-display"
    ]
  }
].map(function (group) {
  Object.freeze(group.handles);
  return Object.freeze(group);
}));
window.DisplayArmourGroupPokemonMenu = function (group) {
  var list = group && group.querySelector(':scope > .gm-links');
  if (!list) return;
  var heading = list.querySelector(':scope > .gm-heading');
  var title = (heading && heading.textContent || '').toLowerCase().replace(/pokémon/g, 'pokemon').trim();
  if (!/^pokemon(?: displays| cases)?$/.test(title)) return;
  // Keep existing hrefs verbatim, including the established booster-box redirect.
  function handleFor(link) {
    var path = new URL(link.getAttribute('href'), location.href).pathname;
    return path === '/products/pokemon-booster-box-acrylic-display-case-moc'
      ? 'pokemon-booster-box-acrylic-display-case' : path.split('/').pop();
  }
  list.style.removeProperty('display');
  list.style.removeProperty('grid-template-columns');
  list.style.removeProperty('gap');
  if (group.dataset.daPokemonGrouped !== 'true') {
    var rows = Array.prototype.slice.call(list.querySelectorAll(':scope > .gm-item:not(.gm-heading)'));
    window.DisplayArmourPokemonTaxonomy.forEach(function (category) {
      var matched = category.handles.map(function (handle) {
        return rows.find(function (row) {
          var link = row.querySelector(':scope > a.gm-target[href]');
          return link && handleFor(link) === handle;
        });
      }).filter(Boolean);
      if (!matched.length) return;
      var section = document.createElement('li');
      var label = document.createElement('h4');
      var links = document.createElement('ul');
      section.className = 'da-pokemon-directory__category';
      section.dataset.pokemonCategory = category.key;
      label.className = 'da-pokemon-directory__heading';
      label.textContent = category.label;
      links.className = 'gm-links da-pokemon-directory__links';
      links.setAttribute('aria-label', category.label);
      matched.forEach(function (row) { links.appendChild(row); });
      section.appendChild(label);
      section.appendChild(links);
      list.appendChild(section);
    });
    // Unrecognised future rows stay available; no guessed category or destination.
    group.dataset.daPokemonGrouped = 'true';
    group.classList.add('da-pokemon-directory');
    list.classList.add('da-pokemon-directory__groups');
  }
  list.querySelectorAll('.gm-target .gm-text, .gm-target .gm-label').forEach(function (text) {
    text.style.removeProperty('white-space');
  });
};
document.dispatchEvent(new Event('da:pokemon-taxonomy-ready'));

/* One strip and one Markets form. Preserve the old mobile sticky boundary by
   placing that same node before the header section below the existing 1470px
   desktop breakpoint. The node is never cloned or initialized a second time. */
if (!window.__DA_UNIFIED_HEADER_PLACEMENT__) {
  window.__DA_UNIFIED_HEADER_PLACEMENT__ = true;
  (function () {
    var desktop = window.matchMedia('(min-width: 1470px)');
    var entries = new Map();
    function place(entry) {
      var destination = desktop.matches ? entry.header : entry.home;
      if (entry.utility.parentNode !== destination) destination.prepend(entry.utility);
      if (desktop.matches) entry.home.remove();
      else if (entry.home.nextSibling !== entry.section) entry.section.before(entry.home);
      document.documentElement.style.setProperty('--header-height', entry.section.offsetHeight + 'px');
    }
    function initialise(scope) {
      var headers = Array.from(scope.querySelectorAll('.da-header-unified'));
      if (scope.matches && scope.matches('.da-header-unified')) headers.unshift(scope);
      headers.forEach(function (header) {
        if (entries.has(header)) return;
        var utility = header.querySelector('[data-da-header-utility]');
        var section = header.closest('.section-header');
        if (!utility || !section) return;
        var home = document.createElement('div');
        home.className = 'da-header-utility-home da-armour-os-strip-section';
        var entry = {header: header, utility: utility, section: section, home: home};
        entries.set(header, entry);
        place(entry);
      });
    }
    function update() {
      entries.forEach(function (entry) { if (entry.section.isConnected) place(entry); });
    }
    desktop.addEventListener('change', update);
    document.addEventListener('shopify:section:reorder', update);
    document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      entries.forEach(function (entry, header) {
        if (event.target === entry.section || event.target.contains(entry.section)) {
          entry.home.remove();
          entries.delete(header);
        }
      });
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initialise(document); }, {once: true});
    } else initialise(document);
  })();
}

/* One delivery/localization runtime, moved from the old section. */
if (!window.__DA_UNIFIED_UTILITY_RUNTIME__) {
window.__DA_UNIFIED_UTILITY_RUNTIME__ = true;

                document.querySelectorAll('[data-country-flag]:empty').forEach(function (flag) {
                  flag.textContent = Array.from(flag.dataset.countryFlag.toUpperCase())
                    .map(function (character) {
                      return String.fromCodePoint(127397 + character.charCodeAt(0));
                    })
                    .join('');
                });
              

(function(){


  function getUKParts(){

    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });

    const parts = formatter.formatToParts(new Date());
    const data = {};

    parts.forEach(function(part){
      data[part.type] = part.value;
    });

    return {
      year:Number(data.year),
      month:Number(data.month),
      day:Number(data.day),
      hour:Number(data.hour),
      minute:Number(data.minute),
      second:Number(data.second)
    };
  }

  function isWeekend(date){
    const day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addWorkingDays(date,days){

    const result = new Date(date.getTime());
    let added = 0;

    while(added < days){
      result.setUTCDate(result.getUTCDate() + 1);

      if(!isWeekend(result)){
        added++;
      }
    }

    return result;
  }

  function getDayName(date){

    return new Intl.DateTimeFormat("en-GB", {
      weekday:"long",
      timeZone:"UTC"
    }).format(date);
  }

  function updateDispatchTimer(){
    const timer = document.getElementById("da-dispatch-timer");
    if(!timer) return;

    const uk = getUKParts();

    const ukNow = Date.UTC(
      uk.year,
      uk.month - 1,
      uk.day,
      uk.hour,
      uk.minute,
      uk.second
    );

    let cutoff = Date.UTC(
      uk.year,
      uk.month - 1,
      uk.day,
      14,
      0,
      0
    );

    let dispatchDate = new Date(
      Date.UTC(
        uk.year,
        uk.month - 1,
        uk.day
      )
    );

    /*
      If today's 2pm cutoff has passed,
      move to the next dispatch day.
    */
    if(ukNow >= cutoff){
      cutoff += 86400000;

      dispatchDate.setUTCDate(
        dispatchDate.getUTCDate() + 1
      );
    }

    /*
      Skip weekends.
    */
    while(isWeekend(dispatchDate)){
      dispatchDate.setUTCDate(
        dispatchDate.getUTCDate() + 1
      );

      cutoff += 86400000;
    }

    const deliveryDate = addWorkingDays(
      dispatchDate,
      2
    );

    const deliveryDay = getDayName(
      deliveryDate
    );

    timer.innerHTML =
      `Order Today → Delivery <a class="da-delivery-link" href="/pages/delivery-and-shipping-information">${deliveryDay}</a>`;
  }

  document.addEventListener("shopify:section:load", updateDispatchTimer);
  updateDispatchTimer();

  /*
    Refresh once per minute.
    No need for a 1-second interval anymore.
  */
  setInterval(
    updateDispatchTimer,
    60000
  );

})();


(function(){
  var popularCountryCodes = ['GB', 'US'];
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var pinIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.5 6-11a6 6 0 1 0-12 0c0 5.5 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/></svg>';
  var globeIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.3 2.5 3.5 5.5 3.5 9S14.3 18.5 12 21M12 3C9.7 5.5 8.5 8.5 8.5 12s1.2 6.5 3.5 9"/></svg>';

  function createHeading(modifier, icon, label){
    var heading = document.createElement('li');
    heading.className = 'country-list-heading country-list-heading--' + modifier;
    heading.innerHTML =
      '<span aria-hidden="true">' + icon + '</span> ' + label;
    return heading;
  }

  function groupMobileCountrySelectors(){
    if(!mobileQuery.matches) return;

    document.querySelectorAll('.country-selector__list').forEach(function(list){
      /*
       * The delivery strip's own selector is already grouped in Liquid.
       * Only update the separate selector Shopify displays on mobile.
       */
      if(list.closest('.da-dispatch-localization')) return;
      if(list.dataset.daMobileGrouped === 'true') return;

      var countryItems = Array.from(
        list.querySelectorAll('.disclosure__item')
      );

      if(!countryItems.length) return;

      var itemsByCode = new Map();

      countryItems.forEach(function(item){
        var link = item.querySelector('[data-value]');
        if(!link) return;

        var code = String(link.dataset.value || '').toUpperCase();

        if(!code) return;

        if(itemsByCode.has(code)){
          item.remove();
          return;
        }

        itemsByCode.set(code, item);
        item.remove();
      });

      var popularList = list.querySelector('ul.popular-countries');
      var allCountriesList = list.querySelector('ul.countries');

      if(!popularList){
        popularList = document.createElement('ul');
        popularList.className = 'list-unstyled popular-countries';
        popularList.setAttribute('role', 'list');
      }

      if(!allCountriesList){
        allCountriesList = document.createElement('ul');
        allCountriesList.className = 'list-unstyled countries';
        allCountriesList.setAttribute('role', 'list');
      }

      popularList
        .querySelectorAll('.country-list-heading')
        .forEach(function(heading){ heading.remove(); });

      allCountriesList
        .querySelectorAll('.country-list-heading')
        .forEach(function(heading){ heading.remove(); });

      popularList.prepend(
        createHeading('popular', pinIcon, 'Popular Countries')
      );

      popularCountryCodes.forEach(function(code){
        var item = itemsByCode.get(code);

        if(item){
          popularList.appendChild(item);
          itemsByCode.delete(code);
        }
      });

      allCountriesList.appendChild(
        createHeading('all', globeIcon, 'All Countries')
      );

      Array.from(itemsByCode.entries())
        .sort(function(a, b){
          var aName = a[1].querySelector('.country');
          var bName = b[1].querySelector('.country');

          return String(aName ? aName.textContent : a[0])
            .trim()
            .localeCompare(
              String(bName ? bName.textContent : b[0]).trim(),
              'en',
              { sensitivity:'base' }
            );
        })
        .forEach(function(entry){
          allCountriesList.appendChild(entry[1]);
        });

      if(popularList.parentNode !== list){
        list.insertBefore(popularList, allCountriesList);
      }

      if(allCountriesList.parentNode !== list){
        list.appendChild(allCountriesList);
      }

      list.dataset.daMobileGrouped = 'true';
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener(
      'DOMContentLoaded',
      groupMobileCountrySelectors,
      { once:true }
    );
  }else{
    groupMobileCountrySelectors();
  }

  document.addEventListener('click', function(event){
    if(event.target.closest('.localization-form__select')){
      window.setTimeout(groupMobileCountrySelectors, 0);
    }
  });

  if(typeof mobileQuery.addEventListener === 'function'){
    mobileQuery.addEventListener('change', groupMobileCountrySelectors);
  }

  new MutationObserver(function(mutations){
    var shouldRefresh = mutations.some(function(mutation){
      return Array.from(mutation.addedNodes).some(function(node){
        return node.nodeType === 1 &&
          (
            node.matches?.('.country-selector__list') ||
            node.querySelector?.('.country-selector__list')
          );
      });
    });

    if(shouldRefresh){
      groupMobileCountrySelectors();
    }
  }).observe(document.documentElement, {
    childList:true,
    subtree:true
  });
})();


(function(){
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function openRegionPanels(){
    return Array.from(document.querySelectorAll('.da-dispatch-localization .disclosure__list-wrapper.country-selector:not([hidden])'));
  }

  function syncRegionViewport(){
    var panels = Array.from(document.querySelectorAll('.da-dispatch-localization .disclosure__list-wrapper.country-selector'));

    if(!mobileQuery.matches){
      panels.forEach(function(panel){
        panel.style.removeProperty('--da-region-visual-height');
      });
      return;
    }

    var openPanels = openRegionPanels();
    if(!openPanels.length) return;

    var viewportHeight = window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;

    openPanels.forEach(function(panel){
      panel.style.setProperty('--da-region-visual-height',Math.round(viewportHeight) + 'px');
    });
  }

  function syncRegionState(){
    var isOpen = mobileQuery.matches && openRegionPanels().length > 0;
    document.body.classList.toggle('da-region-panel-open',isOpen);
    if(isOpen) window.requestAnimationFrame(syncRegionViewport);
  }

  document.addEventListener('click', function(event){
    var countryLink = event.target.closest('.da-dispatch-localization .disclosure__link[data-value]');
    if(countryLink){
      var panel = countryLink.closest('.disclosure__list-wrapper.country-selector');
      countryLink.classList.add('is-selected');
      if(panel){
        panel.classList.remove('is-committing');
        void panel.offsetWidth;
        panel.classList.add('is-committing');
        window.setTimeout(function(){panel.classList.remove('is-committing')},500);
      }
    }

    if(event.target.closest('.da-dispatch-localization .localization-form__select, .da-dispatch-localization .country-selector__close-button, .da-dispatch-localization .country-selector__overlay')){
      window.setTimeout(syncRegionState,0);
    }
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key === 'Escape') window.setTimeout(syncRegionState,0);
  });

  new MutationObserver(function(mutations){
    if(mutations.some(function(mutation){return mutation.type === 'attributes' && mutation.attributeName === 'hidden'})) syncRegionState();
  }).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['hidden']});

  if(typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change',syncRegionState);
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',syncRegionViewport,{passive:true});
    window.visualViewport.addEventListener('scroll',syncRegionViewport,{passive:true});
  }else{
    window.addEventListener('resize',syncRegionViewport,{passive:true});
  }
  window.addEventListener('orientationchange',function(){window.setTimeout(syncRegionViewport,0)},{passive:true});
  document.addEventListener('shopify:section:load',syncRegionState);
  syncRegionState();
})();

}

/* Display Armour header GRID system — extracted from the approved header. */
window.DisplayArmourHeaderConfig = window.DisplayArmourHeaderConfig || {};
(function () {
  var configNode = document.querySelector('[data-da-header-config]');
  if (configNode) {
    window.DisplayArmourHeaderConfig.sectionId = configNode.getAttribute('data-section-id') || 'header';
  } else if (!window.DisplayArmourHeaderConfig.sectionId) {
    window.DisplayArmourHeaderConfig.sectionId = 'header';
  }
})();

if (!window.__DA_HEADER_GRID_BOOTSTRAPPED__) {
window.__DA_HEADER_GRID_BOOTSTRAPPED__ = true;

(function () {
var topLevelDisplaysSelector = [
  '.header .list-menu--inline > li > .header__menu-item',
  '.header .gm-menu:not(.gm-menu-mobile) > .gm-item.gm-level-0 > .gm-target'
].join(',');
function labelFor(item) {
  var label = item.querySelector(':scope > span, :scope > .gm-text, :scope > .gm-label');
  return (label ? label.textContent : item.textContent)
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}
function tagDisplaysItem(scope) {
  var found = false;
  (scope || document).querySelectorAll(topLevelDisplaysSelector).forEach(function (item) {
    if (labelFor(item) === 'displays') {
      item.classList.add('da-nav__displays');
      found = true;
    }
  });
  return found;
}
function initialiseDisplaysEmphasis(scope) {
  if (tagDisplaysItem(scope)) return;
  var observer = new MutationObserver(function () {
    if (tagDisplaysItem(document)) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 10000);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initialiseDisplaysEmphasis(document);
  }, { once: true });
} else {
  initialiseDisplaysEmphasis(document);
}
document.addEventListener('shopify:section:load', function (event) {
  initialiseDisplaysEmphasis(event.target);
});
var drawerBreakpoint = window.matchMedia('(max-width: 1469px)');
function updateDrawerScrollLock() {
  var drawer = document.getElementById('menu-drawer');
  var details = drawer && drawer.closest('details');
  var isOpen = Boolean(
    drawerBreakpoint.matches &&
    details &&
    (details.open || details.classList.contains('menu-opening'))
  );
  document.documentElement.classList.toggle('da-mobile-drawer-open', isOpen);
  document.body.classList.toggle('da-mobile-drawer-open', isOpen);
}
function initialiseDrawerScrollLock() {
  var drawer = document.getElementById('menu-drawer');
  var details = drawer && drawer.closest('details');
  if (!details) return;
  new MutationObserver(updateDrawerScrollLock).observe(details, {
    attributes: true,
    attributeFilter: ['open', 'class']
  });
  drawerBreakpoint.addEventListener('change', updateDrawerScrollLock);
  document.addEventListener('click', function () {
    window.setTimeout(updateDrawerScrollLock, 0);
  });
  updateDrawerScrollLock();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseDrawerScrollLock, { once: true });
} else {
  initialiseDrawerScrollLock();
}

/* Keep the mobile drawer's Region/Currency row connected to the upgraded
   selector supplied by the live delivery strip. Shopify renders a second,
   older localization disclosure inside the drawer; redirecting its trigger
   avoids maintaining two different selector interfaces and preserves the
   delivery strip's current Markets form, search and iOS scrolling behaviour. */
function redirectMobileDrawerRegionSelector(event) {
  if (!drawerBreakpoint.matches) return;

  var drawerTrigger = event.target.closest(
    '#menu-drawer localization-form .localization-form__select'
  );
  if (!drawerTrigger) return;

  var drawerForm = drawerTrigger.closest('form');
  if (!drawerForm || !drawerForm.querySelector('.country-selector')) return;

  var liveTrigger = document.querySelector(
    '.da-dispatch-strip .da-dispatch-localization localization-form .localization-form__select'
  );
  if (!liveTrigger || liveTrigger === drawerTrigger) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  var oldSelector = drawerForm.querySelector('.country-selector');
  if (oldSelector) oldSelector.hidden = true;
  drawerTrigger.setAttribute('aria-expanded', 'false');

  liveTrigger.click();
}
document.addEventListener('click', redirectMobileDrawerRegionSelector, true);
})();

(function () {
var DESKTOP_MENU = '.header .gm-menu:not(.gm-menu-mobile)';
var MOBILE_MENU = '#menu-drawer .gm-menu-mobile';
var observerQueued = false;
var MOBILE_ADDITIONAL_DISPLAY_DESTINATIONS = [
  { label: 'A-Team', url: '/collections/a-team-acrylic-display-cases', home: 'classic displays' },
  { label: 'Aliens', url: '/collections/aliens-acrylic-display-cases', home: 'modern displays' },
  { label: 'Space Jam', url: '/collections/space-jam-acrylic-display-cases', home: 'modern displays' }
];
var POKEMON_COLLECTION_URL = 'https://displayarmour.co.uk/collections/pokemon-acrylic-display-cases';
var POKEMON_RANGE_LINKS = [
  {
    "label": "Single Card Display",
    "url": "https://displayarmour.co.uk/products/pokemon-single-card-acrylic-case"
  },
  {
    "label": "Trading Card Sleeve",
    "url": "https://displayarmour.co.uk/products/trading-card-protective-sleeve"
  },
  {
    "label": "Trading Card Toploader",
    "url": "https://displayarmour.co.uk/products/trading-card-toploader"
  },
  {
    "label": "PSA Graded Card",
    "url": "https://displayarmour.co.uk/products/psa-graded-card-acrylic-case"
  },
  {
    "label": "BGS Graded Card",
    "url": "https://displayarmour.co.uk/products/bgs-graded-card-acrylic-case"
  },
  {
    "label": "PSA TPU Bumper Guard",
    "url": "https://displayarmour.co.uk/products/psa-graded-card-bumper-guard"
  },
  {
    "label": "PSA Multi-Colour TPU Bumper",
    "url": "https://displayarmour.co.uk/products/psa-multi-colour-bumper-guard"
  },
  {
    "label": "PSA TPU Bumper + Plate",
    "url": "https://displayarmour.co.uk/products/psa-bumper-guard-with-plate"
  },
  {
    "label": "Graded TPU Bumper + Plate",
    "url": "https://displayarmour.co.uk/products/graded-card-bumper-guard-with-plate"
  },
  {
    "label": "Single Booster Pack",
    "url": "https://displayarmour.co.uk/products/pokemon-single-booster-pack-acrylic-display-case"
  },
  {
    "label": "Sleeved Booster Pack",
    "url": "https://displayarmour.co.uk/products/pokemon-sleeved-booster-pack-acrylic-display-case"
  },
  {
    "label": "3-Pack Booster",
    "url": "https://displayarmour.co.uk/products/pokemon-booster-pack-acrylic-display-case-3-slot"
  },
  {
    "label": "Pre-2026 Booster Bundle",
    "url": "https://displayarmour.co.uk/products/pokemon-pre-2026-booster-bundle-case"
  },
  {
    "label": "Booster Bundle",
    "url": "https://displayarmour.co.uk/products/pokemon-booster-bundle-case"
  },
  {
    "label": "10 Booster Bundle Display",
    "url": "https://displayarmour.co.uk/products/pokemon-10-booster-bundle-display-case"
  },
  {
    "label": "English Booster Box",
    "url": "https://displayarmour.co.uk/products/pokemon-booster-box-acrylic-display-case"
  },
  {
    "label": "Half Booster Box",
    "url": "https://displayarmour.co.uk/products/pokemon-half-booster-box-acrylic-display-case"
  },
  {
    "label": "Japanese 10-Pack Booster Box",
    "url": "https://displayarmour.co.uk/products/pokemon-japanese-10-pack-booster-box-case"
  },
  {
    "label": "Japanese 30-Pack Booster Box",
    "url": "https://displayarmour.co.uk/products/pokemon-japanese-30-pack-booster-box-case"
  },
  {
    "label": "6 Booster Box Display",
    "url": "https://displayarmour.co.uk/products/pokemon-6-booster-box-display-case"
  },
  {
    "label": "ETB",
    "url": "https://displayarmour.co.uk/products/pokemon-etb-acrylic-display-case"
  },
  {
    "label": "ETB Plus",
    "url": "https://displayarmour.co.uk/products/pokemon-etb-plus-case"
  },
  {
    "label": "Pokémon Center ETB",
    "url": "https://displayarmour.co.uk/products/pokemon-center-etb-acrylic-display-case"
  },
  {
    "label": "Moltres UPC",
    "url": "https://displayarmour.co.uk/products/pokemon-moltres-upc-case"
  },
  {
    "label": "Charizard UPC",
    "url": "https://displayarmour.co.uk/products/pokemon-charizard-upc-case"
  },
  {
    "label": "151 UPC",
    "url": "https://displayarmour.co.uk/products/pokemon-151-upc-case"
  },
  {
    "label": "Mega UPC",
    "url": "https://displayarmour.co.uk/products/pokemon-mega-upc-case"
  },
  {
    "label": "Prismatic Evolutions SPC",
    "url": "https://displayarmour.co.uk/products/pokemon-prismatic-evolutions-spc-case"
  },
  {
    "label": "Tohoku Box",
    "url": "https://displayarmour.co.uk/products/pokemon-tohoku-box-case"
  },
  {
    "label": "Mini Tin",
    "url": "https://displayarmour.co.uk/products/pokemon-mini-tin-acrylic-display-case"
  },
  {
    "label": "TCG Collector Tin",
    "url": "https://displayarmour.co.uk/products/pokemon-tin-acrylic-display-case"
  },
  {
    "label": "3-Slot Booster Pack Dispenser",
    "url": "https://displayarmour.co.uk/products/pokemon-3-slot-booster-pack-dispenser"
  },
  {
    "label": "6-Slot Booster Pack Dispenser",
    "url": "https://displayarmour.co.uk/products/pokemon-6-slot-booster-pack-dispenser"
  },
  {
    "label": "9-Pocket Card Binder",
    "url": "https://displayarmour.co.uk/products/9-pocket-trading-card-binder"
  },
  {
    "label": "12-Pocket Card Binder",
    "url": "https://displayarmour.co.uk/products/12-pocket-trading-card-binder"
  },
  {
    "label": "Large 9-Pocket Card Binder",
    "url": "https://displayarmour.co.uk/products/large-9-pocket-trading-card-binder"
  },
  {
    "label": "3-Card Desktop Frame",
    "url": "https://displayarmour.co.uk/products/pokemon-acrylic-card-desktop-display-frame-3-grid"
  },
  {
    "label": "6-Card Desktop Frame",
    "url": "https://displayarmour.co.uk/products/pokemon-acrylic-card-desktop-display-frame-6-grid"
  },
  {
    "label": "9-Card Desktop Frame",
    "url": "https://displayarmour.co.uk/products/pokemon-acrylic-card-desktop-display-frame-9-grid"
  },
  {
    "label": "PSA 3-Slab Display",
    "url": "https://displayarmour.co.uk/products/psa-3-slab-acrylic-display"
  }
];
var POKEMON_CARD_FRAMES_URL = 'https://displayarmour.co.uk/products/pokemon-acrylic-card-desktop-display-frame-3-grid';
var POKEMON_CENTER_ETB_LINK = {
  label: 'Pokémon Center ETB',
  url: 'https://displayarmour.co.uk/products/pokemon-center-etb-acrylic-display-case'
};
var TRADING_CARD_BOOSTER_BOX_LINKS = [
  { label: 'Star Wars Booster Box', url: 'https://displayarmour.co.uk/products/star-wars-booster-box-acrylic-display-case' },
  { label: 'Dragon Ball Super Booster Box', url: 'https://displayarmour.co.uk/products/dragon-ball-super-booster-box-acrylic-display-case' },
  { label: 'Disney Lorcana Booster Box', url: 'https://displayarmour.co.uk/products/disney-lorcana-booster-box-acrylic-display-case' }
];
var TRADING_CARD_COLLECTION_URL = 'https://displayarmour.co.uk/collections/trading-card-display-cases';
var TRADING_CARD_DISPLAY_LINKS = [
  { label: 'All Trading Card Displays', url: TRADING_CARD_COLLECTION_URL },
  { label: 'Single Card Display Case', mobileLabel: 'Single Card', url: 'https://displayarmour.co.uk/products/trading-card-single-card-acrylic-display-case' },
  { label: 'Booster Pack Display Case', mobileLabel: 'Booster Pack', url: 'https://displayarmour.co.uk/products/trading-card-booster-pack-acrylic-display-case' },
  { label: 'Sleeved Booster Pack Case', mobileLabel: 'Sleeved Booster Pack', url: 'https://displayarmour.co.uk/products/trading-card-sleeved-booster-pack-acrylic-display-case' },
  { label: '3-Pack Display Case', mobileLabel: '3-Pack Display', url: 'https://displayarmour.co.uk/products/trading-card-booster-pack-acrylic-display-case-3-pack' },
  { label: '3-Card Desktop Frame', mobileLabel: '3-Card Frame', url: 'https://displayarmour.co.uk/products/trading-card-acrylic-desktop-display-frame-3-card' },
  { label: '6-Card Desktop Frame', mobileLabel: '6-Card Frame', url: 'https://displayarmour.co.uk/products/trading-card-acrylic-desktop-display-frame-6-card' },
  { label: '9-Card Desktop Frame', mobileLabel: '9-Card Frame', url: 'https://displayarmour.co.uk/products/trading-card-acrylic-desktop-display-frame-9-card' }
];
var TECHNOLOGY_LINKS = [
  { label: 'How it Works', url: '/pages/display-armour-technology', icon: 'gear' },
  { label: 'SecureRail', url: '/pages/securerail-technology', icon: 'shield' },
  { label: 'ArmourLock', url: '/pages/armourlock-technology', icon: 'lock' },
  { label: 'GlideLock', url: '/pages/glidelock-access-panel', icon: 'glide' },
  { label: 'AeroLift', url: '/pages/aerolift-support-technology', icon: 'lift' }
];
var ABOUT_DISPLAY_ARMOUR_LINKS = [
  { label: 'Our Story', url: '/pages/about-us', icon: 'origin' },
  { label: 'Why Display Armour', url: '/pages/why-display-armour-is-the-premium-choice-for-collectors', icon: 'shield-check' },
  { label: 'Trade & Wholesale', url: '/pages/trade-wholesale', icon: 'trade' },
  { label: 'Display Systems', url: '/pages/display-armour-technology', icon: 'systems' },
  { label: 'Rewards', url: '/pages/pages-armour-points', icon: 'reward' }
];
var ABOUT_SUPPORT_LINKS = [
  { label: 'Contact Us', url: '/pages/contact', icon: 'contact' },
  { label: 'Delivery Information', url: '/pages/delivery-and-shipping-information', icon: 'delivery' },
  { label: 'Returns', url: '/pages/30-day-guarantee-returns', icon: 'returns' },
  { label: 'Guarantee', url: '/pages/30-day-guarantee-returns', icon: 'shield-check' }
];
var DESKTOP_SUPPORT_LINKS = [
  { label: 'Contact Us', url: '/pages/contact', icon: 'contact' },
  { label: 'Delivery Information', url: '/pages/delivery-and-shipping-information', icon: 'delivery' },
  { label: 'Returns', url: '/pages/30-day-guarantee-returns', icon: 'returns' },
  { label: 'Warranty', url: '/pages/30-day-guarantee-returns', icon: 'shield-check' },
  { label: 'FAQs', url: '/pages/faqs', icon: 'faq' }
];
var COLLECTOR_COMMUNITY_LINKS = [
  { label: 'Collector Blog', url: '/blogs/news' },
  { label: 'Collector Showcase', url: '/pages/collector-showcase' },
  { label: 'Case Setup & Care Guide', url: '/pages/how-to-use-display-armour-case' },
  { label: 'Collector Reviews', url: '/pages/customer-reviews' },
  { label: 'FAQs & Support', url: '/pages/faqs' }
];
var COLLECTOR_GUIDE_LINKS = [
  { label: 'UV Damage', url: '/pages/uv-damage-action-figures-cardbacks' },
  { label: 'Protecting MOC Figures', url: '/pages/why-moc-figures-need-a-specialist-case' },
  { label: 'How to Store Figures', url: '/pages/how-to-store-moc-action-figures' },
  { label: 'Case Types Explained', url: '/pages/action-figure-display-case-types' },
  { label: 'Collector Terminology', url: '/pages/action-figure-collector-terminology-guide' },
  { label: 'TMNT Collecting', url: '/pages/tmnt-collector-guide-protecting-playmates-moc-figures' },
  { label: 'Pokemon Collecting', url: '/pages/ultimate-guide-to-pokemon-display-cases' },
  { label: 'Star Wars Collecting', url: '/pages/star-wars-collectors-guide' },
  { label: 'WWF Hasbro Collecting', url: '/pages/wwf-hasbro-storage-and-grading-guide' },
  { label: 'Video Game Collecting', url: '/pages/video-game-collector-guide-protect-retro-game-boxes' }
];
var VALUE_GUIDE_LINKS = [
  { label: 'Action Figures', url: '/blogs/news/most-valuable-action-figures-top-20' },
  { label: 'Pokemon Cards', url: '/blogs/news/most-valuable-pokemon-cards' },
  { label: 'Star Wars Figures', url: '/blogs/news/top-30-most-valuable-star-wars-action-figures' },
  { label: 'WWF Hasbro Figures', url: '/blogs/news/most-valuable-wwf-hasbro-figures' },
  { label: 'Teenage Mutant Ninja Turtles', url: '/blogs/news/most-valuable-vintage-tmnt-figures' },
  { label: 'Masters of the Universe', url: '/blogs/news/most-valuable-vintage-motu-figures' },
  { label: 'G.I. Joe Figures', url: '/blogs/news/most-valuable-vintage-gi-joe-figures' },
  { label: 'Thundercats Figures', url: '/blogs/news/most-valuable-vintage-thundercats-figures' },
  { label: 'Transformers Figures', url: '/blogs/news/most-valuable-transformers-toys' },
  { label: 'Ghostbusters Figures', url: '/blogs/news/most-valuable-vintage-ghostbusters-figures' },
  { label: 'Simpsons Figures', url: '/blogs/news/rarest-simpsons-action-figures' },
  { label: 'Video Games', url: '/blogs/news/most-expensive-video-games-ever-sold' }
];
var POKEMON_GUIDE_LINKS = [
  { label: 'Pokémon Beginner Guide', url: 'https://displayarmour.co.uk/blogs/news/pokemon-cards-for-beginners' },
  { label: 'Most Valuable Pokémon Cards', url: '/blogs/news/most-valuable-pokemon-cards' },
  { label: 'Pokémon Rarity Guide', url: 'https://displayarmour.co.uk/blogs/news/pokemon-card-rarity-symbols-explained' },
  { label: 'Modern Pokémon Sets to Watch', url: 'https://displayarmour.co.uk/blogs/news/best-modern-pokemon-sets-to-hold-sealed' },
  { label: 'Pokémon Collector Guide', url: 'https://displayarmour.co.uk/pages/ultimate-guide-to-pokemon-display-cases' }
];
function normaliseLabel(value) {
  return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
}
function ensureMobileDisplayDestination(group, entry) {
  var list = group && group.querySelector(':scope > .gm-links');
  if (!list || !entry) return;
  var exists = Array.prototype.some.call(
    list.querySelectorAll(':scope > .gm-item:not(.gm-heading) > .gm-target[href]'),
    function (target) {
      var text = target.querySelector('.gm-text, .gm-label');
      return normaliseLabel(text ? text.textContent : target.textContent) === normaliseLabel(entry.label) ||
        target.getAttribute('href') === entry.url;
    }
  );
  if (exists) return;
  var item = document.createElement('li');
  var link = document.createElement('a');
  var text = document.createElement('span');
  item.className = 'gm-item';
  link.className = 'gm-target';
  link.setAttribute('href', entry.url);
  link.setAttribute('title', entry.label);
  link.setAttribute('aria-label', entry.label);
  text.className = 'gm-text';
  text.textContent = entry.label;
  link.appendChild(text);
  item.appendChild(link);
  list.appendChild(item);
}
function directTarget(item) {
  if (!item) return null;
  return Array.prototype.find.call(item.children, function (child) {
    return child.classList && child.classList.contains('gm-target');
  }) || null;
}
function targetLabel(item) {
  var target = directTarget(item);
  if (!target) return '';
  var label = target.querySelector('.gm-text, .gm-label');
  return normaliseLabel(label ? label.textContent : target.textContent);
}
function topLevelItems(menu) {
  return Array.prototype.filter.call(menu ? menu.children : [], function (child) {
    return child.classList && child.classList.contains('gm-item');
  });
}
function findTopItem(menu, matcher) {
  return topLevelItems(menu).find(function (item) {
    return matcher(targetLabel(item));
  }) || null;
}
function prepareCollectorShowcaseLinks(menu) {
  var showcaseItem = findTopItem(menu, function (label) {
    return label === 'collector showcase' || label === 'collector community';
  });
  var showcaseTarget = directTarget(showcaseItem);
  if (showcaseTarget && showcaseTarget.getAttribute('href')) {
    COLLECTOR_COMMUNITY_LINKS[1].url = showcaseTarget.getAttribute('href');
  }
  if (showcaseItem) showcaseItem.remove();
  return COLLECTOR_COMMUNITY_LINKS;
}
function removeMovedAboutLinks(panel) {
  if (!panel) return;
  var movedLabels = [
    'collector showcase',
    'collector guides',
    'collector reviews',
    'case setup & care',
    'case setup & care guide'
  ];
  panel.querySelectorAll('.gm-target').forEach(function (link) {
    var label = normaliseLabel(link.textContent);
    if (movedLabels.indexOf(label) === -1) return;
    var item = link.closest('.gm-item');
    if (item) item.remove();
  });
}
function setTargetLabel(target, value) {
  if (!target) return;
  var label = target.querySelector('.gm-text, .gm-label');
  if (label) {
    label.textContent = value;
    return;
  }
  var textNode = Array.prototype.find.call(target.childNodes, function (node) {
    return node.nodeType === 3 && node.nodeValue.trim();
  });
  if (textNode) textNode.nodeValue = value;
}
function replaceTargetWithLink(target, url) {
  if (!target) return null;
  if (target.tagName === 'A') {
    target.setAttribute('href', url);
    return target;
  }
  var link = document.createElement('a');
  Array.prototype.forEach.call(target.attributes, function (attribute) {
    link.setAttribute(attribute.name, attribute.value);
  });
  while (target.firstChild) link.appendChild(target.firstChild);
  link.setAttribute('href', url);
  target.parentNode.replaceChild(link, target);
  return link;
}
function ensureMobileHeadingArrows(menu) {
  if (!menu) return;
  menu.querySelectorAll('.gm-heading > a.gm-target[href]').forEach(function (headingLink) {
    if (headingLink.querySelector(':scope > .da-mobile-heading-arrow')) return;
    var arrow = document.createElement('span');
    arrow.className = 'da-mobile-heading-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
        '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    headingLink.appendChild(arrow);
  });
}
function updatePokemonNavigationLinks(menu, mobile) {
  if (!menu) return;
  menu.querySelectorAll('a.gm-target[href]').forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (href.indexOf('pokemon-acrylic-card-desktop-display-frame-9-grid') !== -1 && !link.dataset.daRangeProduct) {
      link.setAttribute('href', POKEMON_CARD_FRAMES_URL);
    }
  });
  if (!mobile) return;
  var pokemonItem = findTopItem(menu, function (label) {
    return label === 'pokemon' || label === 'pokémon';
  });
  var pokemonPanel = directSubmenu(pokemonItem);
  if (!pokemonPanel) return;
  var pokemonHeading = Array.prototype.find.call(
    pokemonPanel.querySelectorAll('.gm-heading > .gm-target'),
    function (headingTarget) {
      var label = normaliseLabel(headingTarget.textContent).replace('pokémon', 'pokemon');
      return label === 'pokemon displays' || label === 'pokemon cases';
    }
  );
  pokemonHeading = replaceTargetWithLink(pokemonHeading, POKEMON_COLLECTION_URL);
  if (pokemonHeading) {
    pokemonHeading.title = 'Pokémon Displays';
    pokemonHeading.setAttribute('aria-label', 'Pokémon Displays');
  }
}
function renameDisplaysHeadings(menu) {
  var displaysItem = findTopItem(menu, function (label) {
    return label === 'displays';
  });
  var panel = directSubmenu(displaysItem);
  if (!panel) return;
  var displayHeadingLabels = {
    'popular cases': 'Popular Displays',
    'classic cases': 'Classic Displays',
    'modern cases': 'Modern Displays',
    'pokemon cases': 'Pokemon Displays',
    'pokémon cases': 'Pokemon Displays',
    'combat cases': 'Combat Displays',
    'wrestling cases': 'Wrestling Displays',
    'loose figure cases': 'Loose Figure Displays',
    'video game cases': 'Video Game Displays',
    'specialty cases': 'Specialty Displays',
    'card protectors': 'Card Protectors',
    'shop by type': 'Shop by Type'
  };
  panel.querySelectorAll('.gm-heading > .gm-target').forEach(function (headingTarget) {
    var headingText = headingTarget.querySelector('.gm-text, .gm-label');
    var currentLabel = normaliseLabel(headingText ? headingText.textContent : headingTarget.textContent);
    var replacement = displayHeadingLabels[currentLabel];
    if (!replacement) return;
    setTargetLabel(headingTarget, replacement);
    headingTarget.title = replacement;
  });
}
function createMenuGroup(heading, links, modifierClass) {
  var group = document.createElement('div');
  var list = document.createElement('ul');
  var headingItem = document.createElement('li');
  var headingTarget = document.createElement('div');
  var headingText = document.createElement('span');
  group.className = 'gm-item gm-grid-item gm-has-submenu' + (modifierClass ? ' ' + modifierClass : '');
  list.className = 'gm-links';
  headingItem.className = 'gm-item gm-heading';
  headingTarget.className = 'gm-target';
  headingTarget.title = heading;
  headingText.className = 'gm-text';
  headingText.textContent = heading;
  headingTarget.appendChild(headingText);
  headingItem.appendChild(headingTarget);
  list.appendChild(headingItem);
  links.forEach(function (item) {
    var listItem = document.createElement('li');
    var link = document.createElement('a');
    var text = document.createElement('span');
    listItem.className = 'gm-item';
    link.className = 'gm-target';
    if (item.icon) {
      link.classList.add('da-engineered-link', 'da-engineered-link--' + item.icon);
    }
    link.href = item.url;
    link.title = item.label;
    text.className = 'gm-text';
    text.textContent = item.label;
    link.appendChild(text);
    listItem.appendChild(link);
    list.appendChild(listItem);
  });
  group.appendChild(list);
  return group;
}
// Add to source groups before the desktop stages and mobile copies are built.
// Existing rows retain their nodes, labels and URLs; repeat scans are no-ops.
function ensureNewProductDestinations(menu) {
  if (!menu) return;
  menu.querySelectorAll('.gm-grid-item').forEach(function (group) {
    if (group.dataset.daProductDestinationsReady === 'true') return;
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    var groupLabel = normaliseLabel(heading && heading.textContent).replace(/pokémon/g, 'pokemon');
    var pokemon = ['pokemon', 'pokemon displays', 'pokemon cases'].indexOf(groupLabel) !== -1;
    var tradingCards = ['trading cards', 'trading card displays'].indexOf(groupLabel) !== -1;
    var videoGames = ['video games', 'video game displays', 'video game cases'].indexOf(groupLabel) !== -1;
    if (!pokemon && !tradingCards && !videoGames) return;
    var list = group.querySelector(':scope > .gm-links');
    if (!list) return;
    var rows = Array.prototype.slice.call(list.querySelectorAll(':scope > .gm-item:not(.gm-heading)'));
    function rowLabel(row) {
      var target = row.querySelector(':scope > .gm-target');
      var text = target && target.querySelector('.gm-text, .gm-label');
      return normaliseLabel(text ? text.textContent : target && target.textContent);
    }
    var additions = pokemon ? POKEMON_RANGE_LINKS : (videoGames ? [
      { label: 'PlayStation 1 (PS1)', url: 'https://displayarmour.co.uk/products/ps1-acrylic-display-case-standard' }
    ] : TRADING_CARD_BOOSTER_BOX_LINKS);
    function destinationPath(link) {
      // Verified storefront redirect; retain the older working href.
      return link.pathname === '/products/pokemon-booster-box-acrylic-display-case-moc'
        ? '/products/pokemon-booster-box-acrylic-display-case' : link.pathname;
    }
    function isAddition(row) {
      var link = row.querySelector(':scope > a.gm-target[href]');
      return link && additions.some(function (entry) {
        return destinationPath(link) === new URL(entry.url).pathname;
      });
    }
    var existingRows = rows.filter(function (row) { return !isAddition(row); });
    var anchor;
    if (pokemon || videoGames) {
      anchor = existingRows[existingRows.length - 1] || null;
    } else {
      var boxes = existingRows.filter(function (row) { return /booster box/.test(rowLabel(row)); });
      var packs = existingRows.filter(function (row) { return /booster pack|3-pack/.test(rowLabel(row)); });
      anchor = boxes[boxes.length - 1] || packs[packs.length - 1] || existingRows[existingRows.length - 1];
    }
    additions.forEach(function (entry) {
      var row = rows.find(function (candidate) {
        var link = candidate.querySelector(':scope > a.gm-target[href]');
        return link && destinationPath(link) === new URL(entry.url).pathname;
      });
      if (!row) row = createMenuGroup('', [entry]).querySelector('.gm-item:not(.gm-heading) > .gm-target').parentElement;
      var target = row.querySelector(':scope > .gm-target');
      if (pokemon) { target.dataset.daPreservePokemonSpelling = 'true'; target.dataset.daRangeProduct = 'true'; }
      var text = target.querySelector('.gm-text, .gm-label');
      if (!text || text.textContent !== entry.label) setTargetLabel(target, entry.label);
      if (target.hasAttribute('aria-label')) target.setAttribute('aria-label', entry.label);
      if (target.title !== entry.label) target.title = entry.label;
      if (anchor) {
        if (anchor.nextElementSibling !== row) anchor.insertAdjacentElement('afterend', row);
      } else {
        list.appendChild(row);
      }
      anchor = row;
    });
    if (pokemon && menu.classList.contains('gm-menu-mobile')) window.DisplayArmourGroupPokemonMenu(group);
    group.dataset.daProductDestinationsReady = 'true';
  });
}
function ensureTradingCardShopByTypeLink(menu) {
  if (!menu || menu.dataset.daTradingCardShopByTypeReady === 'true') return;
  var displaysItem = findTopItem(menu, function (label) {
    return label === 'displays';
  });
  var panel = directSubmenu(displaysItem);
  if (!panel) return;

  var typeGroup = Array.prototype.find.call(panel.querySelectorAll('.gm-grid-item'), function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent) === 'shop by type';
  });
  var list = typeGroup && typeGroup.querySelector(':scope > .gm-links');
  if (!list) return;

  function itemLabel(item) {
    var target = item && item.querySelector(':scope > .gm-target');
    var text = target && target.querySelector('.gm-text, .gm-label');
    return normaliseLabel(text ? text.textContent : target && target.textContent);
  }

  var items = Array.prototype.filter.call(list.children, function (item) {
    return item.classList && item.classList.contains('gm-item') && !item.classList.contains('gm-heading');
  });
  var tradingCardItem = items.find(function (item) {
    return itemLabel(item) === 'trading card displays';
  });

  if (!tradingCardItem) {
    var link = document.createElement('a');
    var text = document.createElement('span');
    tradingCardItem = document.createElement('li');
    tradingCardItem.className = 'gm-item';
    link.className = 'gm-target';
    link.setAttribute('href', '/collections/trading-card-display-cases');
    link.title = 'Trading Card Displays';
    text.className = 'gm-text';
    text.textContent = 'Trading Card Displays';
    link.appendChild(text);
    tradingCardItem.appendChild(link);
  }

  var wrestlingItem = items.find(function (item) {
    return itemLabel(item) === 'wrestling cases';
  });
  var cardProtectorsItem = items.find(function (item) {
    return itemLabel(item) === 'card protectors';
  });
  if (wrestlingItem) {
    wrestlingItem.insertAdjacentElement('afterend', tradingCardItem);
  } else if (cardProtectorsItem) {
    list.insertBefore(tradingCardItem, cardProtectorsItem);
  } else {
    list.appendChild(tradingCardItem);
  }
  menu.dataset.daTradingCardShopByTypeReady = 'true';
}
function ensureShopByTypeGlobalLinks(menu) {
  if (!menu || menu.dataset.daShopByTypeGlobalsReady === 'true') return;
  var displaysItem = findTopItem(menu, function (label) {
    return label === 'displays';
  });
  var panel = directSubmenu(displaysItem);
  if (!panel) return;

  var typeGroup = Array.prototype.find.call(panel.querySelectorAll('.gm-grid-item'), function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent) === 'shop by type';
  });
  var list = typeGroup && typeGroup.querySelector(':scope > .gm-links');
  if (!list) return;

  function linkItemLabel(item) {
    var target = item && item.querySelector(':scope > .gm-target');
    var text = target && target.querySelector('.gm-text, .gm-label');
    return normaliseLabel(text ? text.textContent : target && target.textContent);
  }

  var items = Array.prototype.filter.call(list.children, function (item) {
    return item.classList && item.classList.contains('gm-item') && !item.classList.contains('gm-heading');
  });
  var collectionsItem = items.find(function (item) {
    var label = linkItemLabel(item);
    return label === 'all products' || label === 'view all collections';
  });
  if (!collectionsItem) return;

  var collectionsLink = collectionsItem.querySelector(':scope > .gm-target');
  var collectionsText = collectionsLink && collectionsLink.querySelector('.gm-text, .gm-label');
  if (!collectionsLink || !collectionsText) return;
  collectionsText.textContent = 'View All Collections';
  collectionsLink.title = 'View All Collections';
  collectionsLink.setAttribute('aria-label', 'View All Collections');
  collectionsItem.classList.add('da-shop-by-type-global', 'da-shop-by-type-global--first');

  var productsItem = items.find(function (item) {
    return linkItemLabel(item) === 'view all products';
  });
  if (!productsItem) {
    productsItem = document.createElement('li');
    var productsLink = document.createElement('a');
    var productsText = document.createElement('span');
    productsItem.className = 'gm-item';
    productsLink.className = 'gm-target';
    productsLink.setAttribute('href', '/collections/all');
    productsLink.title = 'View All Products';
    productsLink.setAttribute('aria-label', 'View All Products');
    productsText.className = 'gm-text';
    productsText.textContent = 'View All Products';
    productsLink.appendChild(productsText);
    productsItem.appendChild(productsLink);
  }
  productsItem.classList.add('da-shop-by-type-global');

  /* Keep both global destinations together at the bottom of Shop by Type.
     Moving the existing item preserves its current collections-directory URL. */
  list.appendChild(collectionsItem);
  list.appendChild(productsItem);

  if (!menu.matches(MOBILE_MENU)) {
    var exploreLabel = list.querySelector(':scope > .da-shop-by-type-global-label');
    if (!exploreLabel) {
      exploreLabel = document.createElement('li');
      var exploreText = document.createElement('span');
      exploreLabel.className = 'gm-item da-shop-by-type-global-label';
      exploreText.textContent = 'EXPLORE DISPLAY ARMOUR';
      exploreLabel.appendChild(exploreText);
    }
    list.insertBefore(exploreLabel, collectionsItem);
  }

  var destinationOrder = [
    'carded cases',
    'loose figure cases',
    'pokemon cases',
    'trading card displays',
    'video game cases',
    'card protectors'
  ];
  function destinationOrderLabel(item) {
    var label = linkItemLabel(item).replace('pokémon', 'pokemon');
    var aliases = {
      'carded figure cases': 'carded cases',
      'carded figures': 'carded cases',
      'carded displays': 'carded cases',
      'combat': 'combat cases',
      'loose figure displays': 'loose figure cases',
      'loose figures': 'loose figure cases',
      'pokemon': 'pokemon cases',
      'pokemon displays': 'pokemon cases',
      'trading cards': 'trading card displays',
      'video game displays': 'video game cases',
      'video games': 'video game cases',
      'wrestling': 'wrestling cases'
    };
    return aliases[label] || label;
  }
  var mainItems = Array.prototype.filter.call(list.children, function (item) {
    return item.classList && item.classList.contains('gm-item') &&
      !item.classList.contains('gm-heading') &&
      !item.classList.contains('da-shop-by-type-global') &&
      !item.classList.contains('da-shop-by-type-global-label');
  });
  mainItems = mainItems.filter(function (item) {
    var label = destinationOrderLabel(item);
    if (label !== 'combat cases' && label !== 'wrestling cases') return true;
    item.remove();
    return false;
  });
  mainItems.sort(function (a, b) {
    var aIndex = destinationOrder.indexOf(destinationOrderLabel(a));
    var bIndex = destinationOrder.indexOf(destinationOrderLabel(b));
    if (aIndex === -1) aIndex = destinationOrder.length;
    if (bIndex === -1) bIndex = destinationOrder.length;
    return aIndex - bIndex;
  });
  var utilityAnchor = list.querySelector(':scope > .da-shop-by-type-global-label') || collectionsItem;
  mainItems.forEach(function (item) { list.insertBefore(item, utilityAnchor); });

  if (!menu.matches(MOBILE_MENU)) {
    var desktopTypeLabels = {
      'carded cases': 'Carded Displays',
      'carded figure cases': 'Carded Displays',
      'loose figure cases': 'Loose Figure Displays',
      'pokemon cases': 'Pokémon Displays',
      'pokemon displays': 'Pokémon Displays',
      'video game cases': 'Video Game Displays',
      'video game displays': 'Video Game Displays'
    };
    mainItems.forEach(function (item) {
      var target = item.querySelector(':scope > .gm-target');
      var replacement = desktopTypeLabels[linkItemLabel(item).replace('pokémon', 'pokemon')];
      if (!target || !replacement) return;
      setTargetLabel(target, replacement);
      target.title = replacement;
      if (target.hasAttribute('aria-label')) target.setAttribute('aria-label', replacement);
    });

  }

  menu.dataset.daShopByTypeGlobalsReady = 'true';
}

function syncDesktopShopByTypePresentation(menu) {
  if (!menu || menu.matches(MOBILE_MENU)) return;
  var displaysItem = findTopItem(menu, function (label) { return label === 'displays'; });
  var panel = directSubmenu(displaysItem);
  if (!panel) return;
  var typeGroup = Array.prototype.find.call(panel.querySelectorAll('.gm-grid-item'), function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent) === 'shop by type';
  });
  var list = typeGroup && typeGroup.querySelector(':scope > .gm-links');
  if (!list) return;

  function syncDestination(item, index, globalDestination) {
    var target = item && item.querySelector(':scope > .gm-target[href]');
    if (!target) return;
    if (globalDestination) {
      delete target.dataset.davoIndex;
      target.classList.remove('da-vault__display-destination');
      target.classList.add('da-vault__global-destination');
      item.style.setProperty('grid-column', '1 / -1', 'important');
      item.style.setProperty('width', '100%', 'important');
      item.style.setProperty('max-width', 'none', 'important');
      item.style.setProperty('justify-self', 'stretch', 'important');
    } else {
      target.dataset.davoIndex = String(index + 1).padStart(2, '0');
      target.classList.remove('da-vault__global-destination');
      target.classList.add('da-vault__display-destination');
    }
    target.style.setProperty('width', '100%', 'important');
    target.style.setProperty('max-width', 'none', 'important');
    target.style.setProperty('box-sizing', 'border-box', 'important');
    if (!target.querySelector(':scope > .da-vault__display-arrow')) {
      var arrow = document.createElement('span');
      arrow.className = 'da-vault__display-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '↗';
      target.appendChild(arrow);
    }
  }

  var mainItems = Array.prototype.filter.call(list.children, function (item) {
    return item.classList && item.classList.contains('gm-item') &&
      !item.classList.contains('gm-heading') &&
      !item.classList.contains('da-shop-by-type-global') &&
      !item.classList.contains('da-shop-by-type-global-label');
  });
  mainItems.forEach(function (item, index) { syncDestination(item, index, false); });
  Array.prototype.forEach.call(list.querySelectorAll(':scope > .da-shop-by-type-global'), function (item) {
    syncDestination(item, 0, true);
  });
}

function removeDesktopPokemonCollectionShortcut(menu) {
  if (!menu || menu.matches(MOBILE_MENU)) return;
  var displaysItem = findTopItem(menu, function (label) { return label === 'displays'; });
  var panel = directSubmenu(displaysItem);
  if (!panel) return;
  var pokemonGroup = Array.prototype.find.call(panel.querySelectorAll('.gm-grid-item'), function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    var label = normaliseLabel(heading && heading.textContent).replace('pokémon', 'pokemon');
    return label === 'pokemon displays' || label === 'pokemon cases';
  });
  if (!pokemonGroup) return;
  Array.prototype.slice.call(pokemonGroup.querySelectorAll('.gm-links > .gm-item:not(.gm-heading)')).forEach(function (item) {
    var target = item.querySelector(':scope > .gm-target[href]');
    var text = target && target.querySelector('.gm-text, .gm-label');
    var label = normaliseLabel(text ? text.textContent : target && target.textContent).replace('pokémon', 'pokemon');
    if (label === 'pokemon') item.remove();
  });
  var stage = pokemonGroup.closest('.da-vault__stage');
  var tabId = stage && stage.getAttribute('aria-labelledby');
  var tab = tabId && document.getElementById(tabId);
  var count = pokemonGroup.querySelectorAll('.gm-links > .gm-item:not(.gm-heading) > .gm-target[href]').length;
  if (tab) {
    tab.dataset.channelCount = String(count);
    if (tab.getAttribute('aria-selected') === 'true') {
      var vault = tab.closest('.da-vault');
      var telemetryCount = vault && vault.querySelector('.da-vault__telemetry-count');
      if (telemetryCount) telemetryCount.textContent = String(count).padStart(2, '0');
    }
  }
}
function ensureTradingCardDisplaysGroup(menu) {
  if (!menu) return;
  var mobile = menu.matches(MOBILE_MENU);
  if (mobile && menu.dataset.daTradingCardDisplaysReady === 'true') return;
  var displaysItem = findTopItem(menu, function (label) {
    return label === 'displays';
  });
  var panel = directSubmenu(displaysItem);
  if (!mobile && panel && panel.dataset.daVaultReady === 'true') return;
  var grid = panel && panel.querySelector(':scope > .gm-grid');
  if (!grid) return;

  function positionMobileGroup(group) {
    if (!mobile || !group) return;
    var looseFigureGroup = Array.prototype.find.call(grid.children, function (candidate) {
      if (!candidate.classList || !candidate.classList.contains('gm-grid-item')) return false;
      var heading = candidate.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
      var label = normaliseLabel(heading && heading.textContent);
      return label === 'loose figure displays' || label === 'loose figure cases';
    });
    if (looseFigureGroup && looseFigureGroup.nextElementSibling !== group) {
      looseFigureGroup.insertAdjacentElement('afterend', group);
    }
  }

  var existingGroup = Array.prototype.find.call(grid.children, function (group) {
    if (!group.classList || !group.classList.contains('gm-grid-item')) return false;
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    var label = normaliseLabel(heading && heading.textContent);
    return label === 'trading card displays' || label === 'trading cards';
  });
  if (existingGroup) {
    existingGroup.classList.add('da-trading-card-displays-group');
    var existingHeadingTarget = existingGroup.querySelector('.gm-heading > .gm-target');
    setTargetLabel(existingHeadingTarget, 'Trading Card Displays');
    if (existingHeadingTarget) {
      existingHeadingTarget.title = 'Trading Card Displays';
      if (existingHeadingTarget.hasAttribute('aria-label')) {
        existingHeadingTarget.setAttribute('aria-label', 'Trading Card Displays');
      }
    }
    Array.prototype.slice.call(existingGroup.querySelectorAll('.gm-links > .gm-item:not(.gm-heading)')).forEach(function (item) {
      var target = item.querySelector(':scope > .gm-target');
      if (normaliseLabel(target && target.textContent) === 'all trading card displays') item.remove();
    });
    positionMobileGroup(existingGroup);
    menu.dataset.daTradingCardDisplaysReady = 'true';
    return;
  }

  var links = TRADING_CARD_DISPLAY_LINKS.filter(function (item) {
    return item.label !== 'All Trading Card Displays';
  }).map(function (item) {
    return {
      label: mobile && item.mobileLabel ? item.mobileLabel : item.label,
      url: item.url
    };
  });
  var group = createMenuGroup(
    'Trading Card Displays',
    links,
    'da-trading-card-displays-group'
  );
  var headingTarget = group.querySelector('.gm-heading > .gm-target');
  headingTarget = replaceTargetWithLink(headingTarget, TRADING_CARD_COLLECTION_URL);
  if (headingTarget) {
    headingTarget.title = 'Trading Card Displays';
    headingTarget.setAttribute('aria-label', 'Trading Card Displays');
  }

  /* Desktop keeps the source group at the end so its established positional
     icons do not move; the GRID applies its semantic channel order below.
     Mobile places the same group directly after Loose Figure Displays. */
  grid.appendChild(group);
  positionMobileGroup(group);
  menu.dataset.daTradingCardDisplaysReady = 'true';
}
function directSubmenu(item) {
  if (!item) return null;
  return Array.prototype.find.call(item.children, function (child) {
    return child.classList && (
      child.classList.contains('gm-submenu') ||
      child.classList.contains('da-vault-panel')
    );
  }) || null;
}
function ensureVaultTopIndicator(target) {
  if (!target) return;
  var indicator = target.querySelector(':scope > .da-grid-nav-indicator');
  if (!indicator) {
    indicator = document.createElement('span');
    indicator.className = 'da-grid-nav-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    target.appendChild(indicator);
  }
}
function syncDesktopIndicators(menu) {
  if (!menu || menu.matches(MOBILE_MENU)) return;
  topLevelItems(menu).forEach(function (item) {
    var label = targetLabel(item);
    if (['displays', 'shop by brand', 'display technology', 'display systems', 'display armour', 'collector hub', 'about', 'about us', 'about & support', 'support'].indexOf(label) === -1) return;
    var target = directTarget(item);
    if (!target) return;
    if (target.querySelector('.gm-text, .gm-label')) {
      Array.prototype.slice.call(target.childNodes).forEach(function (child) {
        if (child.nodeType === 3 && child.textContent.trim()) child.remove();
      });
    }
    var indicator = null;
    Array.prototype.slice.call(target.children).forEach(function (child) {
      if (child.classList && child.classList.contains('da-grid-nav-indicator')) {
        if (!indicator) indicator = child;
        else child.remove();
      } else if (child.classList && (
        child.classList.contains('gm-retractor') ||
        child.classList.contains('icon-caret') ||
        child.classList.contains('da-vault-top-chevron')
      ) || child.tagName === 'SVG') child.remove();
    });
    if (!indicator) ensureVaultTopIndicator(target);
  });
}
function ensureAboutSubmenu(menu) {
  if (menu && menu.dataset.daMobileAboutMenuReady === 'true') return null;
  var item = findTopItem(menu, function (label) {
    return label === 'about' || label === 'about us' || label === 'about & support';
  });
  var target = directTarget(item);
  var panel = directSubmenu(item);
  if (!item || !target) return null;
  if (panel) {
    removeMovedAboutLinks(panel);
    panel.classList.add('da-tech-native-dropdown', 'da-about-native-dropdown');
    panel.id = panel.id || 'DAAboutMenu-' + window.DisplayArmourHeaderConfig.sectionId + '-' + (menu.matches(MOBILE_MENU) ? 'mobile' : 'desktop');
    var existingGrid = panel.querySelector(':scope > .gm-grid');
    if (existingGrid) {
      existingGrid.classList.add('da-tech-native-dropdown__grid', 'da-about-native-dropdown__grid');
      var aboutGroups = [createMenuGroup(
        'Display Armour',
        ABOUT_DISPLAY_ARMOUR_LINKS,
        'da-about-native-dropdown__group da-about-native-dropdown__group--brand'
      )];
      /* Once Support has been promoted on mobile, later menu refreshes must
         not rebuild its former group inside About. */
      if (!(menu.matches(MOBILE_MENU) && menu.dataset.daMobileSupportSplitReady === 'true')) {
        aboutGroups.push(createMenuGroup(
          'Support',
          ABOUT_SUPPORT_LINKS,
          'da-about-native-dropdown__group da-about-native-dropdown__group--support'
        ));
      }
      existingGrid.replaceChildren.apply(existingGrid, aboutGroups);
    }
    item.classList.add('gm-has-submenu', 'gm-submenu-mega', 'da-about-menu-host');
    target.setAttribute('aria-haspopup', 'true');
    target.setAttribute('aria-controls', panel.id);
    return panel;
  }
  panel = document.createElement('div');
  panel.className = 'gm-submenu gm-mega gm-submenu-bordered da-tech-native-dropdown da-about-native-dropdown';
  panel.id = 'DAAboutMenu-' + window.DisplayArmourHeaderConfig.sectionId + '-' + (menu.matches(MOBILE_MENU) ? 'mobile' : 'desktop');
  panel.setAttribute('aria-hidden', 'true');
  var grid = document.createElement('ul');
  grid.className = 'gm-grid da-tech-native-dropdown__grid da-about-native-dropdown__grid';
  grid.appendChild(createMenuGroup(
    'Display Armour',
    ABOUT_DISPLAY_ARMOUR_LINKS,
    'da-about-native-dropdown__group da-about-native-dropdown__group--brand'
  ));
  grid.appendChild(createMenuGroup(
    'Support',
    ABOUT_SUPPORT_LINKS,
    'da-about-native-dropdown__group da-about-native-dropdown__group--support'
  )); 
  panel.appendChild(grid);
  item.appendChild(panel);
  item.classList.add('gm-has-submenu', 'gm-submenu-mega', 'da-about-menu-host');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panel.id);
  return panel;
}
function splitMobileSupportMenu(menu) {
  if (!menu || menu.dataset.daMobileSupportSplitReady === 'true') return;
  var aboutHost = findTopItem(menu, function (label) {
    return label === 'about' || label === 'about us' || label === 'about & support';
  });
  var aboutTarget = directTarget(aboutHost);
  var aboutPanel = directSubmenu(aboutHost);
  var aboutGrid = aboutPanel && aboutPanel.querySelector(':scope > .gm-grid');
  if (!aboutHost || !aboutTarget || !aboutPanel || !aboutGrid) return;

  var supportGroup = aboutGrid.querySelector('.da-about-native-dropdown__group--support');
  if (!supportGroup) return;

  var supportHost = aboutHost.cloneNode(true);
  clearClonedMenuState(supportHost);
  var supportTarget = directTarget(supportHost);
  var supportPanel = directSubmenu(supportHost);
  var supportGrid = supportPanel && supportPanel.querySelector(':scope > .gm-grid');
  if (!supportTarget || !supportPanel || !supportGrid) return;

  supportGrid.replaceChildren(createMenuGroup(
    'Support',
    DESKTOP_SUPPORT_LINKS,
    'da-about-native-dropdown__group da-about-native-dropdown__group--support'
  ));
  supportGroup.remove();

  supportHost.classList.remove('gm-active', 'gm-open', 'da-app-mobile-open');
  supportHost.classList.add('da-mobile-support-host');
  supportTarget.querySelectorAll('.da-grid-nav-indicator, .gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });
  setTargetLabel(supportTarget, 'Support');
  supportTarget.title = 'Support';
  supportTarget.setAttribute('href', '#');
  supportTarget.setAttribute('aria-haspopup', 'true');
  supportTarget.setAttribute('aria-expanded', 'false');
  supportPanel.id = 'DAMobileSupportMenu-' + window.DisplayArmourHeaderConfig.sectionId;
  supportTarget.setAttribute('aria-controls', supportPanel.id);
  aboutHost.insertAdjacentElement('afterend', supportHost);
  menu.dataset.daMobileSupportSplitReady = 'true';
}
function buildDesktopAboutMenu(menu) {
  if (!menu) return;
  var host = findTopItem(menu, function (label) {
    return label === 'about' || label === 'about us' || label === 'about & support';
  });
  var target = directTarget(host);
  if (!host || !target) return;
  ensureVaultTopIndicator(target);
  Array.prototype.slice.call(host.children).forEach(function (child) {
    if (child.classList && child.classList.contains('gm-submenu')) child.remove();
  });
  var panel = Array.prototype.find.call(host.children, function (child) {
    return child.classList && child.classList.contains('da-about-standalone-dropdown');
  });
  if (panel) return;
  panel = document.createElement('div');
  panel.id = 'DADesktopAboutStandaloneMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  panel.className = 'da-tech-native-dropdown da-about-standalone-dropdown';
  panel.setAttribute('aria-hidden', 'true');
  panel.appendChild(createMenuGroup(
    'Display Armour',
    ABOUT_DISPLAY_ARMOUR_LINKS,
    'da-collector-native-dropdown__group da-tech-native-dropdown__group da-about-standalone-dropdown__group da-about-standalone-dropdown__group--brand'
  ));
  host.classList.remove('gm-submenu-mega', 'da-about-menu-host', 'gm-active', 'gm-open');
  host.classList.add('gm-has-submenu', 'da-tech-menu-host', 'da-about-standalone-host');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  host.appendChild(panel);
  bindDesktopBehaviour(host, target, panel);
}
function clearClonedMenuState(root) {
  if (!root) return;
  [root].concat(Array.prototype.slice.call(root.querySelectorAll('*'))).forEach(function (element) {
    element.removeAttribute('id');
    element.removeAttribute('aria-controls');
    element.removeAttribute('aria-expanded');
    element.removeAttribute('aria-hidden');
    element.removeAttribute('inert');
    element.removeAttribute('style');
    if (!element.dataset) return;
    Object.keys(element.dataset).forEach(function (name) {
      if (/^da/.test(name)) delete element.dataset[name];
    });
  });
}
function buildTopLevelShopByBrand(menu) {
  if (!menu || menu.dataset.daShopByBrandReady === 'true') return;
  var existingHost = findTopItem(menu, function (label) { return label === 'shop by brand'; });
  if (existingHost) {
    menu.dataset.daShopByBrandReady = 'true';
    return;
  }
  var displaysHost = findTopItem(menu, function (label) { return label === 'displays'; });
  var displaysTarget = directTarget(displaysHost);
  var displaysPanel = directSubmenu(displaysHost);
  if (!displaysHost || !displaysTarget || !displaysPanel) return;
  var displaysGrid = displaysPanel.querySelector(':scope > .gm-grid');
  if (displaysGrid) applyMobileClassicModernTaxonomy(displaysGrid);
  var host = displaysHost.cloneNode(true);
  clearClonedMenuState(host);
  var target = directTarget(host);
  var panel = directSubmenu(host);
  if (!target || !panel) return;
  host.classList.remove('gm-active', 'gm-open', 'da-vault-host', 'da-tech-menu-open', 'da-app-mobile-open');
  target.querySelectorAll('.da-grid-nav-indicator, .gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });
  setTargetLabel(target, 'Shop by Brand');
  target.title = 'Shop by Brand';
  target.setAttribute('href', '#');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  panel.id = 'DAShopByBrandMenu-' + window.DisplayArmourHeaderConfig.sectionId + '-' + (menu.matches(MOBILE_MENU) ? 'mobile' : 'desktop');
  target.setAttribute('aria-controls', panel.id);
  displaysHost.insertAdjacentElement('afterend', host);
  if (!menu.matches(MOBILE_MENU)) {
    host.classList.add('gm-has-submenu', 'da-tech-menu-host', 'da-shop-by-brand-host');
    ensureVaultTopIndicator(target);
    panel.setAttribute('aria-hidden', 'true');
    bindDesktopBehaviour(host, target, panel);
  }
  menu.dataset.daShopByBrandReady = 'true';
}
function buildTopLevelShopByType(menu) {
  if (!menu || menu.dataset.daShopByTypeReady === 'true') return;
  var existingHost = findTopItem(menu, function (label) { return label === 'shop by type'; });
  if (existingHost) {
    menu.dataset.daShopByTypeReady = 'true';
    return;
  }
  var displaysHost = findTopItem(menu, function (label) { return label === 'displays'; });
  var brandHost = findTopItem(menu, function (label) { return label === 'shop by brand'; });
  var displaysPanel = directSubmenu(displaysHost);
  if (!displaysHost || !displaysPanel) return;

  var host = displaysHost.cloneNode(true);
  clearClonedMenuState(host);
  var target = directTarget(host);
  var panel = directSubmenu(host);
  if (!target || !panel) return;

  var clonedGroups = Array.prototype.slice.call(panel.querySelectorAll('.gm-grid-item'));
  var typeGroup = clonedGroups.find(function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent) === 'shop by type';
  });
  if (!typeGroup) return;
  /* This group is promoted out of its original positional slot on mobile.
     Give it a stable hook so its heading icon no longer depends on nth-child. */
  typeGroup.classList.add('da-mobile-shop-by-type-group');

  /* The source menu currently exposes both accented and unaccented Pokemon
     labels for this destination. Keep the first working link and remove only
     the duplicate from the promoted mobile Shop by Type accordion. */
  var pokemonTypeSeen = false;
  Array.prototype.slice.call(typeGroup.querySelectorAll('.gm-links > .gm-item:not(.gm-heading)')).forEach(function (linkItem) {
    var linkTarget = linkItem.querySelector('.gm-target');
    var linkLabel = normaliseLabel(linkTarget && linkTarget.textContent).replace('pokémon', 'pokemon');
    if (linkLabel !== 'pokemon cases') return;
    if (pokemonTypeSeen) linkItem.remove();
    pokemonTypeSeen = true;
  });
  clonedGroups.forEach(function (group) {
    if (group !== typeGroup) group.remove();
  });

  Array.prototype.slice.call(displaysPanel.querySelectorAll('.gm-grid-item')).forEach(function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    if (normaliseLabel(heading && heading.textContent) === 'shop by type') group.remove();
  });

  host.classList.remove('gm-active', 'gm-open', 'da-vault-host', 'da-tech-menu-open', 'da-app-mobile-open');
  target.querySelectorAll('.da-grid-nav-indicator, .gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });
  setTargetLabel(target, 'Shop by Type');
  target.title = 'Shop by Type';
  target.setAttribute('href', '#');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  panel.id = 'DAShopByTypeMenu-' + window.DisplayArmourHeaderConfig.sectionId + '-mobile';
  target.setAttribute('aria-controls', panel.id);
  (brandHost || displaysHost).insertAdjacentElement('afterend', host);
  menu.dataset.daShopByTypeReady = 'true';
}
function buildTopLevelPokemon(menu) {
  if (!menu || menu.dataset.daPokemonReady === 'true') return;
  var existingHost = findTopItem(menu, function (label) {
    return label === 'pokemon' || label === 'pokémon';
  });
  if (existingHost) {
    menu.dataset.daPokemonReady = 'true';
    return;
  }

  var displaysHost = findTopItem(menu, function (label) { return label === 'displays'; });
  var typeHost = findTopItem(menu, function (label) { return label === 'shop by type'; });
  var displaysPanel = directSubmenu(displaysHost);
  if (!displaysHost || !typeHost || !displaysPanel) return;

  var host = displaysHost.cloneNode(true);
  clearClonedMenuState(host);
  var target = directTarget(host);
  var panel = directSubmenu(host);
  if (!target || !panel) return;

  var clonedGroups = Array.prototype.slice.call(panel.querySelectorAll('.gm-grid-item'));
  var pokemonGroup = clonedGroups.find(function (group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    var label = normaliseLabel(heading && heading.textContent).replace('pokémon', 'pokemon');
    return label === 'pokemon displays' || label === 'pokemon cases';
  });
  if (!pokemonGroup) return;

  /* Keep the original link nodes and href values from the Displays menu. The
     cloned group is only a second, mobile fast-access route. */
  clonedGroups.forEach(function (group) {
    if (group !== pokemonGroup) group.remove();
  });
  pokemonGroup.classList.add('da-mobile-pokemon-group');
  var pokemonHeading = pokemonGroup.querySelector('.gm-heading > .gm-target');
  setTargetLabel(pokemonHeading, 'Pokémon Displays');
  if (pokemonHeading) pokemonHeading.title = 'Pokémon Displays';

  host.classList.remove('gm-active', 'gm-open', 'da-vault-host', 'da-tech-menu-open', 'da-app-mobile-open');
  target.querySelectorAll('.da-grid-nav-indicator, .gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });
  setTargetLabel(target, 'Pokémon');
  target.title = 'Pokémon';
  target.setAttribute('href', '#');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  panel.id = 'DAMobilePokemonMenu-' + window.DisplayArmourHeaderConfig.sectionId;
  target.setAttribute('aria-controls', panel.id);
  typeHost.insertAdjacentElement('afterend', host);
  menu.dataset.daPokemonReady = 'true';
}
function applyMobileClassicModernTaxonomy(grid) {
  if (!grid || grid.dataset.daClassicModernTaxonomyReady === 'true') return;
  var groups = Array.prototype.filter.call(grid.children, function (group) {
    return group.classList && group.classList.contains('gm-grid-item');
  });
  function normaliseTaxonomyName(value) {
    return normaliseLabel(value)
      .replace(/[’]/g, "'")
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^crash test dummies$/, 'crash dummies')
      .replace(/^super7 reaction$/, 'super 7 reaction')
      .replace(/^the simpsons$/, 'simpsons')
      .trim();
  }
  function groupKey(group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent).replace(/\s+cases$/, ' displays');
  }
  function itemName(item) {
    var target = item && item.querySelector(':scope > .gm-target');
    var text = target && target.querySelector('.gm-text, .gm-label');
    return normaliseTaxonomyName(text ? text.textContent : target && target.textContent);
  }
  function groupItems(group) {
    var list = group && group.querySelector(':scope > .gm-links');
    return list ? Array.prototype.filter.call(list.children, function (item) {
      return item.classList && item.classList.contains('gm-item') &&
        !item.classList.contains('gm-heading') && item.querySelector(':scope > .gm-target[href]');
    }) : [];
  }
  function findItem(group, name) {
    var wanted = normaliseTaxonomyName(name);
    return groupItems(group).find(function (item) { return itemName(item) === wanted; }) || null;
  }
  function moveItem(name, sourceGroup, destinationGroup) {
    var sourceItem = findItem(sourceGroup, name);
    var destinationItem = findItem(destinationGroup, name);
    var destinationList = destinationGroup && destinationGroup.querySelector(':scope > .gm-links');
    if (!sourceItem || !destinationList) return;
    if (destinationItem) destinationItem.replaceWith(sourceItem);
    else destinationList.appendChild(sourceItem);
  }
  var groupsByKey = Object.create(null);
  groups.forEach(function (group) { groupsByKey[groupKey(group)] = group; });
  var popularGroup = groupsByKey['popular displays'];
  var classicGroup = groupsByKey['classic displays'];
  var modernGroup = groupsByKey['modern displays'];
  if (!popularGroup || !classicGroup || !modernGroup) return;

  MOBILE_ADDITIONAL_DISPLAY_DESTINATIONS.forEach(function (entry) {
    ensureMobileDisplayDestination(
      entry.home === 'classic displays' ? classicGroup : modernGroup,
      entry
    );
  });

  ['Crash Dummies', 'DC Total Justice', 'Fantastic Four', 'Spider Man', 'X-Men'].forEach(function (name) {
    moveItem(name, modernGroup, classicGroup);
  });
  moveItem('The Simpsons', classicGroup, modernGroup);

  /* Mobile deliberately keeps Popular destinations in Popular only. */
  var popularNames = groupItems(popularGroup).map(itemName);
  groupItems(classicGroup).forEach(function (item) {
    if (popularNames.indexOf(itemName(item)) !== -1) item.remove();
  });
  grid.dataset.daClassicModernTaxonomyReady = 'true';
}
function sortMobileActionDisplayDestinations(grid) {
  if (!grid) return;
  var popularOrder = [
    'batman',
    'biker mice from mars',
    "bucky o'hare",
    'ghostbusters',
    'masters of the universe',
    'pokemon',
    'star wars',
    'teenage mutant ninja turtles',
    'thundercats',
    'toxic crusaders',
    'wwf hasbro'
  ];
  var actionGroups = [
    'classic displays',
    'modern displays',
    'wrestling displays',
    'combat displays',
    'loose figure displays',
    'card protectors'
  ];
  var classicOrder = [
    'a team',
    'crash dummies',
    'dc super heroes',
    'dc total justice',
    'defenders of the earth',
    'dick tracy',
    'fantastic four',
    'jurassic park',
    'power rangers',
    'silverhawks',
    'spider man',
    'super powers',
    'transformers',
    'visionaries',
    'x men'
  ];
  var groups = Array.prototype.filter.call(grid.children, function (group) {
    return group.classList && group.classList.contains('gm-grid-item');
  });
  function groupKey(group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent)
      .replace(/\s+cases$/, ' displays');
  }
  function itemLabel(item) {
    var target = item.querySelector(':scope > .gm-target');
    var text = target && target.querySelector('.gm-text, .gm-label');
    return normaliseLabel(text ? text.textContent : target && target.textContent)
      .replace(/[’]/g, "'")
      .replace('pokémon', 'pokemon')
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^crash test dummies$/, 'crash dummies')
      .replace(/^super7 reaction$/, 'super 7 reaction')
      .trim();
  }
  function alphabeticalKey(label) {
    return label.replace(/^the\s+/, '');
  }
  groups.forEach(function (group) {
    var channelKey = groupKey(group);
    if (channelKey !== 'popular displays' && actionGroups.indexOf(channelKey) === -1) return;
    var list = group.querySelector(':scope > .gm-links');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (item) {
      return item.classList && item.classList.contains('gm-item') &&
        !item.classList.contains('gm-heading') && item.querySelector(':scope > .gm-target[href]');
    });
    items.sort(function (a, b) {
      var aLabel = itemLabel(a);
      var bLabel = itemLabel(b);
      if (channelKey === 'popular displays') {
        return popularOrder.indexOf(aLabel) - popularOrder.indexOf(bLabel);
      }
      if (channelKey === 'classic displays') {
        var aIndex = classicOrder.indexOf(aLabel);
        var bIndex = classicOrder.indexOf(bLabel);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      }
      return alphabeticalKey(aLabel).localeCompare(
        alphabeticalKey(bLabel),
        'en-GB',
        { sensitivity: 'base', numeric: true }
      );
    });
    items.forEach(function (item) { list.appendChild(item); });
  });
}
function reorganiseMobileDisplays(menu) {
  if (!menu || menu.dataset.daMobileDisplaysSplitReady === 'true') return;
  var displaysHost = findTopItem(menu, function (label) {
    return label === 'displays' || label === 'action figure displays' || label === 'figure displays' || label === 'shop by collection';
  });
  var typeHost = findTopItem(menu, function (label) { return label === 'shop by type'; });
  var displaysTarget = directTarget(displaysHost);
  var displaysPanel = directSubmenu(displaysHost);
  var sourceGrid = displaysPanel && displaysPanel.querySelector(':scope > .gm-grid');
  if (!displaysHost || !typeHost || !displaysTarget || !displaysPanel || !sourceGrid) return;
  applyMobileClassicModernTaxonomy(sourceGrid);
  sortMobileActionDisplayDestinations(sourceGrid);

  function groupLabel(group) {
    var heading = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
    return normaliseLabel(heading && heading.textContent).replace('pokémon', 'pokemon');
  }
  function matchesMovedGroup(label, wanted) {
    if (wanted === 'pokemon displays') return label === wanted || label === 'pokemon cases' || label === 'pokemon';
    if (wanted === 'video game displays') return label === wanted || label === 'video game cases' || label === 'video games';
    if (wanted === 'specialty displays') return label === wanted || label === 'specialty cases' || label === 'specialty';
    if (wanted === 'trading card displays') return label === wanted || label === 'trading cards';
    if (wanted === 'popular displays') return label === wanted || label === 'popular cases' || label === 'popular';
    if (wanted === 'classic displays') return label === wanted || label === 'classic cases' || label === 'classic';
    if (wanted === 'modern displays') return label === wanted || label === 'modern cases' || label === 'modern';
    if (wanted === 'combat displays') return label === wanted || label === 'combat cases' || label === 'combat';
    if (wanted === 'wrestling displays') return label === wanted || label === 'wrestling cases' || label === 'wrestling';
    if (wanted === 'loose figure displays') return label === wanted || label === 'loose figure cases' || label === 'loose figures';
    return label === wanted;
  }
  function addCollectiblesToShopByCollection(collectiblePanel) {
    var collectibleGrid = collectiblePanel && (
      collectiblePanel.classList.contains('gm-grid')
        ? collectiblePanel
        : collectiblePanel.querySelector(':scope > .gm-grid')
    );
    if (!collectibleGrid) return;

    var collectibleGroups = Array.prototype.filter.call(collectibleGrid.children, function (group) {
      return group.classList && group.classList.contains('gm-grid-item');
    });
    ['pokemon displays', 'trading card displays', 'video game displays'].forEach(function (wanted) {
      var alreadyPresent = Array.prototype.some.call(sourceGrid.children, function (group) {
        return group.classList && group.classList.contains('gm-grid-item') &&
          matchesMovedGroup(groupLabel(group), wanted);
      });
      if (alreadyPresent) return;
      var sourceGroup = collectibleGroups.find(function (group) {
        return matchesMovedGroup(groupLabel(group), wanted);
      });
      if (!sourceGroup) return;
      var headingIcon = sourceGroup.style.getPropertyValue('--da-gm-heading-icon');
      var clone = sourceGroup.cloneNode(true);
      clearClonedMenuState(clone);
      clone.classList.add('da-mobile-shop-by-collection-collectible');
      if (headingIcon) clone.style.setProperty('--da-gm-heading-icon', headingIcon);
      sourceGrid.appendChild(clone);
    });

    var collectionOrder = [
      'popular displays',
      'classic displays',
      'modern displays',
      'combat displays',
      'wrestling displays',
      'loose figure displays',
      'pokemon displays',
      'trading card displays',
      'video game displays',
      'card protectors'
    ];
    var orderedGroups = collectionOrder.map(function (wanted) {
      return Array.prototype.find.call(sourceGrid.children, function (group) {
        return group.classList && group.classList.contains('gm-grid-item') &&
          matchesMovedGroup(groupLabel(group), wanted);
      });
    }).filter(Boolean);
    if (!orderedGroups.length) return;
    sourceGrid.insertBefore(orderedGroups[0], sourceGrid.firstElementChild);
    for (var orderIndex = 1; orderIndex < orderedGroups.length; orderIndex += 1) {
      orderedGroups[orderIndex - 1].insertAdjacentElement('afterend', orderedGroups[orderIndex]);
    }
  }

  var existingCollectibleHost = findTopItem(menu, function (label) {
    return label === 'collectible displays' || label === 'pokemon & trading cards' || label === 'pokémon & trading cards' || label === 'pokemon & collectibles' || label === 'pokémon & collectibles';
  });
  if (existingCollectibleHost) {
    var existingCollectibleTarget = directTarget(existingCollectibleHost);
    existingCollectibleHost.classList.add('da-mobile-collectible-displays-host');
    setTargetLabel(displaysTarget, 'Shop by Collection');
    displaysTarget.title = 'Shop by Collection';
    setTargetLabel(existingCollectibleTarget, 'Pokémon & Collectibles');
    if (existingCollectibleTarget) existingCollectibleTarget.title = 'Pokémon & Collectibles';
    addCollectiblesToShopByCollection(directSubmenu(existingCollectibleHost));
    typeHost.insertAdjacentElement('afterend', existingCollectibleHost);
    menu.dataset.daMobileDisplaysSplitReady = 'true';
    return;
  }

  var sourceGroups = Array.prototype.filter.call(sourceGrid.children, function (group) {
    return group.classList && group.classList.contains('gm-grid-item');
  });
  var wantedGroups = [
    'pokemon displays',
    'trading card displays',
    'video game displays',
    'specialty displays'
  ];
  var movedGroups = wantedGroups.map(function (wanted) {
    var matches = sourceGroups.filter(function (group) {
      return matchesMovedGroup(groupLabel(group), wanted);
    });
    return matches.length === 1 ? matches[0] : null;
  });
  if (movedGroups.some(function (group) { return !group; })) return;

  /* The original mobile group icons were position-based. Capture every
     resolved value before moving the real nodes so both resulting accordions
     preserve their approved icons without adding or changing any CSS. */
  sourceGroups.forEach(function (group) {
    var headingIcon = window.getComputedStyle(group).getPropertyValue('--da-gm-heading-icon').trim();
    if (headingIcon) group.style.setProperty('--da-gm-heading-icon', headingIcon);
  });
  movedGroups[0].classList.add('da-mobile-collectible-pokemon-group');

  var collectibleHost = displaysHost.cloneNode(false);
  var collectibleTarget = displaysTarget.cloneNode(true);
  var collectiblePanel = displaysPanel.cloneNode(false);
  var collectibleGrid = sourceGrid.cloneNode(false);
  clearClonedMenuState(collectibleHost);
  clearClonedMenuState(collectibleTarget);
  clearClonedMenuState(collectiblePanel);
  clearClonedMenuState(collectibleGrid);
  collectibleHost.classList.remove('gm-active', 'gm-open', 'da-vault-host', 'da-tech-menu-open', 'da-app-mobile-open');
  collectibleHost.classList.add('da-mobile-collectible-displays-host');
  setTargetLabel(collectibleTarget, 'Pokémon & Collectibles');
  collectibleTarget.title = 'Pokémon & Collectibles';
  collectibleTarget.setAttribute('href', '#');
  collectibleTarget.setAttribute('aria-haspopup', 'true');
  collectibleTarget.setAttribute('aria-expanded', 'false');
  collectiblePanel.id = 'DAMobileCollectibleDisplaysMenu-' + window.DisplayArmourHeaderConfig.sectionId;
  collectiblePanel.setAttribute('aria-hidden', 'true');
  collectibleTarget.setAttribute('aria-controls', collectiblePanel.id);

  movedGroups.forEach(function (group) {
    collectibleGrid.appendChild(group);
  });
  addCollectiblesToShopByCollection(collectibleGrid);
  collectiblePanel.appendChild(collectibleGrid);
  collectibleHost.appendChild(collectibleTarget);
  collectibleHost.appendChild(collectiblePanel);

  setTargetLabel(displaysTarget, 'Shop by Collection');
  displaysTarget.title = 'Shop by Collection';
  typeHost.insertAdjacentElement('afterend', collectibleHost);
  menu.dataset.daMobileDisplaysSplitReady = 'true';
}
function simplifyMobileDisplayNavigationLabels(menu) {
  if (!menu) return;

  var conciseGroupLabels = {
    'popular cases': 'Popular',
    'popular displays': 'Popular',
    'classic cases': 'Classic',
    'classic displays': 'Classic',
    'modern cases': 'Modern',
    'modern displays': 'Modern',
    'wrestling cases': 'Wrestling',
    'wrestling displays': 'Wrestling',
    'combat cases': 'Combat',
    'combat displays': 'Combat',
    'loose figure cases': 'Loose Figures',
    'loose figure displays': 'Loose Figures',
    'pokemon cases': 'Pokémon',
    'pokemon displays': 'Pokémon',
    'pokémon cases': 'Pokémon',
    'pokémon displays': 'Pokémon',
    'trading card displays': 'Trading Cards',
    'video game cases': 'Video Games',
    'video game displays': 'Video Games',
    'specialty cases': 'Specialty',
    'specialty displays': 'Specialty'
  };

  topLevelItems(menu).forEach(function (host) {
    var hostLabel = targetLabel(host);
    if (
      hostLabel !== 'shop by collection' &&
      hostLabel !== 'pokemon & collectibles' &&
      hostLabel !== 'pokémon & collectibles'
    ) return;
    var panel = directSubmenu(host);
    if (!panel) return;
    panel.querySelectorAll('.gm-grid-item > .gm-links > .gm-heading > .gm-target').forEach(function (heading) {
      var currentLabel = normaliseLabel(heading.textContent);
      var replacement = conciseGroupLabels[currentLabel];
      if (!replacement) return;
      setTargetLabel(heading, replacement);
      heading.title = replacement;
      if (heading.hasAttribute('aria-label')) heading.setAttribute('aria-label', replacement);
    });
  });

  var typeHost = findTopItem(menu, function (label) { return label === 'shop by type'; });
  var typePanel = directSubmenu(typeHost);
  var typeGroup = typePanel && (
    typePanel.querySelector('.da-mobile-shop-by-type-group') ||
    typePanel.querySelector('.gm-grid-item')
  );
  var typeList = typeGroup && typeGroup.querySelector(':scope > .gm-links');
  if (!typeList) return;

  var typeLabels = {
    'carded cases': 'Carded Figures',
    'carded figure cases': 'Carded Figures',
    'carded figures': 'Carded Figures',
    'loose figure cases': 'Loose Figures',
    'loose figures': 'Loose Figures',
    'pokemon cases': 'Pokémon',
    'pokemon displays': 'Pokémon',
    'pokémon': 'Pokémon',
    'pokémon cases': 'Pokémon',
    'pokémon displays': 'Pokémon',
    'trading card displays': 'Trading Cards',
    'trading cards': 'Trading Cards',
    'card protectors': 'Card Protectors',
    'wrestling cases': 'Wrestling',
    'wrestling': 'Wrestling',
    'combat cases': 'Combat',
    'combat': 'Combat',
    'video game cases': 'Video Games',
    'video game displays': 'Video Games',
    'video games': 'Video Games',
    'view all collections': 'View All Collections',
    'view all products': 'View All Products'
  };
  var typeItems = Array.prototype.filter.call(typeList.children, function (item) {
    return item.classList && item.classList.contains('gm-item') &&
      !item.classList.contains('gm-heading') && item.querySelector(':scope > .gm-target[href]');
  });
  typeItems.forEach(function (item) {
    var target = item.querySelector(':scope > .gm-target');
    var currentLabel = normaliseLabel(target && target.textContent);
    var replacement = typeLabels[currentLabel];
    if (!replacement) return;
    setTargetLabel(target, replacement);
    target.title = replacement;
    if (target.hasAttribute('aria-label')) target.setAttribute('aria-label', replacement);
  });

  function mobileTypeOrderKey(item) {
    var target = item.querySelector(':scope > .gm-target');
    var label = normaliseLabel(target && target.textContent).replace('pokémon', 'pokemon');
    var aliases = {
      'carded figures': 'carded cases',
      'combat': 'combat cases',
      'loose figures': 'loose figure cases',
      'pokemon': 'pokemon cases',
      'trading cards': 'trading card displays',
      'video games': 'video game cases',
      'wrestling': 'wrestling cases'
    };
    return aliases[label] || label;
  }
  [
    'carded cases',
    'combat cases',
    'loose figure cases',
    'pokemon cases',
    'trading card displays',
    'video game cases',
    'wrestling cases',
    'card protectors',
    'view all collections',
    'view all products'
  ].forEach(function (wantedLabel) {
    var item = typeItems.find(function (candidate) {
      return mobileTypeOrderKey(candidate) === wantedLabel;
    });
    if (item) typeList.appendChild(item);
  });
}
function removeStandaloneMobilePokemon(menu) {
  if (!menu || menu.dataset.daStandalonePokemonRemoved === 'true') return;
  var pokemonHost = findTopItem(menu, function (label) {
    return label === 'pokemon' || label === 'pokémon';
  });
  if (pokemonHost) pokemonHost.remove();
  menu.dataset.daStandalonePokemonRemoved = 'true';
}
function buildDesktopSupportMenu(menu) {
  if (!menu || menu.dataset.daSupportDropdownReady === 'true') return;
  var aboutHost = findTopItem(menu, function (label) {
    return label === 'about' || label === 'about us' || label === 'about & support';
  });
  var existingHost = findTopItem(menu, function (label) { return label === 'support'; });
  var host = existingHost;
  var target = directTarget(host);
  if (!host) {
    var aboutTarget = directTarget(aboutHost);
    if (!aboutHost || !aboutTarget) return;
    host = aboutHost.cloneNode(false);
    target = aboutTarget.cloneNode(true);
    host.removeAttribute('id');
    host.removeAttribute('style');
    host.classList.remove(
      'gm-active',
      'gm-open',
      'gm-submenu-mega',
      'da-about-menu-host',
      'da-about-standalone-host',
      'da-vault-host'
    );
    target.removeAttribute('id');
    target.removeAttribute('aria-controls');
    target.removeAttribute('aria-expanded');
    target.querySelectorAll('.da-grid-nav-indicator, .gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (node) {
      node.remove();
    });
    setTargetLabel(target, 'Support');
    target.title = 'Support';
    host.appendChild(target);
    aboutHost.insertAdjacentElement('afterend', host);
  }
  if (!target) return;
  Array.prototype.slice.call(host.children).forEach(function (child) {
    if (child !== target) child.remove();
  });
  ensureVaultTopIndicator(target);
  var panel = document.createElement('div');
  panel.id = 'DADesktopSupportMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  panel.className = 'da-tech-native-dropdown da-about-standalone-dropdown da-support-standalone-dropdown';
  panel.setAttribute('aria-hidden', 'true');
  panel.appendChild(createMenuGroup(
    'Support',
    DESKTOP_SUPPORT_LINKS,
    'da-collector-native-dropdown__group da-tech-native-dropdown__group da-about-standalone-dropdown__group da-about-standalone-dropdown__group--support'
  ));
  host.classList.remove('gm-submenu-mega', 'da-about-menu-host', 'gm-active', 'gm-open');
  host.classList.add('gm-has-submenu', 'da-tech-menu-host', 'da-about-standalone-host', 'da-support-standalone-host');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  target.setAttribute('aria-controls', panel.id);
  host.appendChild(panel);
  bindDesktopBehaviour(host, target, panel);
  menu.dataset.daSupportDropdownReady = 'true';
}
function fitDisplaysPanelToViewport(panel) {
  var host = panel && panel.parentElement;
  if (!host || targetLabel(host) !== 'displays') return;
  if (!window.matchMedia('(min-width: 1470px)').matches) {
    panel.style.removeProperty('--da-display-panel-left');
    panel.style.removeProperty('--da-display-panel-top');
    panel.style.removeProperty('--da-display-panel-max-height');
    return;
  }
  var gutter = 20;
  function applyViewportFit() {
    var hostRect = host.getBoundingClientRect();
    var panelWidth = Math.min(1320, Math.max(0, window.innerWidth - (gutter * 2)));
    var preferredLeft = hostRect.left - 48;
    var maximumLeft = Math.max(gutter, window.innerWidth - gutter - panelWidth);
    var fittedLeft = Math.min(Math.max(preferredLeft, gutter), maximumLeft);
    var availableHeight = Math.max(0, Math.floor(window.innerHeight - hostRect.bottom - 24));
    panel.style.setProperty('--da-display-panel-left', fittedLeft + 'px');
    panel.style.setProperty('--da-display-panel-top', hostRect.bottom + 'px');
    panel.style.setProperty('--da-display-panel-max-height', availableHeight + 'px');
  }
  applyViewportFit();
  window.requestAnimationFrame(applyViewportFit);
}
function fitCollectorPanelToViewport(panel) {
  var host = panel && panel.parentElement;
  if (!host || !panel.classList.contains('da-collector-native-dropdown')) return;
  if (!window.matchMedia('(min-width: 1470px)').matches) {
    panel.style.removeProperty('--da-collector-panel-shift');
    return;
  }
  var gutter = 20;
  var panelWidth = Math.min(1120, Math.max(0, window.innerWidth - (gutter * 2)));
  var hostBox = host.getBoundingClientRect();
  var naturalLeft = hostBox.left + (hostBox.width / 2) - (panelWidth / 2);
  var fittedLeft = Math.min(
    Math.max(naturalLeft, gutter),
    Math.max(gutter, window.innerWidth - gutter - panelWidth)
  );
  panel.style.setProperty('--da-collector-panel-shift', (fittedLeft - naturalLeft) + 'px');
}
function resetPanelToTop(panel) {
  if (!panel) return;
  fitDisplaysPanelToViewport(panel);
  fitCollectorPanelToViewport(panel);
  function reset() {
    panel.scrollTop = 0;
    panel.scrollLeft = 0;
  }
  reset();
  window.requestAnimationFrame(reset);
  window.setTimeout(reset, 40);
}
function bindDesktopScrollReset(menu) {
  if (!menu || menu.dataset.daScrollResetReady === 'true') return;
  topLevelItems(menu).forEach(function (item) {
    var panel = directSubmenu(item);
    if (!panel) return;
    item.addEventListener('mouseenter', function () {
      resetPanelToTop(panel);
    });
    item.addEventListener('focusin', function (event) {
      if (event.target === directTarget(item) || !panel.contains(event.relatedTarget)) {
        resetPanelToTop(panel);
      }
    });
    var target = directTarget(item);
    if (target) {
      target.addEventListener('click', function () {
        resetPanelToTop(panel);
      }, true);
    }
  });
  window.addEventListener('resize', function () {
    topLevelItems(menu).forEach(function (item) {
      fitDisplaysPanelToViewport(directSubmenu(item));
      fitCollectorPanelToViewport(directSubmenu(item));
    });
  }, { passive: true });
  menu.dataset.daScrollResetReady = 'true';
}
function bindDesktopScrollDismiss(menu) {
  if (!menu || menu.dataset.daScrollDismissReady === 'true') return;
  var desktopQuery = window.matchMedia('(min-width: 1470px)');
  var lastScrollY = window.scrollY || window.pageYOffset || 0;
  var lastPointerX = null;
  var lastPointerY = null;
  var dismissedPointerX = null;
  var dismissedPointerY = null;
  function desktopPanel(item) {
    if (!item) return null;
    return Array.prototype.find.call(item.children, function (child) {
      if (!child.classList) return false;
      return child.classList.contains('gm-submenu') ||
        child.classList.contains('da-vault-panel') ||
        child.classList.contains('da-tech-native-dropdown') ||
        child.classList.contains('da-collector-native-dropdown') ||
        child.classList.contains('da-about-native-dropdown') ||
        child.classList.contains('da-about-standalone-dropdown');
    }) || null;
  }
  function panelIsVisible(panel) {
    if (!panel) return false;
    var style = window.getComputedStyle(panel);
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01;
  }
  function closeOpenPanels() {
    topLevelItems(menu).forEach(function (item) {
      var target = directTarget(item);
      var panel = desktopPanel(item);
      item.classList.remove('da-tech-menu-open', 'gm-active', 'gm-open');
      if (target) target.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      if (item.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
    });
  }
  function clearDismissal() {
    menu.classList.remove('da-menu-scroll-dismissed');
    dismissedPointerX = null;
    dismissedPointerY = null;
  }
  function handlePointerMove(event) {
    if (menu.classList.contains('da-menu-scroll-dismissed')) {
      if (dismissedPointerX === null || dismissedPointerY === null) {
        dismissedPointerX = event.clientX;
        dismissedPointerY = event.clientY;
        lastPointerX = event.clientX;
        lastPointerY = event.clientY;
        return;
      }
      var pointerTravel = Math.abs(event.clientX - dismissedPointerX) + Math.abs(event.clientY - dismissedPointerY);
      if (pointerTravel < 4) return;
      clearDismissal();
    }
    lastPointerX = event.clientX;
    lastPointerY = event.clientY;
  }
  function handleScroll() {
    var currentScrollY = window.scrollY || window.pageYOffset || 0;
    var travelled = Math.abs(currentScrollY - lastScrollY);
    if (!desktopQuery.matches) {
      lastScrollY = currentScrollY;
      clearDismissal();
      return;
    }
    if (travelled < 8) return;
    lastScrollY = currentScrollY;
    var hasVisiblePanel = topLevelItems(menu).some(function (item) {
      return panelIsVisible(desktopPanel(item));
    });
    if (!hasVisiblePanel) return;
    dismissedPointerX = lastPointerX;
    dismissedPointerY = lastPointerY;
    menu.classList.add('da-menu-scroll-dismissed');
    closeOpenPanels();
  }
  menu.addEventListener('pointermove', handlePointerMove, { passive: true });
  menu.addEventListener('pointerdown', clearDismissal, { passive: true });
  menu.addEventListener('focusin', clearDismissal);
  window.addEventListener('scroll', handleScroll, { passive: true });
  desktopQuery.addEventListener('change', function () {
    lastScrollY = window.scrollY || window.pageYOffset || 0;
    clearDismissal();
  });
  menu.dataset.daScrollDismissReady = 'true';
}
function buildMobileAppAccordion(menu, matcher, slug) {
  var item = findTopItem(menu, matcher);
  var target = directTarget(item);
  var panel = directSubmenu(item);
  if (!item || !target || !panel || item.dataset.daAppMobileReady === 'true') return;
  var panelId = panel.id || 'DAMobileAppMenu-' + window.DisplayArmourHeaderConfig.sectionId + '-' + slug;
  var retractor = Array.prototype.find.call(target.children, function (child) {
    return child.classList && child.classList.contains('gm-retractor');
  });
  if (!retractor) {
    retractor = document.createElement('span');
    retractor.className = 'gm-retractor';
    target.appendChild(retractor);
  }
  panel.id = panelId;
  item.classList.add('da-app-mobile-host', 'da-app-mobile-host--' + slug);
  Array.prototype.slice.call(panel.children).forEach(function (child) {
    if (
      child.classList &&
      (child.classList.contains('gm-grid') || child.classList.contains('da-mobile-display-directory'))
    ) {
      child.classList.add('da-mobile-panel-surface');
    }
  });
  item.classList.remove('gm-active');
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panelId);
  retractor.setAttribute('aria-hidden', 'true');
  function setOpen(open) {
    item.classList.toggle('da-app-mobile-open', open);
    /* The generated Systems/Collector accordions do not use Globo's bright
       `gm-active` surface. Keep native accordions on the same resting panel
       treatment and let the dedicated open class drive their GRID state. */
    item.classList.remove('gm-active');
    target.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.inert = !open;
  }
  function toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setOpen(!item.classList.contains('da-app-mobile-open'));
  }
  target.addEventListener('click', toggle, true);
  target.addEventListener('keydown', function (event) {
    if (event.key === ' ') toggle(event);
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
      target.focus();
    }
  }, true);
  setOpen(false);
  item.dataset.daAppMobileReady = 'true';
}
function bindDesktopBehaviour(host, target, panel) {
  var closeTimer;
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-controls', panel.id);
  function setOpen(open) {
    var wasOpen = host.classList.contains('da-tech-menu-open');
    window.clearTimeout(closeTimer);
    host.classList.toggle('da-tech-menu-open', open);
    target.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open && !wasOpen) resetPanelToTop(panel);
  }
  function queueClose() {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      if (host.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
      setOpen(false);
    }, 170);
  }
  host.addEventListener('mouseenter', function () { setOpen(true); });
  host.addEventListener('mouseleave', queueClose);
  host.addEventListener('focusin', function () { setOpen(true); });
  host.addEventListener('focusout', function () {
    window.setTimeout(function () {
      if (!host.contains(document.activeElement)) setOpen(false);
    }, 0);
  });
  target.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  });
  host.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setOpen(false);
      target.focus();
    } else if (event.key === ' ') {
      event.preventDefault();
      setOpen(true);
    }
  });
}
function buildDesktopMenu(menu) {
  if (!menu || menu.dataset.daTechDropdownReady === 'true') return;
  var technologyItem = findTopItem(menu, function (label) {
    return label === 'display technology' || label === 'display systems' || label === 'display armour' || label === 'technology';
  });
  var target = directTarget(technologyItem);
  if (!technologyItem || !target) return;
  setTargetLabel(target, 'Display Armour');
  target.title = 'Display Armour';
  var panel = document.createElement('div');
  panel.id = 'DADesktopTechnologyMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  panel.className = 'da-tech-native-dropdown';
  panel.setAttribute('aria-hidden', 'true');
  panel.appendChild(createMenuGroup(
    'Technology',
    TECHNOLOGY_LINKS,
    'da-collector-native-dropdown__group da-tech-native-dropdown__group da-tech-native-dropdown__group--systems'
  ));
  technologyItem.classList.add('da-tech-menu-host');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  technologyItem.appendChild(panel);
  bindDesktopBehaviour(technologyItem, target, panel);
  menu.dataset.daTechDropdownReady = 'true';
}
function buildDesktopCollectorMenu(menu) {
  if (!menu || menu.dataset.daCollectorDropdownReady === 'true') return;
  var showcaseLinks = prepareCollectorShowcaseLinks(menu);
  var collectorItem = findTopItem(menu, function (label) {
    return label === 'collector guides' || label === 'collector hub';
  });
  var target = directTarget(collectorItem);
  if (!collectorItem || !target) return;
  var panel = document.createElement('div');
  var grid = document.createElement('div');
  var hubGroup = createMenuGroup(
    'Collector Guides',
    COLLECTOR_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--hub'
  );
  var valuesGroup = createMenuGroup(
    'Value Guides',
    VALUE_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--values'
  );
  var pokemonGroup = createMenuGroup(
    'Pokémon Guides',
    POKEMON_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--pokemon'
  );
  pokemonGroup.dataset.daPreservePokemonSpelling = 'true';
  var showcaseGroup = createMenuGroup(
    'Collector Community',
    showcaseLinks,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--showcase'
  );
  panel.className = 'da-collector-native-dropdown';
  panel.id = 'DADesktopCollectorMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  panel.setAttribute('aria-hidden', 'true');
  grid.className = 'da-collector-native-dropdown__grid';
  grid.appendChild(hubGroup);
  grid.appendChild(valuesGroup);
  grid.appendChild(pokemonGroup);
  grid.appendChild(showcaseGroup);
  panel.appendChild(grid);
  collectorItem.classList.add('da-tech-menu-host', 'da-collector-menu-host');
  setTargetLabel(target, 'Collector Hub');
  target.title = 'Collector Hub';
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-expanded', 'false');
  collectorItem.appendChild(panel);
  bindDesktopBehaviour(collectorItem, target, panel);
  menu.dataset.daCollectorDropdownReady = 'true';
}
function setMobileOpen(host, button, target, panel, open) {
  host.classList.toggle('da-tech-mobile-open', open);
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  target.setAttribute('aria-expanded', open ? 'true' : 'false');
  panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  panel.inert = !open;
}
function buildMobileMenu(menu) {
  if (!menu || menu.dataset.daTechDropdownReady === 'true') return;
  var technologyItem = findTopItem(menu, function (label) {
    return label === 'display technology' || label === 'display systems' || label === 'display armour' || label === 'technology';
  });
  var target = directTarget(technologyItem);
  if (!technologyItem || !target) return;
  setTargetLabel(target, 'Display Armour');
  target.title = 'Display Armour';
  var panelId = 'DAMobileTechnologyMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  var button = document.createElement('button');
  var panel = document.createElement('div');
  var inner = document.createElement('div');
  button.type = 'button';
  button.className = 'da-tech-mobile-toggle';
  button.setAttribute('aria-label', 'Open Display Armour menu');
  button.setAttribute('aria-controls', panelId);
  button.setAttribute('aria-expanded', 'false');
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panelId);
  panel.id = panelId;
  panel.className = 'da-tech-mobile-submenu da-technology-mobile-submenu';
  panel.setAttribute('aria-hidden', 'true');
  inner.className = 'da-tech-mobile-submenu__inner';
  inner.appendChild(createMenuGroup(
    'Display Armour Systems',
    TECHNOLOGY_LINKS,
    'da-collector-native-dropdown__group da-tech-native-dropdown__group da-tech-native-dropdown__group--systems'
  ));
  panel.appendChild(inner);
  technologyItem.classList.add('da-tech-menu-mobile-host');
  technologyItem.appendChild(button);
  technologyItem.appendChild(panel);
  setMobileOpen(technologyItem, button, target, panel, false);
  function toggleTechnologyMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setMobileOpen(
      technologyItem,
      button,
      target,
      panel,
      !technologyItem.classList.contains('da-tech-mobile-open')
    );
  }
  button.addEventListener('click', toggleTechnologyMenu);
  target.addEventListener('click', toggleTechnologyMenu);
  target.addEventListener('keydown', function (event) {
    if (event.key === ' ') toggleTechnologyMenu(event);
  });
  menu.dataset.daTechDropdownReady = 'true';
}
function buildMobileCollectorMenu(menu) {
  if (!menu || menu.dataset.daCollectorDropdownReady === 'true') return;
  var showcaseLinks = prepareCollectorShowcaseLinks(menu);
  var collectorItem = findTopItem(menu, function (label) {
    return label === 'collector guides' || label === 'collector hub';
  });
  var target = directTarget(collectorItem);
  if (!collectorItem || !target) return;
  var panelId = 'DAMobileCollectorMenu-' + window.DisplayArmourHeaderConfig.sectionId + '';
  var button = document.createElement('button');
  var panel = document.createElement('div');
  var inner = document.createElement('div');
  var hubGroup = createMenuGroup(
    'Collector Guides',
    COLLECTOR_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--hub'
  );
  var valuesGroup = createMenuGroup(
    'Value Guides',
    VALUE_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--values'
  );
  var pokemonGroup = createMenuGroup(
    'Pokémon Guides',
    POKEMON_GUIDE_LINKS,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--pokemon'
  );
  pokemonGroup.dataset.daPreservePokemonSpelling = 'true';
  var showcaseGroup = createMenuGroup(
    'Collector Community',
    showcaseLinks,
    'da-collector-native-dropdown__group da-collector-native-dropdown__group--showcase'
  );
  button.type = 'button';
  button.className = 'da-tech-mobile-toggle';
  button.setAttribute('aria-label', 'Open Collector Hub menu');
  button.setAttribute('aria-controls', panelId);
  button.setAttribute('aria-expanded', 'false');
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panelId);
  panel.id = panelId;
  panel.className = 'da-tech-mobile-submenu da-collector-mobile-submenu';
  panel.setAttribute('aria-hidden', 'true');
  inner.className = 'da-tech-mobile-submenu__inner da-collector-mobile-submenu__inner';
  inner.appendChild(hubGroup);
  inner.appendChild(valuesGroup);
  inner.appendChild(pokemonGroup);
  inner.appendChild(showcaseGroup);
  panel.appendChild(inner);
  collectorItem.classList.add('da-tech-menu-mobile-host', 'da-collector-menu-mobile-host');
  setTargetLabel(target, 'Collector Hub');
  target.title = 'Collector Hub';
  collectorItem.appendChild(button);
  collectorItem.appendChild(panel);
  setMobileOpen(collectorItem, button, target, panel, false);
  function toggleCollectorMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setMobileOpen(
      collectorItem,
      button,
      target,
      panel,
      !collectorItem.classList.contains('da-tech-mobile-open')
    );
  }
  button.addEventListener('click', toggleCollectorMenu);
  target.addEventListener('click', toggleCollectorMenu);
  target.addEventListener('keydown', function (event) {
    if (event.key === ' ') toggleCollectorMenu(event);
  });
  menu.dataset.daCollectorDropdownReady = 'true';
}
function buildMobileAboutMenu(menu) {
  if (!menu || menu.dataset.daMobileAboutMenuReady === 'true') return;
  var aboutItem = findTopItem(menu, function (label) {
    return label === 'about' || label === 'about us' || label === 'about & support';
  });
  var target = directTarget(aboutItem);
  if (!aboutItem || !target) return;

  /* The third-party native submenu traps leaf-link taps after opening. Replace
     only its mobile wrapper with the same independent accordion used by the
     working Display Armour and Collector Hub menus. */
  Array.prototype.slice.call(aboutItem.children).forEach(function (child) {
    if (child.classList && child.classList.contains('gm-submenu')) child.remove();
  });
  target.querySelectorAll('.gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });

  var panelId = 'DAMobileAboutMenu-' + window.DisplayArmourHeaderConfig.sectionId;
  var button = document.createElement('button');
  var panel = document.createElement('div');
  var inner = document.createElement('div');
  button.type = 'button';
  button.className = 'da-tech-mobile-toggle';
  button.setAttribute('aria-label', 'Open About menu');
  button.setAttribute('aria-controls', panelId);
  button.setAttribute('aria-expanded', 'false');
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panelId);
  panel.id = panelId;
  panel.className = 'da-tech-mobile-submenu da-collector-mobile-submenu da-about-mobile-submenu';
  panel.setAttribute('aria-hidden', 'true');
  inner.className = 'da-tech-mobile-submenu__inner da-collector-mobile-submenu__inner da-about-mobile-submenu__inner';
  inner.appendChild(createMenuGroup(
    'Display Armour',
    ABOUT_DISPLAY_ARMOUR_LINKS,
    'da-collector-native-dropdown__group da-about-native-dropdown__group da-about-native-dropdown__group--brand'
  ));
  panel.appendChild(inner);
  aboutItem.classList.remove(
    'gm-has-submenu',
    'gm-submenu-mega',
    'gm-active',
    'gm-open',
    'da-app-mobile-host',
    'da-app-mobile-host--about',
    'da-app-mobile-open',
    'da-about-menu-host'
  );
  aboutItem.classList.add('da-tech-menu-mobile-host', 'da-about-menu-mobile-host');
  aboutItem.appendChild(button);
  aboutItem.appendChild(panel);
  setMobileOpen(aboutItem, button, target, panel, false);

  function toggleAboutMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setMobileOpen(
      aboutItem,
      button,
      target,
      panel,
      !aboutItem.classList.contains('da-tech-mobile-open')
    );
  }
  button.addEventListener('click', toggleAboutMenu);
  target.addEventListener('click', toggleAboutMenu);
  target.addEventListener('keydown', function (event) {
    if (event.key === ' ') toggleAboutMenu(event);
    if (event.key === 'Escape') {
      event.preventDefault();
      setMobileOpen(aboutItem, button, target, panel, false);
      target.focus();
    }
  });
  menu.dataset.daMobileAboutMenuReady = 'true';
}
function buildMobileShopByTypeMenu(menu) {
  if (!menu || menu.dataset.daMobileShopByTypeMenuReady === 'true') return;
  var typeItem = findTopItem(menu, function (label) {
    return label === 'shop by type';
  });
  var target = directTarget(typeItem);
  var sourcePanel = directSubmenu(typeItem);
  if (!typeItem || !target || !sourcePanel) return;

  var sourceLinks = Array.prototype.slice.call(
    sourcePanel.querySelectorAll(
      '.da-mobile-shop-by-type-group .gm-links > .gm-item:not(.gm-heading) > a.gm-target[href]'
    )
  ).map(function (link) {
    var label = link.querySelector('.gm-text, .gm-label');
    return {
      label: (label ? label.textContent : link.textContent).replace(/\s+/g, ' ').trim(),
      url: link.getAttribute('href')
    };
  }).filter(function (link) {
    return link.label && link.url;
  });
  if (!sourceLinks.length) return;

  /* Match the independent mobile About accordion. Removing the cloned Globo
     submenu prevents its delegated handler from swallowing destination taps. */
  Array.prototype.slice.call(typeItem.children).forEach(function (child) {
    if (child.classList && child.classList.contains('gm-submenu')) child.remove();
  });
  target.querySelectorAll('.gm-retractor, .icon-caret, .da-vault-top-chevron, svg').forEach(function (element) {
    element.remove();
  });

  var panelId = 'DAMobileShopByTypeMenu-' + window.DisplayArmourHeaderConfig.sectionId;
  var button = document.createElement('button');
  var panel = document.createElement('div');
  var inner = document.createElement('div');
  button.type = 'button';
  button.className = 'da-tech-mobile-toggle';
  button.setAttribute('aria-label', 'Open Shop by Type menu');
  button.setAttribute('aria-controls', panelId);
  button.setAttribute('aria-expanded', 'false');
  target.setAttribute('href', '#');
  target.setAttribute('draggable', 'false');
  target.setAttribute('role', 'button');
  target.setAttribute('tabindex', '0');
  target.setAttribute('aria-haspopup', 'true');
  target.setAttribute('aria-controls', panelId);
  panel.id = panelId;
  panel.className = 'da-tech-mobile-submenu da-collector-mobile-submenu da-shop-by-type-mobile-submenu';
  panel.setAttribute('aria-hidden', 'true');
  inner.className = 'da-tech-mobile-submenu__inner da-collector-mobile-submenu__inner da-shop-by-type-mobile-submenu__inner';
  inner.appendChild(createMenuGroup(
    'Shop by Type',
    sourceLinks,
    'da-collector-native-dropdown__group da-mobile-shop-by-type-group'
  ));
  panel.appendChild(inner);

  typeItem.classList.remove(
    'gm-has-submenu',
    'gm-submenu-mega',
    'gm-submenu-align-full',
    'gm-active',
    'gm-open',
    'da-app-mobile-host',
    'da-app-mobile-host--shop-by-type',
    'da-app-mobile-open'
  );
  typeItem.classList.add('da-tech-menu-mobile-host', 'da-shop-by-type-menu-mobile-host');
  typeItem.appendChild(button);
  typeItem.appendChild(panel);
  setMobileOpen(typeItem, button, target, panel, false);

  function toggleShopByTypeMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    setMobileOpen(
      typeItem,
      button,
      target,
      panel,
      !typeItem.classList.contains('da-tech-mobile-open')
    );
  }
  button.addEventListener('click', toggleShopByTypeMenu);
  target.addEventListener('click', toggleShopByTypeMenu);
  target.addEventListener('keydown', function (event) {
    if (event.key === ' ') toggleShopByTypeMenu(event);
    if (event.key === 'Escape') {
      event.preventDefault();
      setMobileOpen(typeItem, button, target, panel, false);
      target.focus();
    }
  });
  menu.dataset.daMobileShopByTypeMenuReady = 'true';
}
function initialiseTechnologyDropdowns(scope) {
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(ensureTradingCardDisplaysGroup);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(ensureTradingCardDisplaysGroup);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(ensureNewProductDestinations);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(ensureNewProductDestinations);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(ensureTradingCardShopByTypeLink);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(ensureTradingCardShopByTypeLink);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(ensureShopByTypeGlobalLinks);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(ensureShopByTypeGlobalLinks);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(removeDesktopPokemonCollectionShortcut);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(function (menu) {
    updatePokemonNavigationLinks(menu, false);
  });
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(function (menu) {
    updatePokemonNavigationLinks(menu, true);
  });
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildTopLevelShopByBrand);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildTopLevelShopByType);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(function (menu) {
    updatePokemonNavigationLinks(menu, true);
  });
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(ensureAboutSubmenu);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(splitMobileSupportMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(renameDisplaysHeadings);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(renameDisplaysHeadings);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(reorganiseMobileDisplays);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(simplifyMobileDisplayNavigationLabels);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildMobileShopByTypeMenu);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(removeStandaloneMobilePokemon);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(buildDesktopMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(syncDesktopShopByTypePresentation);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildMobileMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(buildDesktopCollectorMenu);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildMobileCollectorMenu);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(buildMobileAboutMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(buildDesktopAboutMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(buildDesktopSupportMenu);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(syncDesktopIndicators);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(bindDesktopScrollReset);
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(bindDesktopScrollDismiss);
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(function (menu) {
    buildMobileAppAccordion(menu, function (label) {
      return label === 'shop by collection';
    }, 'displays');
    buildMobileAppAccordion(menu, function (label) {
      return label === 'pokemon & collectibles' || label === 'pokémon & collectibles';
    }, 'displays');
    buildMobileAppAccordion(menu, function (label) {
      return label === 'shop by brand';
    }, 'shop-by-brand');
    buildMobileAppAccordion(menu, function (label) {
      return label === 'shop by type';
    }, 'shop-by-type');
    buildMobileAppAccordion(menu, function (label) {
      return label === 'support';
    }, 'support');
    ensureMobileHeadingArrows(menu);
  });
}
function queueInitialise() {
  if (observerQueued) return;
  observerQueued = true;
  window.requestAnimationFrame(function () {
    observerQueued = false;
    initialiseTechnologyDropdowns(document);
  });
}
// Prepare this source group synchronously before the desktop Vault consumes it.
// The menu app can replace its grid while retaining the menu's old ready flag.
window.DisplayArmourHeaderConfig.prepareDesktopTradingCards = function (menu) {
  if (menu && !menu.matches(MOBILE_MENU)) {
    ensureTradingCardDisplaysGroup(menu);
    ensureNewProductDestinations(menu);
  }
};
function start() {
  initialiseTechnologyDropdowns(document);
  new MutationObserver(queueInitialise).observe(document.documentElement, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
document.addEventListener('shopify:section:load', queueInitialise);
})();

(function () {
var DESKTOP_MENU = '.header .gm-menu:not(.gm-menu-mobile)';
var MOBILE_MENU = '#menu-drawer .gm-menu-mobile';
var observerQueued = false;
var DESKTOP_ADDITIONAL_DISPLAY_DESTINATIONS = [
  { label: 'A-Team', url: '/collections/a-team-acrylic-display-cases', home: 'classic displays' },
  { label: 'Aliens', url: '/collections/aliens-acrylic-display-cases', home: 'modern displays' },
  { label: 'Space Jam', url: '/collections/space-jam-acrylic-display-cases', home: 'modern displays' }
];
var CHANNEL_COPY = {
  displays: ['Collection systems', 'Explore purpose-built protection for every collection.'],
  'shop by brand': ['Brand directory', 'Browse Display Armour collections by brand and franchise from A–Z.'],
  'display technology': ['Protection engineering', 'Explore the mechanisms behind the Display Armour protection system.'],
  'collector hub': ['Collector intelligence', 'Explore expert guides, values and collector knowledge.'],
  about: ['Brand systems', 'Discover the people and principles behind Display Armour.'],
  support: ['Customer support', 'Access delivery, returns, warranty and customer-support information.']
};
var CHANNEL_DESCRIPTIONS = {
  displays: {
    'popular cases': 'Explore our most popular display cases, trusted by collectors across iconic lines.',
    'popular displays': 'Explore our most popular display cases, trusted by collectors across iconic lines.',
    'classic cases': 'Protect the legendary toy lines and carded figures that defined generations.',
    'classic displays': 'Protect the legendary toy lines and carded figures that defined generations.',
    'modern cases': 'Purpose-built protection for today’s modern figures, releases and collections.',
    'modern displays': 'Purpose-built protection for today’s modern figures, releases and collections.',
    'pokemon cases': 'Protect Pokemon cards, sealed products and collectibles with collector-grade cases.',
    'pokémon cases': 'Protect Pokemon cards, sealed products and collectibles with collector-grade cases.',
    'pokemon displays': 'Protect Pokemon cards, sealed products and collectibles with collector-grade cases.',
    'pokémon displays': 'Protect Pokemon cards, sealed products and collectibles with collector-grade cases.',
    'trading card displays': 'Protect and showcase sports cards, TCGs, sealed packs and multi-card collections.',
    'combat cases': 'Mission-ready protection for military, action and combat figure collections.',
    'combat displays': 'Mission-ready protection for military, action and combat figure collections.',
    'wrestling cases': 'Step into the ring with display cases engineered for iconic wrestling figures.',
    'wrestling displays': 'Step into the ring with display cases engineered for iconic wrestling figures.',
    'loose figure cases': 'Showcase loose figures with clear, purpose-built protection designed for display.',
    'loose figure displays': 'Showcase loose figures with clear, purpose-built protection designed for display.',
    'video game cases': 'Protect boxed games, console releases and gaming collectibles with purpose-built display cases.',
    'video game displays': 'Protect boxed games, console releases and gaming collectibles with purpose-built display cases.',
    'specialty cases': 'Explore dedicated case formats engineered for unusual and specialist collectibles.',
    'specialty displays': 'Explore dedicated case formats engineered for unusual and specialist collectibles.',
    'card protectors': 'Preserve trading cards and graded collectibles with dedicated protective displays.',
    'shop by type': 'Find the right protection by case format, size and display style.'
  },
  'collector hub': {
    'collector guides': 'Explore expert guides, values and collector knowledge.',
    'value guides': 'Discover values, rarities and sought-after collectibles.',
    'pokémon guides': 'Explore Pokémon value guides, rarity references and sealed-set collector research.',
    'collector community': 'Explore stories, showcases, reviews, FAQs and collector support.'
  }
};
var TECHNOLOGY_FEATURES = {
  'how it works': {
    name: 'How it Works',
    icon: 'system',
    description: 'See how Display Armour’s protection systems work together around your collection.'
  },
  securerail: {
    name: 'SecureRail',
    icon: 'rail',
    description: 'A precision rail system engineered to keep cardbacks supported, aligned and secure.'
  },
  armourlock: {
    name: 'ArmourLock',
    icon: 'armour',
    description: 'A controlled locking interface designed to hold the display structure firmly in position.'
  },
  glidelock: {
    name: 'GlideLock',
    icon: 'glide',
    description: 'A guided access mechanism for smooth opening and secure closure.'
  },
  aerolift: {
    name: 'AeroLift',
    icon: 'lift',
    description: 'An elevated support system designed to improve presentation and protective clearance.'
  }
};
var TECHNOLOGY_STAGE_LABELS = {
  'how it works': 'SYSTEM OVERVIEW 01',
  securerail: 'SECURERAIL SYSTEM 02',
  armourlock: 'SECURITY SYSTEM 03',
  glidelock: 'GLIDE SYSTEM 04',
  aerolift: 'AEROLIFT SYSTEM 05'
};
var COLLECTOR_HUB_STAGE_LABELS = {
  'collector guides': 'KNOWLEDGE CHANNEL 01',
  'value guides': 'VALUE INDEX 02',
  'pokémon guides': 'POKÉMON ARCHIVE 03',
  'collector community': 'COMMUNITY SIGNAL 04'
};
var STATUS_CODES = {
  displays: 'DA / ARMOURY',
  'shop by brand': 'DA / ARMOURY',
  'display technology': 'DA / TECH',
  'collector hub': 'DA / HUB',
  about: 'DA / ABOUT',
  support: 'DA / SUPPORT'
};
var ACTIVE_LABELS = {
  displays: 'ACTIVE COLLECTION',
  'shop by brand': 'ACTIVE DIRECTORY',
  'display technology': 'ACTIVE SYSTEM',
  'collector hub': 'ACTIVE CHANNEL',
  about: 'ACTIVE CHANNEL',
  support: 'ACTIVE CHANNEL'
};
var CHANNEL_PREFIXES = {
  displays: 'PROTECTION CHANNEL',
  'shop by brand': 'DIRECTORY CHANNEL',
  'display technology': 'SYSTEM CHANNEL',
  'collector hub': 'COLLECTOR CHANNEL',
  about: 'ARMOUR CHANNEL',
  support: 'SUPPORT CHANNEL'
};
var INDEX_LABELS = {
  displays: 'DISPLAY INDEX',
  'shop by brand': 'BRAND INDEX',
  'display technology': 'SYSTEMS INDEX',
  'collector hub': 'HUB INDEX',
  about: 'ABOUT INDEX',
  support: 'SUPPORT INDEX'
};
var CHANNEL_MODES = {
  displays: {
    popular: 'POPULAR', classic: 'CLASSIC', modern: 'MODERN', pokemon: 'POKEMON',
    'trading card': 'CARDS',
    combat: 'COMBAT', wrestling: 'WRESTLING', 'loose figure': 'LOOSE',
    'video game': 'GAMING', specialty: 'SPECIALTY', 'card protectors': 'CARD',
    'shop by type': 'TYPE'
  },
  'collector hub': {
    'collector guides': 'COLLECTOR', 'value guides': 'VALUE', 'pokemon guides': 'POKÉMON', 'collector community': 'COMMUNITY'
  }
};
function clean(value) {
  return (value || '').replace(/\s+/g, ' ').trim();
}
function key(value) {
  return clean(value).toLowerCase();
}
function displayIndexTitleCase(value) {
  return clean(value)
    .toLocaleLowerCase('en-GB')
    .replace(/\b[a-z]/g, function (letter) { return letter.toLocaleUpperCase('en-GB'); })
    .replace(/\b(By|And|Of|The|For|In|On|To)\b/g, function (word, matchOffset) {
      return matchOffset === 0 ? word : word.toLocaleLowerCase('en-GB');
    });
}
function channelDescriptionFor(menuKey, channelTitle, fallback) {
  var descriptions = CHANNEL_DESCRIPTIONS[menuKey];
  return descriptions && descriptions[key(channelTitle)] || fallback;
}
function channelModeFor(menuKey, channelTitle) {
  var modes = CHANNEL_MODES[menuKey];
  var channelKey = key(channelTitle)
    .replace(/pokémon/g, 'pokemon')
    .replace(/\s+(?:cases|displays)$/, '');
  return modes && modes[channelKey] || 'LIVE';
}
function technologyFeatureFor(label) {
  var technologyKey = key(label).replace(/™/g, '');
  return TECHNOLOGY_FEATURES[technologyKey] || {
    name: clean(label),
    icon: 'system',
    description: 'Explore this Display Armour protection system.'
  };
}
function technologySvg(iconName) {
  var paths = {
    system:
      '<path class="da-tech-svg__trace" d="M48 10 76 26v34L48 76 20 60V26L48 10Z"/>' +
      '<path class="da-tech-svg__accent" d="M48 20 67 31v23L48 65 29 54V31L48 20ZM48 10v10M76 26l-9 5M76 60l-9-6M48 76V65M20 60l9-6M20 26l9 5"/>' +
      '<path class="da-tech-svg__trace" d="M38 38h20v20H38zM14 43h12M70 43h12M48 16v12M48 68v12"/>' +
      '<path class="da-tech-svg__core" d="m48 42 6 6-6 6-6-6 6-6Z"/>',
    rail:
      '<path class="da-tech-svg__trace" d="M12 25h72M12 71h72M18 19v58M78 19v58"/>' +
      '<path class="da-tech-svg__accent" d="M18 34h20M58 34h20M18 62h20M58 62h20M24 25v46M72 25v46"/>' +
      '<path class="da-tech-svg__trace" d="m48 27 15 6v13c0 11-6 18-15 23-9-5-15-12-15-23V33l15-6Z"/>' +
      '<path class="da-tech-svg__trace" d="M40 43h16M40 53h16"/>' +
      '<path class="da-tech-svg__core" d="m48 44 5 5-5 5-5-5 5-5Z"/>',
    armour:
      '<path class="da-tech-svg__trace" d="M29 18h38l11 11v38L67 78H29L18 67V29l11-11Z"/>' +
      '<path class="da-tech-svg__accent" d="M18 39H8v18h10M78 39h10v18H78M39 18V8h18v10M39 78v10h18V78"/>' +
      '<path class="da-tech-svg__trace" d="M34 43h28v24H34zM39 43v-7a9 9 0 0 1 18 0v7M48 52v8"/>' +
      '<path class="da-tech-svg__core" d="m48 49 5 5-5 5-5-5 5-5Z"/>',
    glide:
      '<path class="da-tech-svg__trace" d="M12 28h72M12 68h72M20 22v52M76 22v52"/>' +
      '<path class="da-tech-svg__accent" d="m28 38-10 10 10 10M68 38l10 10-10 10M34 34h28v28H34z"/>' +
      '<path class="da-tech-svg__trace" d="M27 48h42M38 28v40M58 28v40"/>' +
      '<path class="da-tech-svg__core" d="m48 42 6 6-6 6-6-6 6-6Z"/>',
    lift:
      '<path class="da-tech-svg__trace" d="M18 72h60M25 64h46M32 56h32M48 16v36"/>' +
      '<path class="da-tech-svg__accent" d="m36 28 12-12 12 12M24 48c7-9 15-14 24-14s17 5 24 14M18 57c9-11 19-17 30-17s21 6 30 17"/>' +
      '<path class="da-tech-svg__trace" d="M32 56v8M64 56v8M25 64v8M71 64v8"/>' +
      '<path class="da-tech-svg__core" d="m48 30 5 5-5 5-5-5 5-5Z"/>'
  };
  return '<svg class="da-vault__tech-svg" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    (paths[iconName] || paths.system) +
  '</svg>';
}
function normalisePokemonSpelling(root) {
  if (!root) return;
  [root].concat(Array.prototype.slice.call(root.querySelectorAll('*'))).forEach(function (element) {
    if (element.closest('[data-da-preserve-pokemon-spelling="true"]')) return;
    Array.prototype.slice.call(element.childNodes).forEach(function (child) {
      if (child.nodeType === 3 && /pok[éÉ]mon/i.test(child.nodeValue)) {
        child.nodeValue = child.nodeValue.replace(/pok[éÉ]mon/gi, 'Pokemon');
      }
    });
    ['title', 'aria-label'].forEach(function (attribute) {
      var value = element.getAttribute && element.getAttribute(attribute);
      if (value && /pok[éÉ]mon/i.test(value)) {
        element.setAttribute(attribute, value.replace(/pok[éÉ]mon/gi, 'Pokemon'));
      }
    });
  });
}
function restorePromotedPokemonSpelling(menu) {
  if (!menu) return;
  var item = menu.querySelector(':scope > .gm-item.da-app-mobile-host--pokemon');
  var target = directTarget(item);
  var targetText = target && target.querySelector('.gm-text, .gm-label');
  if (targetText) targetText.textContent = 'Pokémon';
  if (target) target.title = 'Pokémon';

  var heading = item && item.querySelector('.da-mobile-pokemon-group .gm-heading > .gm-target');
  var headingText = heading && heading.querySelector('.gm-text, .gm-label');
  if (headingText) headingText.textContent = 'Pokémon Displays';
  if (heading) heading.title = 'Pokémon Displays';
}
function restoreCollectiblePokemonSpelling(menu) {
  if (!menu) return;
  var item = menu.querySelector(':scope > .gm-item.da-mobile-collectible-displays-host');
  var target = directTarget(item);
  var targetText = target && target.querySelector('.gm-text, .gm-label');
  if (targetText) targetText.textContent = 'Pokémon & Collectibles';
  if (target) target.title = 'Pokémon & Collectibles';
  var heading = item && item.querySelector('.da-mobile-collectible-pokemon-group .gm-heading > .gm-target');
  var headingText = heading && heading.querySelector('.gm-text, .gm-label');
  if (headingText) headingText.textContent = 'Pokémon';
  if (heading) {
    heading.title = 'Pokémon';
    heading.setAttribute('aria-label', 'Pokémon');
  }
  menu.querySelectorAll('.da-mobile-shop-by-collection-collectible').forEach(function (group) {
    var collectionHeading = group.querySelector('.gm-heading > .gm-target');
    var collectionHeadingText = collectionHeading && collectionHeading.querySelector('.gm-text, .gm-label');
    var collectionHeadingKey = key(collectionHeadingText && collectionHeadingText.textContent).replace(/pokémon/g, 'pokemon');
    if (collectionHeadingKey !== 'pokemon') return;
    collectionHeadingText.textContent = 'Pokémon';
    collectionHeading.title = 'Pokémon';
    if (collectionHeading.hasAttribute('aria-label')) collectionHeading.setAttribute('aria-label', 'Pokémon');
  });
}
function restoreDisplaysPokemonSpelling(menu) {
  if (!menu) return;
  var displaysItem = menuItems(menu).find(function (item) {
    return key(itemLabel(item)) === 'displays';
  });
  var panel = submenuFor(displaysItem, 'displays', false);
  if (!panel) return;
  groupsFor(panel).forEach(function (group) {
    var heading = group.querySelector('.gm-heading > .gm-target');
    var headingText = heading && heading.querySelector('.gm-text, .gm-label');
    var headingKey = key(headingText && headingText.textContent).replace(/pokémon/g, 'pokemon');
    if (headingKey !== 'pokemon displays') return;
    headingText.textContent = 'Pokémon Displays';
    heading.title = 'Pokémon Displays';
    heading.setAttribute('aria-label', 'Pokémon Displays');
  });
}
function directTarget(item) {
  return item && Array.prototype.find.call(item.children, function (child) {
    return child.classList && child.classList.contains('gm-target');
  });
}
function itemLabel(item) {
  var target = directTarget(item);
  var text = target && target.querySelector('.gm-text, .gm-label');
  return clean(text ? text.textContent : target && target.textContent);
}
function menuItems(menu) {
  return Array.prototype.filter.call(menu ? menu.children : [], function (child) {
    return child.classList && child.classList.contains('gm-item');
  });
}
function submenuFor(item, labelKey, mobile) {
  if (!item) return null;
  if (!mobile && labelKey === 'display technology') {
    return item.querySelector(':scope > [id^="DADesktopTechnologyMenu-"].da-tech-native-dropdown');
  }
  return Array.prototype.find.call(item.children, function (child) {
    return child.classList && (
      child.classList.contains('gm-submenu') ||
      child.classList.contains('da-vault-panel') ||
      child.classList.contains('da-tech-native-dropdown') ||
      child.classList.contains('da-tech-mobile-submenu') ||
      child.classList.contains('da-collector-native-dropdown') ||
      child.classList.contains('da-about-native-dropdown')
    );
  }) || null;
}
function headingFor(group) {
  var node = group.querySelector('.gm-heading .gm-text, .gm-heading .gm-label, .gm-heading .gm-target');
  return clean(node && node.textContent) || 'System channel';
}
function linksFor(group) {
  return Array.prototype.filter.call(group.querySelectorAll('.gm-links > .gm-item:not(.gm-heading) > .gm-target'), function (link) {
    return link.tagName === 'A' && link.getAttribute('href');
  });
}
function ensureDesktopDisplayDestination(group, entry) {
  var list = group && group.querySelector(':scope > .gm-links');
  if (!list || !entry) return;
  var exists = linksFor(group).some(function (target) {
    var text = target.querySelector('.gm-text, .gm-label');
    return key(text ? text.textContent : target.textContent) === key(entry.label) ||
      target.getAttribute('href') === entry.url;
  });
  if (exists) return;
  var item = document.createElement('li');
  var link = document.createElement('a');
  var text = document.createElement('span');
  item.className = 'gm-item';
  link.className = 'gm-target';
  link.setAttribute('href', entry.url);
  link.setAttribute('title', entry.label);
  link.setAttribute('aria-label', entry.label);
  text.className = 'gm-text';
  text.textContent = entry.label;
  link.appendChild(text);
  item.appendChild(link);
  list.appendChild(item);
}
function groupsFor(panel) {
  return Array.prototype.filter.call(panel.querySelectorAll('.gm-grid-item'), function (group) {
    if (!group.querySelector('.gm-heading')) return false;
    return !group.parentElement.closest('.gm-grid-item');
  });
}
var DISPLAY_GROUP_ORDER = [
  'popular displays',
  'shop by type',
  'classic displays',
  'modern displays',
  'wrestling displays',
  'combat displays',
  'loose figure displays',
  'card protectors',
  'pokemon displays',
  'trading card displays',
  'video game displays',
  'specialty displays'
];
var DISPLAY_RAIL_LABELS = {
  'popular displays': 'Trending',
  'shop by type': 'Shop by Type',
  'classic displays': 'Classic',
  'modern displays': 'Modern',
  'wrestling displays': 'Wrestling',
  'combat displays': 'Combat',
  'loose figure displays': 'Loose Figures',
  'pokemon displays': 'Pokémon',
  'trading card displays': 'Trading Cards',
  'video game displays': 'Video Games',
  'specialty displays': 'Specialty',
  'card protectors': 'Card Protectors'
};
/*
 * Desktop Displays icon language. These are intentionally symbolic DA marks,
 * not franchise logos. Every mark shares one 24px drawing grid and inherits
 * the menu's current colour so existing selected/hover states remain in charge.
 */
var DISPLAY_RAIL_ICONS = {
  'popular displays': 'pulse',
  'shop by brand': 'brand-grid',
  'shop by type': 'stacked-case',
  'classic displays': 'retro-burst',
  'modern displays': 'future-hex',
  'wrestling displays': 'ring',
  'combat displays': 'tactical',
  'loose figure displays': 'figure',
  'card protectors': 'card',
  'pokemon displays': 'capture-orb',
  'trading card displays': 'fanned-cards',
  'video game displays': 'd-pad',
  'specialty displays': 'diamond'
};
var DISPLAY_DESTINATION_ICONS = {
  'batman': 'night-wing',
  'biker mice from mars': 'mouse-wheel',
  "bucky o'hare": 'rabbit-signal',
  'crash dummies': 'crash-target',
  'dc super heroes': 'hero-shield',
  'dc total justice': 'hero-shield',
  'defenders of the earth': 'globe-bolt',
  'dick tracy': 'fedora',
  'fantastic four': 'four-mark',
  'ghostbusters': 'spectral-swirl',
  'jurassic park': 'dino-track',
  'masters of the universe': 'castle-blade',
  'pokemon': 'capture-orb',
  'power rangers': 'lightning-bolt',
  'silverhawks': 'silver-wing',
  'spider man': 'spider-web',
  'star wars': 'twin-sun',
  'super powers': 'cape-shield',
  'teenage mutant ninja turtles': 'shell-grid',
  'thundercats': 'feline-eye',
  'toxic crusaders': 'hazard-drop',
  'transformers': 'robot-mark',
  'visionaries': 'mystic-eye',
  'funko pop': 'figure-head',
  'indiana jones': 'fedora',
  'marvel legends': 'hero-shield',
  'metal gear solid': 'radar-target',
  'simpsons': 'donut',
  'sonic the hedgehog': 'speed-ring',
  'super 7 reaction': 'retro-figure',
  'toony terrors': 'horror-skull',
  'tron': 'identity-disc',
  'wwf hasbro': 'championship'
};
var VAULT_DESTINATION_ICONS = {
  'about': {
    'our story': 'origin',
    'why display armour': 'shield-check',
    'trade & wholesale': 'trade',
    'display systems': 'systems',
    'rewards': 'reward'
  },
  'support': {
    'contact us': 'contact',
    'delivery information': 'delivery',
    'returns': 'returns',
    'warranty': 'shield-check',
    'faqs': 'faq'
  }
};
var COLLECTOR_HUB_CHANNEL_ICONS = {
  'collector guides': 'guide',
  'value guides': 'value',
  'pokémon guides': 'capture-orb',
  'collector community': 'community'
};
function displaySystemIconSvg(iconName) {
  var drawings = {
    'pulse': '<path d="M3 12h4l2.2-5 4.1 10 2.2-5H21"/>',
    'brand-grid': '<rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1"/><rect x="14" y="3.5" width="6.5" height="6.5" rx="1"/><rect x="3.5" y="14" width="6.5" height="6.5" rx="1"/><rect x="14" y="14" width="6.5" height="6.5" rx="1"/>',
    'stacked-case': '<rect x="5" y="4" width="12" height="14" rx="1.5"/><path d="M8 7h12v13H8M5 8h12"/>',
    'retro-burst': '<path d="m12 2 1.8 6.2L20 6l-4.2 5 5.7 3-6.5.5.8 6.5-3.8-5.3L8.2 21l.8-6.5-6.5-.5 5.7-3L4 6l6.2 2.2L12 2Z"/>',
    'future-hex': '<path d="m12 3 7.8 4.5v9L12 21l-7.8-4.5v-9L12 3Z"/><path d="m9 9 3-1.7L15 9v3.5l-3 1.7-3-1.7V9Z"/>',
    'ring': '<path d="M3 7h18M3 12h18M3 17h18M5 4v16M19 4v16"/><path d="M8 7v10M16 7v10"/>',
    'tactical': '<circle cx="12" cy="12" r="6.5"/><circle cx="12" cy="12" r="2"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/>',
    'figure': '<circle cx="12" cy="5" r="2.2"/><path d="M8.5 10 12 8l3.5 2M12 8v7M8 21l4-6 4 6M8.5 10 6 15M15.5 10l2.5 5"/>',
    'card': '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 17h8"/>',
    'capture-orb': '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h5M15.5 12h5"/><circle cx="12" cy="12" r="3.2"/>',
    'fanned-cards': '<rect x="7" y="4" width="11" height="16" rx="1.5"/><path d="m7.5 6-3 1 4.5 13.5M16.5 5l3 1-3 13.5"/>',
    'd-pad': '<path d="M8.5 5h7v3.5H19v7h-3.5V19h-7v-3.5H5v-7h3.5V5Z"/>',
    'diamond': '<path d="m12 3 8 7-8 11-8-11 8-7Z"/><path d="m4 10 8 3 8-3M12 3v10"/>',
    'night-wing': '<path d="M3 8.5 8 10l4-4 4 4 5-1.5-3 7-6 3-6-3-3-7Z"/><path d="m8 10 4 2 4-2"/>',
    'mouse-wheel': '<circle cx="12" cy="13" r="6.5"/><path d="M7.5 8.5 5 4l5 2.5M16.5 8.5 19 4l-5 2.5M9 13h6M12 10v6"/>',
    'rabbit-signal': '<path d="M9.5 9C7 5 8 2.5 9.5 2c2.2 2 2.5 4.7 2.5 7M14.5 9C17 5 16 2.5 14.5 2 12.3 4 12 6.7 12 9"/><path d="M6 14c0-3 2.7-5 6-5s6 2 6 5-2.7 6-6 6-6-3-6-6Z"/>',
    'spectral-swirl': '<path d="M18.5 17.5c-1.4 2-4 3-6.5 2.5-4-.7-6.5-4.2-5.8-8.1.6-3.2 3.5-5.5 6.7-5.3 2.8.2 5 2.3 5 5 0 2.2-1.8 4-4 4-1.8 0-3.2-1.4-3.2-3.1 0-1.4 1.1-2.5 2.5-2.5"/><path d="m17 15 1.5 2.5 2.5-1.5"/>',
    'castle-blade': '<path d="M5 20V8h3V5h3v3h2V5h3v3h3v12H5Z"/><path d="M9 20v-5h6v5M12 3v12"/>',
    'twin-sun': '<circle cx="8" cy="12" r="3.5"/><circle cx="16" cy="12" r="3.5"/><path d="M2.5 18h19M4 6l2 2M20 6l-2 2"/>',
    'shell-grid': '<path d="M12 3c5 0 8 4.2 8 9.3 0 4.7-3.1 8.2-8 8.2s-8-3.5-8-8.2C4 7.2 7 3 12 3Z"/><path d="m12 3-3 5 3 4 3-4-3-5ZM4.5 11l4.5-3M19.5 11 15 8M6 17l6-5 6 5M12 12v8.5"/>',
    'feline-eye': '<path d="M3 12s3.5-5 9-5 9 5 9 5-3.5 5-9 5-9-5-9-5Z"/><path d="m12 8 2 4-2 4-2-4 2-4Z"/>',
    'hazard-drop': '<path d="M12 3c2.7 4.1 6 7.3 6 11a6 6 0 0 1-12 0c0-3.7 3.3-6.9 6-11Z"/><path d="M12 9v5M12 17h.01"/>',
    'championship': '<path d="M3 9h4l2-3h6l2 3h4v6h-4l-2 3H9l-2-3H3V9Z"/><path d="m12 8 1.2 2.4 2.6.4-1.9 1.8.5 2.6-2.4-1.3-2.4 1.3.5-2.6-1.9-1.8 2.6-.4L12 8Z"/>',
    'crash-target': '<circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4M5 5l2.5 2.5M19 5l-2.5 2.5M5 19l2.5-2.5M19 19l-2.5-2.5"/>',
    'hero-shield': '<path d="M12 3 20 6v5c0 4.8-3.2 8.3-8 10-4.8-1.7-8-5.2-8-10V6l8-3Z"/><path d="M8 12h8M12 8v8"/>',
    'globe-bolt': '<circle cx="12" cy="12" r="9"/><path d="M3 12h6M15 12h6M12 3c-2 2.4-3 5-3 7.5M12 21c2-2.4 3-5 3-7.5M13 5l-4 7h4l-2 7"/>',
    'fedora': '<path d="M6 13 8.5 5h7L18 13M4 13h16c1 0 2 .7 2 1.5S21 16 20 16H4c-1 0-2-.7-2-1.5S3 13 4 13Z"/><path d="M7.5 9.5h9"/>',
    'four-mark': '<path d="M15 21V4L5 15h15M8 15l7-8"/>',
    'dino-track': '<path d="M9 20c-3-1.2-4.3-3.7-3.1-6.2C7 11.4 9.3 10 12 10s5 1.4 6.1 3.8C19.3 16.3 18 18.8 15 20c-2 .8-4 .8-6 0Z"/><path d="M7 9 4 5M10 7 9 3M14 7l1-4M17 9l3-4"/>',
    'lightning-bolt': '<path d="m14 2-9 12h7l-2 8 9-12h-7l2-8Z"/>',
    'silver-wing': '<path d="M3 13c5-1 8-4.5 9-9 1 4.5 4 8 9 9-3 1-5.5 3.2-7 7l-2-5-2 5c-1.5-3.8-4-6-7-7Z"/><path d="M7 12h10"/>',
    'spider-web': '<circle cx="12" cy="12" r="9"/><path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4M8 4.2l4 7.8 7.8 4M4.2 16 12 12l4-7.8"/>',
    'cape-shield': '<path d="M12 3 19 6v5c0 4.2-2.7 7.5-7 9-4.3-1.5-7-4.8-7-9V6l7-3Z"/><path d="M8 8c2 1.2 3 3 4 6 1-3 2-4.8 4-6M9 17l3-3 3 3"/>',
    'robot-mark': '<path d="m12 3 7 4v10l-7 4-7-4V7l7-4Z"/><path d="M8 9h8v6H8zM9 11h.01M15 11h.01M10 17h4"/>',
    'mystic-eye': '<path d="M3 12s3.5-5.5 9-5.5 9 5.5 9 5.5-3.5 5.5-9 5.5S3 12 3 12Z"/><circle cx="12" cy="12" r="2.5"/><path d="M12 3v2M12 19v2M3 6l2 1M21 6l-2 1"/>',
    'figure-head': '<circle cx="12" cy="8" r="4"/><path d="M5 21c.7-5 3-7.5 7-7.5S18.3 16 19 21M8 8h.01M16 8h.01"/>',
    'radar-target': '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M12 12l5-5"/>',
    'donut': '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="m7 7 .5.5M16.5 7.5l.5-.5M7 16.5l.5-.5M16.5 16l.5.5M12 5v1M5 12h1M18 12h1M12 18v1"/>',
    'speed-ring': '<circle cx="13" cy="12" r="7"/><path d="M2 7h7M1 12h6M3 17h6"/>',
    'retro-figure': '<rect x="5" y="3" width="14" height="18" rx="2"/><circle cx="12" cy="8" r="2"/><path d="M12 10v5M8.5 12 12 10l3.5 2M9 19l3-4 3 4"/>',
    'horror-skull': '<path d="M5 11a7 7 0 1 1 14 0c0 3-1.5 5-4 6v3H9v-3c-2.5-1-4-3-4-6Z"/><circle cx="9" cy="11" r="1.3"/><circle cx="15" cy="11" r="1.3"/><path d="m12 13-1 2h2l-1-2ZM9 18h6"/>',
    'identity-disc': '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><path d="M12 3v4M12 17v4M3 12h4M17 12h4"/>',
    'single-card': '<rect x="6" y="3" width="12" height="18" rx="2"/><path d="M9 7h6M9 17h6"/>',
    'booster-pack': '<path d="M7 3h10l2 3-1 15H6L5 6l2-3Z"/><path d="M6 7h12M8 11h8M8 17h8"/>',
    'sleeved-pack': '<rect x="5" y="2.5" width="14" height="19" rx="2"/><path d="M8 5h8l1 3-1 10H8L7 8l1-3ZM7 9h10"/>',
    'three-pack': '<rect x="9" y="3" width="10" height="18" rx="1.5"/><path d="M9 5 5 6v15h10M5 8 2 9v12h10"/>',
    'booster-box': '<path d="m4 7 8-4 8 4-8 4-8-4Z"/><path d="M4 7v10l8 4 8-4V7M12 11v10M8 9v4h8V9"/>',
    'desktop-frame': '<rect x="3" y="4" width="18" height="13" rx="1.5"/><path d="M7 7h4v7H7zM13 7h4v7h-4M12 17v4M8 21h8"/>',
    'origin': '<path d="M5 21V4M5 5h12l-3 4 3 4H5"/><circle cx="5" cy="4" r="1.2"/>',
    'shield-check': '<path d="M12 3 20 6v5c0 5-3.4 8.6-8 10-4.6-1.4-8-5-8-10V6l8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/>',
    'trade': '<rect x="3" y="7" width="18" height="12" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2"/>',
    'systems': '<rect x="4" y="4" width="6" height="6" rx=".8"/><rect x="14" y="4" width="6" height="6" rx=".8"/><rect x="4" y="14" width="6" height="6" rx=".8"/><rect x="14" y="14" width="6" height="6" rx=".8"/><path d="M10 7h4M7 10v4M17 10v4M10 17h4"/>',
    'reward': '<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/><circle cx="12" cy="12" r="2.1"/>',
    'contact': '<path d="M4 5h16v11H8l-4 4V5Z"/><path d="M8 9h8M8 12h5"/>',
    'delivery': '<path d="M3 6h11v10H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    'returns': '<path d="M9 7 4 12l5 5"/><path d="M4 12h10a5 5 0 0 1 5 5v2"/><path d="M14 5h5v5"/>',
    'faq': '<path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z"/><path d="M9.5 9a2.5 2.5 0 1 1 4.3 1.8c-.9.8-1.8 1.2-1.8 2.7M12 17h.01"/>',
    'guide': '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21V5.5Z"/><path d="M4 5.5V21M8 7h8M8 11h8"/>',
    'value': '<path d="M4 18v-8M10 18V6M16 18v-4M3 21h18"/><path d="m15 6 3-3 3 3M18 3v8"/>',
    'community': '<circle cx="12" cy="7" r="3"/><circle cx="5" cy="13" r="2"/><circle cx="19" cy="13" r="2"/><path d="M7 21a5 5 0 0 1 10 0M7 13h10M7 13l3-4M17 13l-3-4"/>'
  };
  var drawing = drawings[iconName] || drawings.diamond;
  return '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round">' + drawing + '</svg>';
}
function displaySystemIconNode(iconName, className) {
  var icon = node('span', className);
  icon.setAttribute('aria-hidden', 'true');
  icon.innerHTML = displaySystemIconSvg(iconName);
  return icon;
}
function displayRailIconName(value) {
  return DISPLAY_RAIL_ICONS[displayRailKey(value)] || 'diamond';
}
function displayDestinationIconName(value, channelTitle) {
  var destination = desktopDisplayDestinationIdentity(value);
  var channel = displayRailKey(channelTitle);
  if (DISPLAY_DESTINATION_ICONS[destination]) return DISPLAY_DESTINATION_ICONS[destination];
  if (/(?:desktop|display)\s+(?:card\s+)?frame|\b[369][ -]card\b/.test(destination)) return 'desktop-frame';
  if (/sleeved\s+booster/.test(destination)) return 'sleeved-pack';
  if (/(?:3|three)[ -]pack/.test(destination)) return 'three-pack';
  if (/booster\s+box|elite\s+trainer\s+box|\betb\b/.test(destination)) return 'booster-box';
  if (/booster\s+pack/.test(destination)) return 'booster-pack';
  if (/single\s+card/.test(destination)) return 'single-card';
  if (/spider/.test(destination)) return 'spider-web';
  if (/sonic/.test(destination)) return 'speed-ring';
  if (/transformer/.test(destination)) return 'robot-mark';
  if (/jurassic|dinosaur/.test(destination)) return 'dino-track';
  if (/ghost/.test(destination)) return 'spectral-swirl';
  if (/simpson|donut/.test(destination)) return 'donut';
  if (/indiana|dick tracy|fedora/.test(destination)) return 'fedora';
  if (/power ranger/.test(destination)) return 'lightning-bolt';
  if (/metal gear|radar/.test(destination)) return 'radar-target';
  if (/toony|terror|horror/.test(destination)) return 'horror-skull';
  if (/tron/.test(destination)) return 'identity-disc';
  if (/pokemon/.test(destination)) return 'capture-orb';
  if (/(?:trading card|deck|toploader|card saver|sleeve)/.test(destination)) return 'single-card';
  if (/(?:video game|nintendo|nes|snes|sega|playstation|xbox)/.test(destination)) return 'd-pad';
  if (/(?:wrestl|wwf|wwe|hasbro|jakks)/.test(destination)) return 'championship';
  if (/(?:loose|figure)/.test(destination)) return 'figure';
  if (/(?:protector|carded|moc)/.test(destination)) return 'card';
  if (/(?:combat|g\.i\. joe|gi joe|action force)/.test(destination)) return 'tactical';
  if (channel === 'shop by brand') return 'brand-grid';
  return displayRailIconName(channelTitle);
}
function vaultDestinationIconName(labelKey, value) {
  var menuIcons = VAULT_DESTINATION_ICONS[labelKey];
  return menuIcons && menuIcons[key(value)] || '';
}
function collectorHubChannelIconName(value) {
  return COLLECTOR_HUB_CHANNEL_ICONS[key(value)] || '';
}
function vaultRailIconName(labelKey, value) {
  if (labelKey === 'collector hub') return collectorHubChannelIconName(value);
  if (labelKey === 'about') return 'shield-check';
  if (labelKey === 'support') return 'contact';
  return '';
}
// Fixed desktop stage labels; independent of channel ordering and status-box copy.
var DISPLAY_STAGE_LABELS = {
  'popular displays': 'TREND SIGNAL 01',
  'shop by brand': 'BRAND INDEX 02',
  'shop by type': 'FORMAT INDEX 03',
  'classic displays': 'ARCHIVE CHANNEL 04',
  'modern displays': 'MODERN ERA 05',
  'wrestling displays': 'RINGSIDE CHANNEL 06',
  'combat displays': 'TACTICAL CHANNEL 07',
  'loose figure displays': 'LOOSE SERIES 08',
  'card protectors': 'PROTECTOR SERIES 09',
  'pokemon displays': 'TRAINER CHANNEL 10',
  'trading card displays': 'TCG CHANNEL 11',
  'video game displays': 'GAME VAULT 12',
  'specialty displays': 'SPECIAL OPS 13'
};
// Desktop showcase assets only; Wrestling keeps its dedicated image, Specialty its radar.
var DISPLAY_COLLECTION_IMAGES = {
  'popular displays': 'group-shot-2026-main-banner.png',
  'shop by brand': 'tmnt-display-case-acrylic-display-armour.png',
  'shop by type': 'trading-cards-triple-booster-pack-front-side-banner.png',
  'classic displays': 'action-figure-acrylic-display-cases-display-armour-banner.png',
  'modern displays': 'super7-group-banner.png',
  'combat displays': 'COMBAT-GROUP-MAIN-BANNER.png',
  'loose figure displays': 'loose-action-figure-display-case-display-armour-v2.png',
  'card protectors': 'protector_series_logo.png',
  'pokemon displays': 'pokemon-group-bannerv3.png',
  'trading card displays': 'trading-cards-triple-booster-pack-front-side-banner.png',
  'video game displays': 'SNES_logo_svg.png'
};
function displayRailKey(value) {
  return key(value)
    .replace(/pokémon/g, 'pokemon')
    .replace(/^trading cards$/, 'trading card displays')
    .replace(/\s+cases$/, ' displays');
}
var DISPLAY_CHANNEL_TITLES = {
  'popular displays': 'Popular Displays',
  'shop by type': 'Shop by Type',
  'classic displays': 'Classic Displays',
  'modern displays': 'Modern Displays',
  'wrestling displays': 'Wrestling Displays',
  'combat displays': 'Combat Displays',
  'loose figure displays': 'Loose Figure Displays',
  'pokemon displays': 'Pokémon Displays',
  'trading card displays': 'Trading Card Displays',
  'video game displays': 'Video Game Displays',
  'specialty displays': 'Specialty Displays',
  'card protectors': 'Card Protectors'
};
function displayChannelTitle(value) {
  return DISPLAY_CHANNEL_TITLES[displayRailKey(value)] || value;
}
function displayRailLabel(value) {
  return DISPLAY_RAIL_LABELS[displayRailKey(value)] || displayIndexTitleCase(value);
}
function displayRailGroup(value) {
  var channelKey = displayRailKey(value);
  if (['popular displays', 'shop by type'].indexOf(channelKey) !== -1) return 'browse';
  if ([
    'pokemon displays',
    'trading card displays',
    'video game displays',
    'specialty displays'
  ].indexOf(channelKey) !== -1) return 'collectible';
  return 'action';
}
var DISPLAY_CHANNEL_TITLE_LINKS = {
  'popular displays': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'shop by brand': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'shop by type': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'classic displays': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'modern displays': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'pokemon displays': 'https://displayarmour.co.uk/collections/pokemon-acrylic-display-cases',
  'trading card displays': 'https://displayarmour.co.uk/collections/trading-card-display-cases',
  'combat displays': 'https://displayarmour.co.uk/collections/combat-action-figure-display-cases',
  'wrestling displays': 'https://displayarmour.co.uk/collections/display-armour-wrestling-acrylic-display-cases',
  'loose figure displays': 'https://displayarmour.co.uk/collections/loose-action-figure-display-cases-collections',
  'video game displays': 'https://displayarmour.co.uk/collections/video-game-display-cases',
  'specialty displays': 'https://displayarmour.co.uk/pages/action-figure-display-cases-collections',
  'card protectors': 'https://displayarmour.co.uk/collections/protector-series-moc-card-protectors'
};
function orderedDisplayGroups(groups) {
  var remaining = groups.slice();
  var ordered = [];
  DISPLAY_GROUP_ORDER.forEach(function (wanted) {
    var matchIndex = remaining.findIndex(function (group) {
      var groupKey = displayRailKey(headingFor(group));
      return groupKey === wanted;
    });
    if (matchIndex === -1) return;
    ordered.push(remaining.splice(matchIndex, 1)[0]);
  });
  return ordered.concat(remaining);
}
var DESKTOP_POPULAR_TAXONOMY = [
  { name: 'Teenage Mutant Ninja Turtles', home: 'classic displays' },
  { name: 'Star Wars', home: 'classic displays' },
  { name: 'WWF Hasbro', home: 'wrestling displays' },
  { name: 'Pokemon', label: 'Pokémon', home: 'pokemon displays' },
  { name: 'Masters of the Universe', home: 'classic displays' },
  { name: 'Ghostbusters', home: 'classic displays' },
  { name: 'Batman', home: 'classic displays' },
  { name: 'Thundercats', label: 'ThunderCats', home: 'classic displays' },
  { name: 'Biker Mice From Mars', home: 'classic displays' },
  { name: "Bucky O'Hare", home: 'classic displays' },
  { name: 'Toxic Crusaders', home: 'classic displays' }
];
function desktopDisplayDestinationIdentity(value) {
  return key(value)
    .replace(/[’]/g, "'")
    .replace(/[-–—]/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^crash test dummies$/, 'crash dummies')
    .replace(/^super7 reaction$/, 'super 7 reaction')
    .replace(/^the simpsons$/, 'simpsons')
    .replace('pokémon', 'pokemon')
    .trim();
}
function ensureDesktopDisplayTaxonomy(panel) {
  if (!panel || panel.dataset.daDesktopDisplayTaxonomyReady === 'true') return;
  var groups = groupsFor(panel);
  var groupsByKey = Object.create(null);
  groups.forEach(function (group) {
    groupsByKey[displayRailKey(headingFor(group))] = group;
  });
  var popularGroup = groupsByKey['popular displays'];
  var classicGroup = groupsByKey['classic displays'];
  var modernGroup = groupsByKey['modern displays'];
  var wrestlingGroup = groupsByKey['wrestling displays'];
  var pokemonGroup = groupsByKey['pokemon displays'];
  if (!popularGroup || !classicGroup || !modernGroup || !wrestlingGroup || !pokemonGroup) return;

  DESKTOP_ADDITIONAL_DISPLAY_DESTINATIONS.forEach(function (entry) {
    ensureDesktopDisplayDestination(
      entry.home === 'classic displays' ? classicGroup : modernGroup,
      entry
    );
  });

  function destinationName(link) {
    var text = link && link.querySelector('.gm-text, .gm-label');
    var label = text ? text.textContent : link && link.textContent;
    return desktopDisplayDestinationIdentity(canonicalDirectoryName(label) || label);
  }
  function destinationLink(group, name) {
    var wanted = desktopDisplayDestinationIdentity(name);
    return linksFor(group).find(function (link) {
      return destinationName(link) === wanted;
    }) || null;
  }
  function groupList(group) {
    return group && group.querySelector(':scope > .gm-links');
  }
  function setDestinationLabel(link, label) {
    if (!link || !label) return;
    var text = link.querySelector('.gm-text, .gm-label');
    if (text) text.textContent = label;
    link.title = label;
    if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', label);
  }
  function clonePopularDestination(sourceLink, destinationGroup, label) {
    var list = groupList(destinationGroup);
    var sourceItem = sourceLink && sourceLink.closest('.gm-item');
    if (!list || !sourceItem) return null;
    var clone = sourceItem.cloneNode(true);
    clone.querySelectorAll('.da-vault__display-arrow').forEach(function (arrow) { arrow.remove(); });
    clone.querySelectorAll('[data-davo-index], [data-davo-channel]').forEach(function (element) {
      element.removeAttribute('data-davo-index');
      element.removeAttribute('data-davo-channel');
      element.classList.remove('da-vault__display-destination', 'da-vault__global-destination');
    });
    var cloneLink = clone.querySelector(':scope > .gm-target');
    setDestinationLabel(cloneLink, label);
    list.appendChild(clone);
    return cloneLink;
  }

  DESKTOP_POPULAR_TAXONOMY.forEach(function (entry) {
    var sourceLink = destinationLink(popularGroup, entry.name);
    var destinationGroup = groupsByKey[entry.home];
    if (!sourceLink || !destinationGroup || destinationLink(destinationGroup, entry.name)) return;
    clonePopularDestination(sourceLink, destinationGroup, entry.label || entry.name);
  });

  function moveDestination(name, sourceGroup, destinationGroup) {
    var sourceLink = destinationLink(sourceGroup, name);
    var destinationLinkMatch = destinationLink(destinationGroup, name);
    var sourceItem = sourceLink && sourceLink.closest('.gm-item');
    var destinationItem = destinationLinkMatch && destinationLinkMatch.closest('.gm-item');
    var destinationList = groupList(destinationGroup);
    if (!sourceItem || !destinationList) return;
    if (destinationItem) destinationItem.replaceWith(sourceItem);
    else destinationList.appendChild(sourceItem);
  }

  ['Crash Dummies', 'DC Total Justice', 'Fantastic Four', 'Spider Man', 'X-Men'].forEach(function (name) {
    moveDestination(name, modernGroup, classicGroup);
  });
  moveDestination('The Simpsons', classicGroup, modernGroup);
  panel.dataset.daDesktopDisplayTaxonomyReady = 'true';
}
var DESKTOP_CLASSIC_DESTINATION_ORDER = [
  'a team',
  'batman',
  'biker mice from mars',
  "bucky o'hare",
  'crash dummies',
  'dc super heroes',
  'dc total justice',
  'defenders of the earth',
  'dick tracy',
  'fantastic four',
  'ghostbusters',
  'jurassic park',
  'masters of the universe',
  'power rangers',
  'silverhawks',
  'spider man',
  'star wars',
  'super powers',
  'teenage mutant ninja turtles',
  'thundercats',
  'toxic crusaders',
  'transformers',
  'visionaries',
  'x men'
];
var DESKTOP_POPULAR_DESTINATION_ORDER = [
  'batman',
  'biker mice from mars',
  "bucky o'hare",
  'ghostbusters',
  'masters of the universe',
  'pokemon',
  'star wars',
  'teenage mutant ninja turtles',
  'thundercats',
  'toxic crusaders',
  'wwf hasbro'
];
function sortDesktopActionDisplayDestinations(panel) {
  if (!panel || panel.dataset.daDesktopActionDestinationsSorted === 'true') return;
  var actionGroups = [
    'classic displays',
    'modern displays',
    'wrestling displays',
    'combat displays',
    'loose figure displays',
    'card protectors'
  ];
  function destinationLabel(item) {
    var target = item.querySelector(':scope > .gm-target');
    var text = target && target.querySelector('.gm-text, .gm-label');
    return desktopDisplayDestinationIdentity(text ? text.textContent : target && target.textContent);
  }
  function alphabeticalKey(label) {
    return label.replace(/^the\s+/, '');
  }
  groupsFor(panel).forEach(function (group) {
    var channelKey = displayRailKey(headingFor(group));
    if (channelKey !== 'popular displays' && actionGroups.indexOf(channelKey) === -1) return;
    var list = group.querySelector(':scope > .gm-links');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (item) {
      return item.classList && item.classList.contains('gm-item') &&
        !item.classList.contains('gm-heading') && item.querySelector(':scope > .gm-target[href]');
    });
    items.sort(function (a, b) {
      var aLabel = destinationLabel(a);
      var bLabel = destinationLabel(b);
      if (channelKey === 'popular displays') {
        return DESKTOP_POPULAR_DESTINATION_ORDER.indexOf(aLabel) -
          DESKTOP_POPULAR_DESTINATION_ORDER.indexOf(bLabel);
      }
      if (channelKey === 'classic displays') {
        var aIndex = DESKTOP_CLASSIC_DESTINATION_ORDER.indexOf(aLabel);
        var bIndex = DESKTOP_CLASSIC_DESTINATION_ORDER.indexOf(bLabel);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      }
      return alphabeticalKey(aLabel).localeCompare(
        alphabeticalKey(bLabel),
        'en-GB',
        { sensitivity: 'base', numeric: true }
      );
    });
    items.forEach(function (item) { list.appendChild(item); });
  });
  panel.dataset.daDesktopActionDestinationsSorted = 'true';
}
function removeDuplicatePokemonTypeLinks(panel) {
  if (!panel) return;
  groupsFor(panel).forEach(function (group) {
    if (key(headingFor(group)) !== 'shop by type') return;
    var foundPokemon = false;
    linksFor(group).forEach(function (link) {
      var linkName = key((link.querySelector('.gm-text, .gm-label') || link).textContent).replace(/pokémon/g, 'pokemon');
      if (!/^pokemon (?:cases|displays)$/.test(linkName)) return;
      if (!foundPokemon) {
        foundPokemon = true;
        return;
      }
      var item = link.closest('.gm-item');
      if (item) item.remove();
    });
  });
}
function node(tag, className, text) {
  var element = document.createElement(tag);
  if (className) element.className = className;
  if (typeof text === 'string') element.textContent = text;
  return element;
}
function addDisplayStageTitleLink(stageTitle, title) {
  var titleKey = displayRailKey(title);
  var url = DISPLAY_CHANNEL_TITLE_LINKS[titleKey];
  if (!stageTitle || !url) return;
  var link = node('a', 'da-vault__stage-title-link');
  var arrow = node('span', 'da-vault__stage-title-arrow', '→');
  link.setAttribute('href', url);
  link.appendChild(document.createTextNode(title + ' '));
  arrow.setAttribute('aria-hidden', 'true');
  link.appendChild(arrow);
  stageTitle.textContent = '';
  stageTitle.appendChild(link);
}
function directoryLetter(name) {
  var match = clean(name).toLocaleUpperCase('en-GB').match(/[A-Z]/);
  return match ? match[0] : '#';
}
var DIRECTORY_BRANDS = [
  ['Action Force', /\baction force\b/i],
  ['Batman', /\bbatman\b/i],
  ['Biker Mice From Mars', /\bbiker mice(?: from mars)?\b/i],
  ["Bucky O'Hare", /\bbucky o[’']?hare\b/i],
  ['Crash Test Dummies', /\bcrash test dumm(?:y|ies)\b/i],
  ['DC Super Heroes', /\bdc super heroes?\b/i],
  ['DC Total Justice', /\b(?:dc )?total justice\b/i],
  ['Defenders of the Earth', /\bdefenders of (?:the )?earth\b/i],
  ['Dick Tracy', /\bdick tracy\b/i],
  ['Ghostbusters', /\bghostbusters?\b/i],
  ['G.I. Joe', /\b(?:g\.?i\.?|gi) joe\b/i],
  ['Jurassic Park', /\bjurassic park\b/i],
  ['M.A.S.K.', /\bm\.?a\.?s\.?k\.?\b/i],
  ['Masters of the Universe', /\b(?:masters of the universe|motu)\b/i],
  ['Pokemon', /\bpok[eé]mon\b/i],
  ['Power Rangers', /\bpower rangers?\b/i],
  ['RoboCop', /\brobo\s?cop\b/i],
  ['SilverHawks', /\bsilver\s?hawks\b/i],
  ['Simpsons', /\b(?:the )?simpsons\b/i],
  ['Sonic The Hedgehog', /\bsonic(?: the hedgehog)?\b/i],
  ['Spider-Man', /\bspider[ -]?man\b/i],
  ['Star Wars', /\bstar wars\b/i],
  ['Super7 ReAction', /\b(?:super\s?7\s*)?reaction\b/i],
  ['Super Powers', /\bsuper powers\b/i],
  ['Teenage Mutant Ninja Turtles', /\b(?:teenage mutant ninja turtles|tmnt)\b/i],
  ['Terminator', /\bterminator\b/i],
  ['Thundercats', /\bthunder\s?cats\b/i],
  ['Toxic Crusaders', /\btoxic crusaders?\b/i],
  ['Transformers', /\btransformers?\b/i],
  ['Visionaries', /\bvisionaries\b/i],
  ['WWF Hasbro', /\b(?:wwf|wwe) hasbro\b/i]
];
var DIRECTORY_BROAD = {
  'pokemon': 'Pokemon',
  'pokemon cases': 'Pokemon',
  'pokemon displays': 'Pokemon',
  'loose figure cases': 'Loose Figure Displays',
  'loose figure displays': 'Loose Figure Displays'
};
var DIRECTORY_FORMAT_CLUTTER = /\b(card frames?|card protectors?|single cards?|sleeved booster(?: packs?)?|booster packs?|collector tins?|elite trainer box(?:es)?|graded cards?|toploaders?|one[ -]?touch|magnetic holders?|slabs?|case depths?|shop by (?:case )?type|display box(?:es)?|acrylic box(?:es)?)\b|\b\d+(?:\.\d+)?\s*(?:mm|cm|inch|inches)\b/i;
function canonicalDirectoryName(name) {
  var cleaned = clean(name).replace(/Pokémon/g, 'Pokemon');
  if (/^(?:carded|video game) (?:cases|displays)$/i.test(cleaned)) return '';
  var broad = DIRECTORY_BROAD[key(cleaned)];
  if (broad) return broad;
  for (var brandIndex = 0; brandIndex < DIRECTORY_BRANDS.length; brandIndex += 1) {
    if (DIRECTORY_BRANDS[brandIndex][1].test(cleaned)) return DIRECTORY_BRANDS[brandIndex][0];
  }
  if (DIRECTORY_FORMAT_CLUTTER.test(cleaned) || /\b(deep|regular|standard) bubble\b/i.test(cleaned)) return '';
  cleaned = cleaned
    .replace(/\s*[–—|-]\s*(?:display cases?|displays?|cases?|collection)$/i, '')
    .replace(/\s+(?:display cases?|displays?|cases?|collection)$/i, '')
    .trim();
  if (!cleaned || /^(?:cases?|displays?|action figures?|carded figures?|accessories)$/i.test(cleaned)) return '';
  return cleaned;
}
function directoryHubScore(rawName, canonicalName, href) {
  var rawKey = key(rawName).replace(/pokémon/g, 'pokemon');
  var canonicalKey = key(canonicalName);
  var score = rawKey === canonicalKey ? 1000 : 0;
  if (rawKey === canonicalKey + ' cases' || rawKey === canonicalKey + ' displays' || rawKey === canonicalKey + ' display cases') score += 700;
  if (/\/(?:collections|pages)\/[^/?#]+\/?(?:[?#].*)?$/i.test(href || '')) score += 40;
  if (/\b(kenner|tvc|retro|moc|deep|regular|standard|deluxe|single|double|pack|size|depth)\b/i.test(rawName)) score -= 120;
  return score - rawName.length - (href || '').length / 10;
}
function directoryEntriesFor(groups) {
  var entriesByName = Object.create(null);
  function consider(link, forcedName) {
    if (!link || link.tagName !== 'A') return;
    var nameNode = link.querySelector('.gm-text, .gm-label');
    var rawName = clean(nameNode ? nameNode.textContent : link.textContent);
    var href = link.getAttribute('href');
    var name = forcedName || canonicalDirectoryName(rawName);
    if (!name || !href || href === '#' || /^javascript:/i.test(href)) return;
    var identity = key(name);
    var score = directoryHubScore(rawName, name, href);
    if (entriesByName[identity] && entriesByName[identity].score >= score) return;
    entriesByName[identity] = {
      name: name,
      href: href,
      target: link.getAttribute('target') || '',
      rel: link.getAttribute('rel') || '',
      score: score
    };
  }
  groups.forEach(function (group) {
    var groupName = headingFor(group);
    var groupKey = key(groupName).replace(/pokémon/g, 'pokemon');
    var broadGroupName = DIRECTORY_BROAD[groupKey];
    var headingLink = group.querySelector('.gm-heading .gm-target[href]');
    if (groupKey === 'trading card displays') {
      consider(
        headingLink || linksFor(group).find(function (link) {
          return link.getAttribute('href') === TRADING_CARD_COLLECTION_URL ||
            link.getAttribute('href') === '/collections/trading-card-display-cases';
        }),
        'Trading Card Displays'
      );
      return;
    }
    if (broadGroupName) consider(headingLink, broadGroupName);
    linksFor(group).forEach(function (link) {
      var linkNameNode = link.querySelector('.gm-text, .gm-label');
      var linkName = clean(linkNameNode ? linkNameNode.textContent : link.textContent);
      var allowedBroad = DIRECTORY_BROAD[key(linkName).replace(/pokémon/g, 'pokemon')];
      if (/^(?:card protectors?|shop by type|pokemon (?:cases|displays)|loose figure (?:cases|displays))$/i.test(groupKey) && !allowedBroad) return;
      consider(link, allowedBroad || '');
    });
  });
  return Object.keys(entriesByName).map(function (identity) { return entriesByName[identity]; }).sort(function (a, b) {
    return a.name.localeCompare(b.name, 'en-GB', { sensitivity: 'base', numeric: true });
  });
}
function groupedDirectoryEntries(entries) {
  return entries.reduce(function (groups, entry) {
    var letter = directoryLetter(entry.name);
    if (!groups[letter]) groups[letter] = [];
    groups[letter].push(entry);
    return groups;
  }, Object.create(null));
}
function appendDirectoryGroups(container, grouped, classPrefix, idPrefix) {
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('').forEach(function (letter) {
    if (!grouped[letter] || !grouped[letter].length) return;
    var group = node('section', classPrefix + '__group');
    var heading = node('h4', classPrefix + '__heading', letter);
    heading.id = idPrefix + '-letter-' + (letter === '#' ? 'other' : letter.toLocaleLowerCase('en-GB'));
    group.appendChild(heading);
    grouped[letter].forEach(function (entry) {
      var link = node('a', classPrefix + '__link', entry.name);
      link.setAttribute('href', entry.href);
      if (entry.target) link.setAttribute('target', entry.target);
      if (entry.rel) link.setAttribute('rel', entry.rel);
      group.appendChild(link);
    });
    container.appendChild(group);
  });
}
function scrollWithin(owner, target, offset) {
  if (!owner || !target) return;
  var ownerBox = owner.getBoundingClientRect();
  var targetBox = target.getBoundingClientRect();
  // Use an immediate native jump. Safari can cancel an in-progress smooth
  // scroll when the surrounding mega-menu is measured again after focus.
  owner.scrollTop = owner.scrollTop + targetBox.top - ownerBox.top - (offset || 0);
}
function appendAlphabetNavigation(container, grouped, className, idPrefix, scrollOwnerFor) {
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter) {
    var button = node('button', className, letter);
    var available = !!(grouped[letter] && grouped[letter].length);
    button.type = 'button';
    button.disabled = !available;
    button.setAttribute('aria-disabled', available ? 'false' : 'true');
    if (available) {
      button.setAttribute('aria-label', 'Jump to collections beginning with ' + letter);
      button.addEventListener('click', function () {
        var target = document.getElementById(idPrefix + '-letter-' + letter.toLocaleLowerCase('en-GB'));
        scrollWithin(scrollOwnerFor(), target, 6);
      });
    }
    container.appendChild(button);
  });
}
function bindDirectoryScrollbar(scroll, track, thumb) {
  if (!scroll || !track || !thumb) return;
  var dragging = false;
  var dragStartY = 0;
  var dragStartScroll = 0;

  function measurements() {
    var maxScroll = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
    var trackHeight = track.clientHeight;
    var thumbHeight = maxScroll > 0
      ? Math.max(42, Math.round(trackHeight * (scroll.clientHeight / scroll.scrollHeight)))
      : trackHeight;
    var travel = Math.max(0, trackHeight - thumbHeight);
    return { maxScroll: maxScroll, trackHeight: trackHeight, thumbHeight: thumbHeight, travel: travel };
  }

  function sync() {
    var data = measurements();
    var top = data.maxScroll > 0 && data.travel > 0
      ? Math.round((scroll.scrollTop / data.maxScroll) * data.travel)
      : 0;
    track.hidden = data.maxScroll <= 1;
    thumb.style.height = data.thumbHeight + 'px';
    // The header animation system uses several transform rules. Move the
    // scrollbar thumb with top instead so its position cannot be overridden.
    thumb.style.removeProperty('transform');
    thumb.style.setProperty('top', top + 'px', 'important');
    thumb.setAttribute('aria-valuemin', '0');
    thumb.setAttribute('aria-valuemax', String(Math.round(data.maxScroll)));
    thumb.setAttribute('aria-valuenow', String(Math.round(scroll.scrollTop)));
  }

  function endDrag(event) {
    if (!dragging) return;
    dragging = false;
    thumb.classList.remove('is-dragging');
    if (event && thumb.hasPointerCapture && thumb.hasPointerCapture(event.pointerId)) {
      thumb.releasePointerCapture(event.pointerId);
    }
  }

  thumb.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation();
    dragging = true;
    dragStartY = event.clientY;
    dragStartScroll = scroll.scrollTop;
    thumb.classList.add('is-dragging');
    if (thumb.setPointerCapture) thumb.setPointerCapture(event.pointerId);
  });
  thumb.addEventListener('pointermove', function (event) {
    if (!dragging) return;
    event.preventDefault();
    event.stopPropagation();
    var data = measurements();
    if (data.travel <= 0) return;
    scroll.scrollTop = dragStartScroll + ((event.clientY - dragStartY) * data.maxScroll / data.travel);
  });
  thumb.addEventListener('pointerup', endDrag);
  thumb.addEventListener('pointercancel', endDrag);
  thumb.addEventListener('lostpointercapture', function () {
    dragging = false;
    thumb.classList.remove('is-dragging');
  });
  thumb.addEventListener('keydown', function (event) {
    var amount = 0;
    if (event.key === 'ArrowDown') amount = 48;
    else if (event.key === 'ArrowUp') amount = -48;
    else if (event.key === 'PageDown') amount = scroll.clientHeight * 0.8;
    else if (event.key === 'PageUp') amount = -scroll.clientHeight * 0.8;
    else if (event.key === 'Home') scroll.scrollTop = 0;
    else if (event.key === 'End') scroll.scrollTop = scroll.scrollHeight;
    else return;
    event.preventDefault();
    event.stopPropagation();
    if (amount) scroll.scrollTop += amount;
  });
  track.addEventListener('pointerdown', function (event) {
    if (event.target === thumb || event.button !== 0) return;
    event.preventDefault();
    event.stopPropagation();
    var data = measurements();
    if (data.travel <= 0) return;
    var box = track.getBoundingClientRect();
    var thumbTop = Math.max(0, Math.min(data.travel, event.clientY - box.top - (data.thumbHeight / 2)));
    scroll.scrollTop = (thumbTop / data.travel) * data.maxScroll;
  });
  scroll.addEventListener('wheel', function (event) {
    if (scroll.scrollHeight <= scroll.clientHeight) return;
    if (!event.deltaY) return;
    // Drive the same scrollTop used by the working draggable thumb instead of
    // leaving WebKit to resolve nested native momentum. Safari can otherwise
    // hand the gesture back to the mega-menu and snap the directory upwards.
    var multiplier = event.deltaMode === 1
      ? 16
      : event.deltaMode === 2
        ? scroll.clientHeight
        : 1;
    var maxScroll = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
    var nextScroll = Math.max(0, Math.min(maxScroll, scroll.scrollTop + (event.deltaY * multiplier)));
    event.preventDefault();
    event.stopPropagation();
    scroll.scrollTop = nextScroll;
  }, { passive: false, capture: true });
  scroll.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(sync);
    resizeObserver.observe(scroll);
  }
  window.requestAnimationFrame(sync);
}
function buildDisplaysDirectoryChannel(vault, rail, chamber, vaultId, entries, index) {
  var grouped = groupedDirectoryEntries(entries);
  var tabId = vaultId + '-tab-' + index;
  var stageId = vaultId + '-stage-' + index;
  var directoryId = vaultId + '-directory';
  var tab = node('button', 'da-vault__tab');
  var number = displaySystemIconNode('brand-grid', 'da-vault__tab-icon');
  var tabText = node('span', 'da-vault__tab-label', 'Shop by Brand');
  var signal = node('span', 'da-vault__tab-signal');
  var stage = node('section', 'da-vault__stage da-vault__stage--directory');
  var stageHeader = node('header', 'da-vault__stage-header');
  var stageKicker = node('span', 'da-vault__stage-kicker', DISPLAY_STAGE_LABELS['shop by brand']);
  var stageTitle = node('h3', 'da-vault__stage-title', 'Shop by Brand');
  addDisplayStageTitleLink(stageTitle, 'Shop by Brand');
  var alphabet = node('nav', 'da-vault__directory-alpha');
  var scrollFrame = node('div', 'da-vault__directory-scroll-frame');
  var scroll = node('div', 'da-vault__directory-scroll');
  var grid = node('div', 'da-vault__directory-grid');
  var scrollbar = node('div', 'da-vault__directory-scrollbar');
  var scrollbarThumb = node('span', 'da-vault__directory-scrollbar-thumb');
  tab.type = 'button';
  tab.id = tabId;
  tab.setAttribute('role', 'tab');
  tab.setAttribute('aria-controls', stageId);
  tab.setAttribute('aria-selected', 'false');
  tab.tabIndex = -1;
  tab.dataset.channelTitle = 'Shop by Brand';
  tab.dataset.channelFooterTitle = 'All Displays';
  tab.dataset.channelCount = String(entries.length);
  tab.dataset.channelDescription = 'Browse Display Armour collections by brand and franchise from A–Z.';
  tab.dataset.channelCountLabel = 'COLLECTIONS';
  tab.dataset.channelMode = 'BRAND';
  tab.dataset.channelModeLabel = 'DIRECTORY';
  tab.appendChild(number);
  tab.appendChild(tabText);
  tab.appendChild(signal);
  stage.id = stageId;
  stage.setAttribute('role', 'tabpanel');
  stage.setAttribute('aria-labelledby', tabId);
  stage.setAttribute('aria-hidden', 'true');
  stage.hidden = true;
  stageHeader.appendChild(stageKicker);
  stageHeader.appendChild(stageTitle);
  alphabet.setAttribute('aria-label', 'Shop by Brand alphabet');
  scroll.tabIndex = 0;
  scroll.setAttribute('aria-label', 'Display Armour brands and franchises from A to Z');
  scrollbar.setAttribute('aria-hidden', 'false');
  scrollbarThumb.tabIndex = 0;
  scrollbarThumb.setAttribute('role', 'scrollbar');
  scrollbarThumb.setAttribute('aria-controls', directoryId + '-scroll');
  scrollbarThumb.setAttribute('aria-orientation', 'vertical');
  scrollbarThumb.setAttribute('aria-label', 'Scroll brand directory');
  scroll.id = directoryId + '-scroll';
  appendDirectoryGroups(grid, grouped, 'da-vault__directory', directoryId);
  scroll.appendChild(grid);
  scrollbar.appendChild(scrollbarThumb);
  scrollFrame.appendChild(scroll);
  scrollFrame.appendChild(scrollbar);
  appendAlphabetNavigation(alphabet, grouped, 'da-vault__directory-letter', directoryId, function () { return scroll; });
  stage.appendChild(stageHeader);
  stage.appendChild(alphabet);
  stage.appendChild(scrollFrame);
  rail.appendChild(tab);
  chamber.appendChild(stage);
  bindDirectoryScrollbar(scroll, scrollbar, scrollbarThumb);
  tab.addEventListener('click', function () { activate(vault, index, false); });
  tab.addEventListener('pointerenter', function (event) {
    if (event.pointerType !== 'touch') activate(vault, index, false);
  });
}
function findScrollOwner(element) {
  var current = element && element.parentElement;
  while (current && current !== document.body) {
    var overflowY = window.getComputedStyle(current).overflowY;
    if (/(auto|scroll)/.test(overflowY)) return current;
    current = current.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}
function buildMobileShopByBrandDirectory(menu) {
  if (!menu) return;
  var item = menuItems(menu).find(function (candidate) { return key(itemLabel(candidate)) === 'shop by brand'; });
  var panel = submenuFor(item, 'displays', true);
  if (!panel || panel.dataset.daMobileDirectoryReady === 'true') return;
  var groups = groupsFor(panel);
  var entries = directoryEntriesFor(groups);
  DESKTOP_ADDITIONAL_DISPLAY_DESTINATIONS.forEach(function (destination) {
    var exists = entries.some(function (entry) {
      return key(entry.name) === key(destination.label) || entry.href === destination.url;
    });
    if (!exists) {
      entries.push({
        name: destination.label,
        href: destination.url,
        target: '',
        rel: '',
        score: 1000
      });
    }
  });
  entries.sort(function (a, b) {
    return a.name.localeCompare(b.name, 'en-GB', { sensitivity: 'base', numeric: true });
  });
  if (!entries.length) return;
  panel.dataset.daMobileDirectoryReady = 'true';
  var grouped = groupedDirectoryEntries(entries);
  var idPrefix = 'DAMobileDirectory-' + Math.random().toString(36).slice(2, 9);
  var body = node('div', 'da-mobile-display-directory da-mobile-display-directory__body');
  var alphabet = node('nav', 'da-mobile-display-directory__alpha');
  var list = node('div', 'da-mobile-display-directory__list');
  alphabet.setAttribute('aria-label', 'Shop by Brand alphabet');
  appendDirectoryGroups(list, grouped, 'da-mobile-display-directory', idPrefix);
  appendAlphabetNavigation(alphabet, grouped, '', idPrefix, function () { return findScrollOwner(panel); });
  body.appendChild(alphabet);
  body.appendChild(list);
  panel.replaceChildren(body);
}
function updateChamberOverflow(vault) {
  if (!vault || !window.matchMedia('(min-width: 1470px)').matches) return;
  window.requestAnimationFrame(function () {
    var chamber = vault.querySelector('.da-vault__chamber');
    if (!chamber) return;
    // Ignore sub-pixel and animation rounding; only expose the rail when the
    // active channel genuinely needs more vertical room.
    var scrollable = chamber.scrollHeight > chamber.clientHeight + 12;
    chamber.classList.toggle('is-scrollable', scrollable);
    if (!scrollable) chamber.scrollTop = 0;
  });
}
function activate(vault, index, moveFocus) {
  var tabs = Array.prototype.slice.call(vault.querySelectorAll('.da-vault__tab'));
  var stages = Array.prototype.slice.call(vault.querySelectorAll('.da-vault__stage'));
  var safeIndex = Math.max(0, Math.min(index, tabs.length - 1));
  var activeTab = tabs[safeIndex];
  var activeStage = stages[safeIndex];
  var title = activeTab && activeTab.dataset.channelTitle;
  var footerTitle = activeTab && activeTab.dataset.channelFooterTitle || title;
  var count = activeTab && activeTab.dataset.channelCount;
  var description = activeTab && activeTab.dataset.channelDescription;
  var countLabel = activeTab && activeTab.dataset.channelCountLabel || 'DESTINATIONS';
  var mode = activeTab && activeTab.dataset.channelMode || 'LIVE';
  var modeLabel = activeTab && activeTab.dataset.channelModeLabel || 'CHANNEL';
  tabs.forEach(function (tab, tabIndex) {
    var selected = tabIndex === safeIndex;
    tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    tab.tabIndex = selected ? 0 : -1;
  });
  stages.forEach(function (stage, stageIndex) {
    var selected = stageIndex === safeIndex;
    stage.hidden = !selected;
    stage.setAttribute('aria-hidden', selected ? 'false' : 'true');
  });
  var telemetryTitle = vault.querySelector('.da-vault__telemetry-title');
  var telemetryCopy = vault.querySelector('.da-vault__telemetry-copy');
  var telemetryCount = vault.querySelector('.da-vault__telemetry-count');
  var telemetryCountLabel = vault.querySelector('.da-vault__telemetry-count-label');
  var telemetryMode = vault.querySelector('.da-vault__telemetry-mode');
  var telemetryModeLabel = vault.querySelector('.da-vault__telemetry-mode-label');
  var metrics = vault.querySelector('.da-vault__metrics');
  var footerChannel = vault.querySelector('.da-vault__footer-channel');
  if (telemetryTitle) telemetryTitle.textContent = title || 'System channel';
  if (telemetryCopy && description) telemetryCopy.textContent = description;
  if (telemetryCount) telemetryCount.textContent = String(count || 0).padStart(2, '0');
  if (telemetryCountLabel) telemetryCountLabel.textContent = countLabel;
  if (telemetryMode) telemetryMode.textContent = mode;
  if (telemetryModeLabel) telemetryModeLabel.textContent = modeLabel;
  var wrestlingImage = vault.querySelector('.da-vault__wrestling-image');
  if (wrestlingImage) {
    var showWrestlingImage = mode === 'WRESTLING';
    wrestlingImage.parentElement.classList.toggle('da-vault__orb--wrestling', showWrestlingImage);
    if (showWrestlingImage && !wrestlingImage.hasAttribute('src')) {
      wrestlingImage.src = wrestlingImage.dataset.src;
    }
  }
  var collectionImage = vault.querySelector('.da-vault__collection-image');
  if (collectionImage) {
    var imageFile = DISPLAY_COLLECTION_IMAGES[displayRailKey(title)];
    collectionImage.parentElement.classList.toggle('da-vault__orb--collection', !!imageFile);
    if (imageFile) {
      var imageSrc = 'https://displayarmour.co.uk/cdn/shop/files/' + imageFile + '?width=360';
      if (collectionImage.getAttribute('src') !== imageSrc) collectionImage.src = imageSrc;
    }
  }
  if (metrics) {
    metrics.classList.remove('is-updating');
    void metrics.offsetWidth;
    metrics.classList.add('is-updating');
  }
  if (footerChannel) footerChannel.textContent = footerTitle || 'System channel';
  vault.classList.toggle('is-directory-active', !!(activeStage && activeStage.classList.contains('da-vault__stage--directory')));
  if (activeStage && activeStage.classList.contains('da-vault__stage--technology')) {
    activeStage.classList.remove('is-activating');
    void activeStage.offsetWidth;
    activeStage.classList.add('is-activating');
  }
  vault.dataset.activeChannel = String(safeIndex + 1).padStart(2, '0');
  if (moveFocus && activeTab) activeTab.focus();
  updateChamberOverflow(vault);
  var activePanel = vault.closest('.da-vault-panel');
  if (activePanel && activePanel.dataset.daVaultLabel === 'displays') {
    window.requestAnimationFrame(function () { positionPanel(activePanel); });
  }
}
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
function positionPanel(panel) {
  if (!panel || !panel.parentElement || !window.matchMedia('(min-width: 1470px)').matches) return;
  var viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  var panelLabel = panel.dataset.daVaultLabel || '';
  var directoryScroll = panel.querySelector('.da-vault__directory-scroll');
  var directoryScrollTop = directoryScroll ? directoryScroll.scrollTop : 0;
  var header = document.querySelector('.header-wrapper') || document.querySelector('.header');
  var headerBox = header && header.getBoundingClientRect();
  var targetTop = Math.max(8, Math.round(headerBox ? headerBox.bottom : panel.parentElement.getBoundingClientRect().bottom));
  var gutter = viewportWidth <= 1366 ? 10 : viewportWidth <= 1600 ? 14 : 18;
  var panelWidthCap = panelLabel === 'display technology' ? 1040 : (panelLabel === 'about' || panelLabel === 'support') ? 900 : 1320;
  var panelHeightCap = panelLabel === 'display technology'
    ? 470
    : (panelLabel === 'about' || panelLabel === 'support')
      ? 460
      : (panelLabel === 'collector hub' || panelLabel === 'shop by brand')
        ? 650
        : panelLabel === 'displays'
          ? Math.max(920, viewportHeight - targetTop - 10)
          : Math.max(760, viewportHeight - targetTop - 10);
  var targetWidth = Math.min(panelWidthCap, Math.max(320, viewportWidth - (gutter * 2)));
  var centeredLeft = (viewportWidth - targetWidth) / 2;
  var targetLeft = clamp(centeredLeft, gutter, viewportWidth - gutter - targetWidth);
  var root = panel.offsetParent;
  var rootIsDocument = !root || root === document.body || root === document.documentElement;
  var rootBox = rootIsDocument
    ? { left: 0, top: 0, width: viewportWidth, height: viewportHeight }
    : root.getBoundingClientRect();
  var scaleX = rootIsDocument ? 1 : (rootBox.width && root.offsetWidth ? rootBox.width / root.offsetWidth : 1);
  var scaleY = rootIsDocument ? 1 : (rootBox.height && root.offsetHeight ? rootBox.height / root.offsetHeight : 1);
  var scrollLeft = rootIsDocument ? (window.pageXOffset || document.documentElement.scrollLeft || 0) : (root.scrollLeft || 0);
  var scrollTop = rootIsDocument ? (window.pageYOffset || document.documentElement.scrollTop || 0) : (root.scrollTop || 0);
  var localLeft = ((targetLeft - rootBox.left) / scaleX) + scrollLeft;
  var localTop = ((targetTop - rootBox.top) / scaleY) + scrollTop;
  var availableHeight = Math.max(1, Math.min(panelHeightCap, viewportHeight - targetTop - 10));
  panel.style.setProperty('--davo-left', localLeft + 'px');
  panel.style.setProperty('--davo-top', localTop + 'px');
  panel.style.setProperty('--davo-width', (targetWidth / scaleX) + 'px');
  panel.style.setProperty('--davo-height', (availableHeight / scaleY) + 'px');
  panel.style.setProperty('top', localTop + 'px', 'important');
  panel.style.setProperty('left', localLeft + 'px', 'important');
  panel.style.setProperty('right', 'auto', 'important');
  panel.style.setProperty('width', (targetWidth / scaleX) + 'px', 'important');
  panel.style.setProperty('min-width', '0', 'important');
  panel.style.setProperty('max-width', 'none', 'important');
  panel.style.setProperty('height', (availableHeight / scaleY) + 'px', 'important');
  panel.style.setProperty('min-height', Math.min(470, availableHeight / scaleY) + 'px', 'important');
  panel.style.setProperty('max-height', 'none', 'important');
  if (panelLabel === 'displays') {
    var vault = panel.querySelector('.da-vault');
    var rail = panel.querySelector('.da-vault__rail');
    var chamber = panel.querySelector('.da-vault__chamber');
    var footer = panel.querySelector('.da-vault__footer');
    var activeStage = chamber && chamber.querySelector('.da-vault__stage:not([hidden])');
    var lastTab = rail && rail.querySelector('.da-vault__tab:last-child');
    var panelBox = panel.getBoundingClientRect();
    var renderedScale = panel.offsetHeight ? panelBox.height / panel.offsetHeight : 0;
    if (lastTab && renderedScale > 0) {
      // Fit both the navigation rail and the active centre channel. Classic
      // gained another row, so sizing from the rail alone can clip its last
      // destinations even when the viewport has room for a taller panel.
      var contentBottom = (lastTab.getBoundingClientRect().bottom - panelBox.top) / renderedScale + rail.scrollTop;
      var requiredHeight = contentBottom + 48;
      if (activeStage && !activeStage.classList.contains('da-vault__stage--directory')) {
        var chamberBox = chamber.getBoundingClientRect();
        var chamberStyle = window.getComputedStyle(chamber);
        var chamberTop = (chamberBox.top - panelBox.top) / renderedScale;
        var paddingTop = parseFloat(chamberStyle.paddingTop) || 0;
        var paddingBottom = parseFloat(chamberStyle.paddingBottom) || 0;
        var footerHeight = footer ? footer.offsetHeight : 32;
        requiredHeight = Math.max(
          requiredHeight,
          chamberTop + paddingTop + activeStage.offsetHeight + paddingBottom + footerHeight + 2
        );
      }
      var fittedHeight = Math.min(availableHeight / scaleY, Math.ceil(requiredHeight));
      panel.style.setProperty('--davo-height', fittedHeight + 'px');
      panel.style.setProperty('height', fittedHeight + 'px', 'important');
      panel.style.setProperty('min-height', Math.min(470, fittedHeight) + 'px', 'important');
    }
  }
  // Resizing the isolated panel can make WebKit reset a nested overflow box.
  // Preserve the A-Z directory position whenever a harmless re-measure occurs.
  if (directoryScroll && directoryScrollTop > 0) {
    directoryScroll.scrollTop = Math.min(
      directoryScrollTop,
      Math.max(0, directoryScroll.scrollHeight - directoryScroll.clientHeight)
    );
  }
  updateChamberOverflow(vault || panel.querySelector('.da-vault'));
}

/*
 * Displays is converted into an isolated Vault panel, so it no longer inherits
 * the menu app's normal trigger-to-panel hover hand-off. Keep it open briefly
 * while the pointer crosses that small visual gap, then close normally.
 */
function bindDisplaysHoverHandoff(item, panel) {
  if (!item || !panel || item.dataset.daDisplaysHoverHandoffReady === 'true') return;

  var target = directTarget(item);
  var closeTimer = null;
  var closeDelay = 360;

  function cancelClose() {
    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = null;
  }

  function setOpen(open) {
    cancelClose();
    item.classList.toggle('da-tech-menu-open', open);
    if (target) target.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) positionPanel(panel);
  }

  function queueClose() {
    cancelClose();
    closeTimer = window.setTimeout(function () {
      if (item.matches(':hover') || panel.matches(':hover') || item.contains(document.activeElement)) return;
      setOpen(false);
    }, closeDelay);
  }

  item.addEventListener('mouseenter', function () { setOpen(true); });
  item.addEventListener('mouseleave', queueClose);
  panel.addEventListener('mouseenter', function () { setOpen(true); });
  panel.addEventListener('mouseleave', queueClose);

  item.dataset.daDisplaysHoverHandoffReady = 'true';
}

function buildTechnologyVaultChannels(vault, group, rail, chamber, vaultId, channelPrefix, fallbackCopy) {
  var links = linksFor(group);
  links.forEach(function (sourceLink, technologyIndex) {
    var sourceLabel = clean((sourceLink.querySelector('.gm-text, .gm-label') || sourceLink).textContent);
    var feature = technologyFeatureFor(sourceLabel);
    var tabId = vaultId + '-tab-' + technologyIndex;
    var stageId = vaultId + '-stage-' + technologyIndex;
    var tab = node('button', 'da-vault__tab da-vault__tab--technology');
    var tabIcon = node('span', 'da-vault__tech-index-icon');
    var tabText = node('span', 'da-vault__tab-label', feature.name);
    var signal = node('span', 'da-vault__tab-signal');
    var stage = node('section', 'da-vault__stage da-vault__stage--technology');
    var stageHeader = node('header', 'da-vault__stage-header');
    var stageLabel = TECHNOLOGY_STAGE_LABELS[key(feature.name)]
      || channelPrefix + ' ' + String(technologyIndex + 1).padStart(2, '0');
    var stageKicker = node('span', 'da-vault__stage-kicker', stageLabel);
    var featurePanel = node('div', 'da-vault__tech-feature');
    var visual = node('div', 'da-vault__tech-visual');
    var content = node('div', 'da-vault__tech-content');
    var featureTitle = node('h3', 'da-vault__stage-title', feature.name);
    var description = node('p', 'da-vault__tech-description', feature.description || fallbackCopy);
    var explore = node('a', 'da-vault__tech-explore', 'EXPLORE ' + feature.name.toLocaleUpperCase('en-GB') + ' →');
    tab.type = 'button';
    tab.id = tabId;
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', stageId);
    tab.setAttribute('aria-selected', technologyIndex === 0 ? 'true' : 'false');
    tab.tabIndex = technologyIndex === 0 ? 0 : -1;
    tab.dataset.channelTitle = feature.name;
    tab.dataset.channelCount = '1';
    tab.dataset.channelDescription = feature.description || fallbackCopy;
    tabIcon.setAttribute('aria-hidden', 'true');
    tabIcon.innerHTML = technologySvg(feature.icon);
    tab.appendChild(tabIcon);
    tab.appendChild(tabText);
    tab.appendChild(signal);
    stage.id = stageId;
    stage.setAttribute('role', 'tabpanel');
    stage.setAttribute('aria-labelledby', tabId);
    stage.setAttribute('aria-hidden', technologyIndex === 0 ? 'false' : 'true');
    stage.hidden = technologyIndex !== 0;
    stageHeader.appendChild(stageKicker);
    visual.setAttribute('aria-hidden', 'true');
    visual.innerHTML = technologySvg(feature.icon);
    explore.setAttribute('href', sourceLink.getAttribute('href'));
    explore.setAttribute('aria-label', 'Explore ' + feature.name);
    if (sourceLink.getAttribute('target')) explore.setAttribute('target', sourceLink.getAttribute('target'));
    if (sourceLink.getAttribute('rel')) explore.setAttribute('rel', sourceLink.getAttribute('rel'));
    content.appendChild(featureTitle);
    content.appendChild(description);
    content.appendChild(explore);
    featurePanel.appendChild(visual);
    featurePanel.appendChild(content);
    stage.appendChild(stageHeader);
    stage.appendChild(featurePanel);
    rail.appendChild(tab);
    chamber.appendChild(stage);
    tab.addEventListener('click', function () { activate(vault, technologyIndex, false); });
    tab.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'touch') activate(vault, technologyIndex, false);
    });
  });
}
function buildVault(item, panel, label, isMobile) {
  if (!panel || panel.dataset.daVaultReady === 'true') return;
  var groups = groupsFor(panel);
  if (!groups.length) return;
  panel.dataset.daVaultReady = 'true';
  panel.classList.add('da-vault-panel');
  var vault = node('div', 'da-vault');
  var masthead = node('div', 'da-vault__masthead');
  var identity = node('div', 'da-vault__identity');
  var mark = node('span', 'da-vault__identity-mark');
  var identityCopy = node('span', 'da-vault__identity-copy');
  var eyebrow = node('span', 'da-vault__eyebrow', 'DISPLAY ARMOUR /');
  var title = node('strong', 'da-vault__title', label);
  var status = node('div', 'da-vault__status');
  var body = node('div', 'da-vault__body');
  var rail = node('div', 'da-vault__rail');
  var railIndex = node('div', 'da-vault__rail-index', 'DISPLAY INDEX');
  var railScrollHint = node('span', 'da-vault__rail-scroll-hint', 'SCROLL ↓');
  var chamber = node('div', 'da-vault__chamber');
  var telemetry = node('aside', 'da-vault__telemetry');
  var footer = node('div', 'da-vault__footer');
  var labelKey = key(label);
  if (labelKey === 'display systems' || labelKey === 'display armour' || labelKey === 'technology') {
    labelKey = 'display technology';
  }
  var desktopDisplayRail = !isMobile && labelKey === 'displays';
  if (!isMobile && labelKey === 'displays') {
    panel.classList.remove('gm-submenu', 'gm-mega');
    panel.classList.add('da-vault-panel--isolated');
  }
  if (labelKey === 'displays') groups = orderedDisplayGroups(groups);
  railIndex.textContent = desktopDisplayRail
    ? 'BROWSE'
    : (INDEX_LABELS[labelKey] || 'DISPLAY INDEX');
  if (desktopDisplayRail) {
    railIndex.classList.add('da-vault__rail-group-label', 'da-vault__rail-group-label--browse');
    railIndex.setAttribute('role', 'heading');
    railIndex.setAttribute('aria-level', '3');
  }
  var copy = CHANNEL_COPY[labelKey] || ['Navigation system', 'Access protected destinations within the Display Armour network.'];
  var statusCode = STATUS_CODES[labelKey] || 'DA / ARMOURY';
  var activeLabel = ACTIVE_LABELS[labelKey] || 'ACTIVE CHANNEL';
  var channelPrefix = CHANNEL_PREFIXES[labelKey] || 'PROTECTION CHANNEL';
  var vaultId = 'DAVault-' + Math.random().toString(36).slice(2, 9);
  var displayDirectoryEntries = labelKey === 'displays' && !isMobile
    ? directoryEntriesFor(groups)
    : [];
  mark.setAttribute('aria-hidden', 'true');
  mark.innerHTML =
    '<svg class="da-vault__identity-shield" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
      '<path d="M12 2.5 20 5.7v6.6c0 5.15-3.1 8.85-8 11.2-4.9-2.35-8-6.05-8-11.2V5.7L12 2.5Z" stroke="currentColor" stroke-width="1.45" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>' +
      '<path d="m12 9.4 2.2 2.2-2.2 2.2-2.2-2.2L12 9.4Z" fill="currentColor"/>' +
    '</svg>';
  identityCopy.appendChild(eyebrow);
  identityCopy.appendChild(title);
  identity.appendChild(mark);
  identity.appendChild(identityCopy);
  status.innerHTML = '<span class="da-vault__status-live">GRID ONLINE</span><span>' + statusCode + '</span>';
  masthead.appendChild(identity);
  masthead.appendChild(status);
  rail.setAttribute('role', 'tablist');
  rail.setAttribute('aria-label', label + ' channels');
  railScrollHint.setAttribute('aria-hidden', 'true');
  rail.appendChild(railIndex);
  if (labelKey === 'display technology' && !isMobile && groups[0]) {
    buildTechnologyVaultChannels(vault, groups[0], rail, chamber, vaultId, channelPrefix, copy[1]);
  } else {
    var browseDisplayNumber = 0;
    var actionDisplayNumber = 0;
    var collectibleDisplayNumber = 0;
    groups.forEach(function (group, groupIndex) {
    var channelIndex = labelKey === 'displays' && groupIndex >= 1 ? groupIndex + 1 : groupIndex;
    var groupTitle = labelKey === 'displays'
      ? displayChannelTitle(headingFor(group))
      : headingFor(group);
    var railGroup = desktopDisplayRail ? displayRailGroup(groupTitle) : '';
    if (railGroup === 'action' && actionDisplayNumber === 0) {
      var actionRailHeading = node(
        'div',
        'da-vault__rail-index da-vault__rail-group-label da-vault__rail-group-label--action',
        'ACTION FIGURE DISPLAYS'
      );
      actionRailHeading.setAttribute('role', 'heading');
      actionRailHeading.setAttribute('aria-level', '3');
      rail.appendChild(actionRailHeading);
    }
    if (railGroup === 'collectible' && collectibleDisplayNumber === 0) {
      var collectibleRailHeading = node(
        'div',
        'da-vault__rail-index da-vault__rail-group-label da-vault__rail-group-label--collectible',
        'COLLECTIBLE DISPLAYS'
      );
      collectibleRailHeading.setAttribute('role', 'heading');
      collectibleRailHeading.setAttribute('aria-level', '3');
      rail.appendChild(collectibleRailHeading);
    }
    var visibleChannelNumber = channelIndex + 1;
    if (desktopDisplayRail) {
      if (railGroup === 'browse') {
        browseDisplayNumber += 1;
        visibleChannelNumber = browseDisplayNumber;
      } else if (railGroup === 'collectible') {
        collectibleDisplayNumber += 1;
        visibleChannelNumber = collectibleDisplayNumber;
      } else {
        actionDisplayNumber += 1;
        visibleChannelNumber = actionDisplayNumber;
      }
    }
    var links = linksFor(group);
    var linkGrid = group.querySelector(':scope > .gm-links');
    var tabId = vaultId + '-tab-' + channelIndex;
    var stageId = vaultId + '-stage-' + channelIndex;
    var tab = node('button', 'da-vault__tab');
    var railIconName = !isMobile ? vaultRailIconName(labelKey, groupTitle) : '';
    var number = desktopDisplayRail
      ? displaySystemIconNode(displayRailIconName(groupTitle), 'da-vault__tab-icon')
      : railIconName
        ? displaySystemIconNode(railIconName, 'da-vault__tab-icon')
        : node('span', 'da-vault__tab-number', String(visibleChannelNumber).padStart(2, '0'));
    var tabText = node(
      'span',
      'da-vault__tab-label',
      labelKey === 'displays' ? displayRailLabel(groupTitle) : groupTitle
    );
    var signal = node('span', 'da-vault__tab-signal');
    var stage = node('section', 'da-vault__stage');
    var stageHeader = node('header', 'da-vault__stage-header');
    var stageLabel = desktopDisplayRail && DISPLAY_STAGE_LABELS[displayRailKey(groupTitle)]
      || !isMobile && labelKey === 'collector hub' && COLLECTOR_HUB_STAGE_LABELS[key(groupTitle)]
      || channelPrefix + ' ' + String(channelIndex + 1).padStart(2, '0');
    var stageKicker = node('span', 'da-vault__stage-kicker', stageLabel);
    var stageTitle = node('h3', 'da-vault__stage-title', groupTitle);
    if (labelKey === 'displays' && !isMobile) addDisplayStageTitleLink(stageTitle, groupTitle);
    if (!isMobile && linkGrid) {
      group.style.setProperty('display', 'block', 'important');
      group.style.setProperty('position', 'relative', 'important');
      group.style.setProperty('inset', 'auto', 'important');
      group.style.setProperty('grid-column', '1 / -1', 'important');
      group.style.setProperty('width', '100%', 'important');
      group.style.setProperty('min-width', '0', 'important');
      group.style.setProperty('max-width', 'none', 'important');
      group.style.setProperty('flex', '0 0 100%', 'important');
      linkGrid.style.setProperty('display', 'grid', 'important');
      linkGrid.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
      linkGrid.style.setProperty('gap', '2px 34px', 'important');
      linkGrid.style.setProperty('width', '100%', 'important');
      linkGrid.style.setProperty('min-width', '0', 'important');
      linkGrid.style.setProperty('max-width', 'none', 'important');
      linkGrid.style.setProperty('box-sizing', 'border-box', 'important');
      links.forEach(function (link) {
        var isGlobalDestination = Boolean(link.closest('.da-shop-by-type-global'));
        link.style.setProperty('width', '100%', 'important');
        link.style.setProperty('max-width', 'none', 'important');
        link.style.setProperty('overflow', 'visible', 'important');
        if (link.parentElement) {
          link.parentElement.style.setProperty('width', 'auto', 'important');
          link.parentElement.style.setProperty('min-width', '0', 'important');
          link.parentElement.style.setProperty('max-width', 'none', 'important');
          link.parentElement.style.setProperty('position', 'relative', 'important');
          link.parentElement.style.setProperty('inset', 'auto', 'important');
          link.parentElement.style.setProperty('grid-column', isGlobalDestination ? '1 / -1' : 'auto', 'important');
          link.parentElement.style.setProperty('grid-row', 'auto', 'important');
        }
        var linkText = link.querySelector('.gm-text, .gm-label');
        if (linkText) {
          linkText.style.setProperty('display', 'block', 'important');
          linkText.style.setProperty('width', 'auto', 'important');
          linkText.style.setProperty('max-width', 'none', 'important');
          linkText.style.setProperty('overflow', 'visible', 'important');
          linkText.style.setProperty('text-overflow', 'clip', 'important');
          linkText.style.setProperty('white-space', 'nowrap', 'important');
        }
      });
    }
    tab.type = 'button';
    tab.id = tabId;
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', stageId);
    tab.setAttribute('aria-selected', channelIndex === 0 ? 'true' : 'false');
    tab.tabIndex = channelIndex === 0 ? 0 : -1;
    tab.dataset.channelTitle = groupTitle;
    tab.dataset.channelCount = String(links.length);
    tab.dataset.channelDescription = channelDescriptionFor(labelKey, groupTitle, copy[1]);
    tab.dataset.channelMode = channelModeFor(labelKey, groupTitle);
    tab.dataset.channelModeLabel = 'CHANNEL';
    tab.appendChild(number);
    tab.appendChild(tabText);
    tab.appendChild(signal);
    stage.id = stageId;
    stage.setAttribute('role', 'tabpanel');
    stage.setAttribute('aria-labelledby', tabId);
    stage.setAttribute('aria-hidden', channelIndex === 0 ? 'false' : 'true');
    stage.hidden = channelIndex !== 0;
    stageHeader.appendChild(stageKicker);
    stageHeader.appendChild(stageTitle);
    stage.appendChild(stageHeader);
    links.forEach(function (link, linkIndex) {
      var isShopByTypeGlobal = Boolean(link.closest('.da-shop-by-type-global'));
      if (isShopByTypeGlobal) {
        delete link.dataset.davoIndex;
      } else {
        link.dataset.davoIndex = String(linkIndex + 1).padStart(2, '0');
      }
      link.setAttribute('data-davo-channel', String(channelIndex + 1).padStart(2, '0'));
      if (!isMobile && (labelKey === 'about' || labelKey === 'support')) {
        var vaultLinkText = link.querySelector('.gm-text, .gm-label');
        var vaultIconName = vaultDestinationIconName(
          labelKey,
          vaultLinkText ? vaultLinkText.textContent : link.textContent
        );
        if (vaultIconName && !link.querySelector('.da-vault__destination-icon')) {
          delete link.dataset.davoIndex;
          Array.prototype.slice.call(link.classList).forEach(function (className) {
            if (className.indexOf('da-engineered-link') === 0) link.classList.remove(className);
          });
          link.classList.add('da-vault__destination-icon-only');
          link.insertBefore(
            displaySystemIconNode(vaultIconName, 'da-vault__destination-icon'),
            link.firstChild
          );
        }
      }
      if (labelKey === 'displays' && !isMobile) {
        link.classList.add(isShopByTypeGlobal ? 'da-vault__global-destination' : 'da-vault__display-destination');
        if (!isShopByTypeGlobal && !link.querySelector('.da-vault__destination-icon')) {
          delete link.dataset.davoIndex;
          var destinationText = link.querySelector('.gm-text, .gm-label');
          var destinationIcon = displaySystemIconNode(
            displayDestinationIconName(destinationText ? destinationText.textContent : link.textContent, groupTitle),
            'da-vault__destination-icon'
          );
          link.classList.add('da-vault__destination-has-icon');
          link.insertBefore(destinationIcon, link.firstChild);
        }
        if (!link.querySelector('.da-vault__display-arrow')) {
          var displayArrow = node('span', 'da-vault__display-arrow', '↗');
          displayArrow.setAttribute('aria-hidden', 'true');
          link.appendChild(displayArrow);
        }
      }
    });
    if (labelKey === 'displays' && !isMobile) window.DisplayArmourGroupPokemonMenu(group);
    stage.appendChild(group);
    rail.appendChild(tab);
    chamber.appendChild(stage);
    tab.addEventListener('click', function () { activate(vault, channelIndex, false); });
    if (!isMobile) {
      tab.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') activate(vault, channelIndex, false);
      });
    }
    if (labelKey === 'displays' && !isMobile && groupIndex === 0 && displayDirectoryEntries.length) {
      buildDisplaysDirectoryChannel(
        vault,
        rail,
        chamber,
        vaultId,
        displayDirectoryEntries,
        1
      );
      browseDisplayNumber += 1;
    }
    });
  }
  telemetry.innerHTML =
    '<div class="da-vault__telemetry-label">' + activeLabel + '</div>' +
    '<div class="da-vault__orb" aria-hidden="true"><span class="da-vault__orb-core"></span></div>' +
    '<div class="da-vault__telemetry-title">System channel</div>' +
    '<p class="da-vault__telemetry-copy">' + copy[1] + '</p>' +
    '<div class="da-vault__metrics">' +
      '<div class="da-vault__metric"><strong class="da-vault__metric-value da-vault__telemetry-count">00</strong><span class="da-vault__metric-label da-vault__telemetry-count-label">DESTINATIONS</span></div>' +
      '<div class="da-vault__metric"><strong class="da-vault__metric-value da-vault__telemetry-mode">LIVE</strong><span class="da-vault__metric-label da-vault__telemetry-mode-label">CHANNEL</span></div>' +
    '</div>';
  if (desktopDisplayRail) {
    var wrestlingImage = node('img', 'da-vault__wrestling-image');
    wrestlingImage.alt = '';
    wrestlingImage.width = 2020;
    wrestlingImage.height = 1350;
    wrestlingImage.decoding = 'async';
    wrestlingImage.dataset.src = 'https://displayarmour.co.uk/cdn/shop/files/wwf-hasbro-wrestling-display-cases-display-armour.png?width=360';
    telemetry.querySelector('.da-vault__orb').appendChild(wrestlingImage);
    var collectionImage = node('img', 'da-vault__collection-image');
    collectionImage.alt = '';
    collectionImage.width = 180;
    collectionImage.height = 138;
    collectionImage.decoding = 'async';
    telemetry.querySelector('.da-vault__orb').appendChild(collectionImage);
  }
  footer.innerHTML =
    '<span>ARMOUR SYSTEM</span>' +
    '<span class="da-vault__footer-line" aria-hidden="true"></span>' +
    '<span class="da-vault__footer-channel">SYSTEM CHANNEL</span>';
  body.appendChild(rail);
  body.appendChild(chamber);
  body.appendChild(telemetry);
  body.appendChild(railScrollHint);
  vault.appendChild(masthead);
  vault.appendChild(body);
  vault.appendChild(footer);
  Array.prototype.slice.call(panel.children).forEach(function (child) {
    if (child !== vault && !child.closest('.da-vault__stage')) {
      child.classList.add('da-vault-source');
      if (!isMobile && labelKey === 'display technology') {
        child.style.setProperty('display', 'none', 'important');
        child.setAttribute('aria-hidden', 'true');
      }
    }
  });
  panel.appendChild(vault);
  if (!isMobile && labelKey === 'displays') {
    bindDisplaysHoverHandoff(item, panel);
  }
  function updateRailScrollHint() {
    var scrollable = !isMobile && rail.scrollHeight > rail.clientHeight + 4;
    var atEnd = rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 4;
    railScrollHint.classList.toggle('is-visible', scrollable && !atEnd);
  }
  rail.addEventListener('scroll', updateRailScrollHint, { passive: true });
  window.addEventListener('resize', function () {
    updateRailScrollHint();
    updateChamberOverflow(vault);
  }, { passive: true });
  rail.addEventListener('keydown', function (event) {
    var tabs = Array.prototype.slice.call(rail.querySelectorAll('.da-vault__tab'));
    var current = tabs.indexOf(document.activeElement);
    var next = current;
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (current + 1) % tabs.length;
    else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    activate(vault, next, true);
  });
  var hostTarget = directTarget(item);
  item.addEventListener('mouseenter', function () {
    positionPanel(panel);
    panel.scrollTop = 0;
    chamber.scrollTop = 0;
    window.requestAnimationFrame(updateRailScrollHint);
  });
  if (hostTarget) {
    hostTarget.addEventListener('focusin', function () {
      positionPanel(panel);
      panel.scrollTop = 0;
      chamber.scrollTop = 0;
      window.requestAnimationFrame(updateRailScrollHint);
    });
    hostTarget.addEventListener('click', function () {
      positionPanel(panel);
      panel.scrollTop = 0;
      chamber.scrollTop = 0;
      window.requestAnimationFrame(updateRailScrollHint);
    });
  }
  if (hostTarget) {
    hostTarget.setAttribute(
      'aria-label',
      (labelKey === 'display technology' ? 'Display Armour' : label) + ' — open navigation system'
    );
  }
  activate(vault, 0, false);
  positionPanel(panel);
  window.requestAnimationFrame(updateRailScrollHint);
}
function scan(scope) {
  document.body.classList.add('da-vault-os');
  (scope || document).querySelectorAll(DESKTOP_MENU).forEach(function (menu) {
    normalisePokemonSpelling(menu);
    restoreDisplaysPokemonSpelling(menu);
    if (window.DisplayArmourHeaderConfig.prepareDesktopTradingCards) {
      window.DisplayArmourHeaderConfig.prepareDesktopTradingCards(menu);
    }
    var mobile = false;
    menuItems(menu).forEach(function (item) {
      var label = itemLabel(item);
      var labelKey = key(label);
      if (labelKey === 'display systems' || labelKey === 'display armour' || labelKey === 'technology') {
        labelKey = 'display technology';
      }
      if (['displays', 'shop by brand', 'display technology', 'collector hub', 'about', 'about us', 'support'].indexOf(labelKey) === -1) return;
      var panel = submenuFor(item, labelKey, mobile);
      if (!panel) return;
      if (labelKey === 'displays') {
        removeDuplicatePokemonTypeLinks(panel);
        ensureDesktopDisplayTaxonomy(panel);
        sortDesktopActionDisplayDestinations(panel);
      }
      if (!mobile && labelKey === 'display technology') {
        panel.classList.remove('da-vault-source');
        panel.removeAttribute('aria-hidden');
        panel.style.removeProperty('display');
        Array.prototype.forEach.call(item.children, function (child) {
          if (child === panel || !child.classList) return;
          if (
            child.classList.contains('gm-submenu') ||
            child.classList.contains('da-tech-native-dropdown')
          ) {
            child.classList.add('da-vault-source');
            child.setAttribute('aria-hidden', 'true');
            child.style.setProperty('display', 'none', 'important');
          }
        });
      }
      panel.dataset.daVaultLabel = labelKey === 'about us' ? 'about' : labelKey;
      if (!mobile) item.classList.add('da-vault-host');
      buildVault(
        item,
        panel,
        labelKey === 'display technology' ? 'Technology' : (labelKey === 'about us' ? 'About' : label),
        mobile
      );
      if (!mobile) positionPanel(panel);
    });
  });
  (scope || document).querySelectorAll(MOBILE_MENU).forEach(function (menu) {
    normalisePokemonSpelling(menu);
    restorePromotedPokemonSpelling(menu);
    restoreCollectiblePokemonSpelling(menu);
    var displaysItem = menuItems(menu).find(function (item) {
      var labelKey = key(itemLabel(item));
      return labelKey === 'shop by collection' || labelKey === 'figure displays';
    });
    removeDuplicatePokemonTypeLinks(submenuFor(displaysItem, 'displays', true));
    buildMobileShopByBrandDirectory(menu);
  });
}
function queueScan() {
  if (observerQueued) return;
  observerQueued = true;
  window.requestAnimationFrame(function () {
    observerQueued = false;
    scan(document);
  });
}
function start() {
  scan(document);
  window.setTimeout(queueScan, 80);
  window.setTimeout(queueScan, 350);
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', queueScan, { passive: true });
  document.addEventListener('shopify:section:load', queueScan);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
})();

class StickyHeader extends HTMLElement {
constructor() {
  super();
}
connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};
  this.setHeaderHeight();
  this.headerResizeObserver = new ResizeObserver(() => {
    this.setHeaderHeight();
    if (Number.isFinite(this.headerBounds.top)) {
      this.headerBounds.bottom = this.headerBounds.top + this.header.offsetHeight;
    }
  });
  this.headerResizeObserver.observe(this.header);
  this.headerBreakpointQuery = window.matchMedia('(max-width: 990px)');
  this.onHeaderBreakpointChange = this.setHeaderHeight.bind(this);
  this.headerBreakpointQuery.addEventListener('change', this.onHeaderBreakpointChange);
  if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
  };
  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');
  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);
  this.createObserver();
}
setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}
disconnectedCallback() {
  this.headerResizeObserver.disconnect();
  this.headerBreakpointQuery.removeEventListener('change', this.onHeaderBreakpointChange);
  window.clearTimeout(this.isScrolling);
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = {top: entries[0].intersectionRect.top, bottom: entries[0].intersectionRect.bottom};
    observer.disconnect();
  });
  observer.observe(this.header);
}
onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);
      requestAnimationFrame(this.hide.bind(this));
    }
  } else if (scrollTop <= this.headerBounds.top) {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
  }
  this.currentScrollTop = scrollTop;
}
hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
}
reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
}
reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}
closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());
}
closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  this.searchModal.close(false);
}
}
if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
// === Display Armour – auto-close desktop mega menu on mouse leave (with delay) ===
function initDesktopNavAutoClose() {
const mq = window.matchMedia('(min-width: 990px)');
const CLOSE_DELAY = 220; // ms – tweak this (150–300) to taste
const bindHandlers = () => {
  if (!mq.matches) return;
  const detailItems = document.querySelectorAll('.header details');
  detailItems.forEach((detailsEl) => {
    if (detailsEl.dataset.daAutoCloseBound === 'true') return;
    detailsEl.dataset.daAutoCloseBound = 'true';
    const dropdown =
      detailsEl.querySelector('.mega-menu__content, .header__submenu') || detailsEl;
    let closeTimeout;
    const closeMenu = () => {
      if (detailsEl.hasAttribute('open')) {
        detailsEl.removeAttribute('open');
        const summary = detailsEl.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    };
    const scheduleClose = () => {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(closeMenu, CLOSE_DELAY);
    };
    const cancelClose = () => {
      clearTimeout(closeTimeout);
    };
    // When you hover back over the menu, cancel closing
    detailsEl.addEventListener('mouseenter', cancelClose);
    dropdown.addEventListener('mouseenter', cancelClose);
    // When you leave the menu area, *schedule* the close
    detailsEl.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('mouseleave', scheduleClose);
  });
};
bindHandlers();
mq.addEventListener('change', bindHandlers);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target && event.target.classList.contains('section-header')) {
    bindHandlers();
  }
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initDesktopNavAutoClose);
} else {
initDesktopNavAutoClose();
}
}